{
  "% к прошлой неделе": "% vs. last week",
  ". STEOS ID и финансовые квитанции сохраняются.": ". STEOS ID and financial receipts are retained.",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": ". Ready voices are available under “Voiceover” → “My”.",
  ". Он не меняет голос озвучки чата.": ". It does not change the chat voiceover voice.",
  ". После подтверждения обновите профиль.": ". Update your profile after confirmation.",
  ". Проверьте папку «Спам».": ". Check your Spam folder.",
  "Circle каждый месяц по подписке": "Circle monthly subscription",
  "Circle по подписке на этот месяц потрачены": "This month’s plan Circle are used up",
  "STEOS ID · {0}": "STEOS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · Not connected",
  "Telegram ID скопирован.": "Telegram ID copied.",
  "{0} {1} C сгорят {2}": "{0} {1} C will expire on {2}",
  "{0} из {1}": "{0} of {1}",
  "{0} фото хватит для сходства": "{0} photos are enough for a likeness",
  "{0}: {1} работ": "{0}: {1} works",
  "{0}: пока недоступно": "{0}: not available yet",
  "· Вы и варианты": "· You and variants",
  "· Новое": "· New",
  "· занято": "· busy",
  "· отменена": "· canceled",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "». Training will begin after you separately tap “Retry processing” on the card.",
  "Автовоспроизведение примеров": "Autoplay examples",
  "Аккаунт": "Account",
  "Аккаунт подключён": "Account connected",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "Archive unavailable or link expired. You can request a new export.",
  "Бабушка": "Grandmother",
  "Баланс и вывод доступны в STEOS ID.": "Balance and withdrawals are available in STEOS ID.",
  "Баланс и награды": "Balance and rewards",
  "Без имени": "Unnamed",
  "Бесплатный план": "Free plan",
  "Ближайшие": "Upcoming",
  "Близкие": "Loved ones",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "This relative will disappear from your profile. Their photos will no longer be available for new works.",
  "Близкий удалён.": "Relative deleted.",
  "Близких пока нет.": "No relatives yet.",
  "Брат": "Brother",
  "В Steos с": "On Steos since",
  "В избранное": "Add to favorites",
  "Валюта": "Currency",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "This variant will be deleted. Original photos and STEOS ID will be retained.",
  "Вариантов: {0}": "Variants: {0}",
  "Варианты": "Variants",
  "Ваш собственный голос": "Your own voice",
  "Введите УДАЛИТЬ": "Enter УДАЛИТЬ",
  "Введите пароль": "Enter password",
  "Введите почту": "Enter email",
  "Вернуться ко входу": "Back to login",
  "Версия": "Version",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "Consent version changed. Refresh the page and confirm the current text.",
  "Версия согласия изменилась. Обновите страницу.": "Consent version changed. Refresh the page.",
  "Версия:": "Version:",
  "Взрослый": "Adult",
  "Включаем микрофон…": "Enabling microphone…",
  "Включено": "Enabled",
  "Возраст": "Age",
  "Войти": "Log in",
  "Восстановить пароль": "Reset password",
  "Все Circle на балансе без срока": "Your Circle never expire",
  "Вы": "You",
  "Вы и близкие": "You and relatives",
  "Вы и варианты": "You & your looks",
  "Выберите голос": "Choose a voice",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "Choose a tool and fill in its form. The finished work will be saved to history.",
  "Выбран": "Selected",
  "Выбрать голос": "Choose voice",
  "Выбрать голос по умолчанию": "Choose default voice",
  "Выбрать из работ": "Choose from works",
  "Выгрузить мои данные": "Export my data",
  "Выгрузка:": "Export:",
  "Выключено": "Disabled",
  "Голос": "Voice",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "Voice ready. Available under the “My” tab in Voiceover.",
  "Голос и клон": "Voice and clone",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "Voice changed. Data updated — check it before saving.",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "Voice changed. Check the updated data before retrying processing.",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "The voice will disappear from your list. This action cannot be undone.",
  "Голос по умолчанию для создания:": "Default voice for creation:",
  "Голос принят в обработку. Здесь появится его статус.": "Voice submitted for processing. Its status will appear here.",
  "Голос уже удалён или недоступен.": "Voice already deleted or unavailable.",
  "Голос:": "Voice:",
  "Голоса не найдены. Откройте каталог или измените поиск.": "No voices found. Open the catalog or change your search.",
  "Горизонтальное": "Landscape",
  "Готов": "Ready",
  "Готовим образцы": "Preparing samples",
  "Готово": "Done",
  "Готовые работы": "Finished works",
  "Далее": "Next",
  "Данные Telegram обновлены.": "Telegram data updated.",
  "Данные баланса временно недоступны": "Balance data temporarily unavailable",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "Data is being transferred to the confirmed account. Old sessions have been closed; the receipt lets you resume verification after reloading.",
  "Дедушка": "Grandfather",
  "До 5 фото: лицо крупно, при хорошем свете": "Up to 5 photos: close-up face, good lighting",
  "До пяти фото. Они будут использоваться как ваш образ.": "Up to five photos. They will be used as your likeness.",
  "Добавить близкого": "Add a loved one",
  "Добавить фото": "Add photo",
  "Добавьте ещё": "Add more",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "Add 2 seconds to 1.5 minutes of your speech. Speak naturally, without music or other voices.",
  "Дочь": "Daughter",
  "Друг": "Friend",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "If the account exists, a password reset link has been sent to",
  "Ещё варианты": "More variants",
  "Ещё операции": "More transactions",
  "Ещё работы": "More works",
  "Жена": "Wife",
  "ЗАМЕНА ОБРАЗЦОВ": "REPLACE SAMPLES",
  "Забыли пароль?": "Forgot password?",
  "Загружаем аккаунт…": "Loading account…",
  "Загружаем варианты…": "Loading variants…",
  "Загружаем ваши голоса…": "Loading your voices…",
  "Загружаем голоса…": "Loading voices…",
  "Загружаем настройки…": "Loading settings…",
  "Загружаем обновления…": "Loading updates…",
  "Загружаем операции…": "Loading transactions…",
  "Загружаем пример…": "Loading example…",
  "Загружаем работы…": "Loading works…",
  "Загружаем фото…": "Loading photos…",
  "Загрузить аудиофайлы": "Upload audio files",
  "Загрузить выбранные фото": "Upload selected photos",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "Upload not yet confirmed. Tap “Continue upload” to check the previous upload first.",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "Upload not confirmed. Continuing will first check previous uploads.",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "Upload rejected. Tap “Continue upload” to get a new link and upload the sample.",
  "Закрыть": "Close",
  "Закрыть мастер": "Close wizard",
  "Заменить образцы": "Replace samples",
  "Записать с микрофона": "Record with microphone",
  "Запись": "Recording",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "Recording is unavailable here. Open the app over HTTPS or upload an audio file.",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "Recording was interrupted. Try again or upload a file.",
  "Запись-{0}.{1}": "Recording-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "Record a sample, wait for training, and voice text in your own voice.",
  "Запишите речь или загрузите аудиофайлы": "Record speech or upload audio files",
  "Запишите свой голос один раз — используйте его в озвучке.": "Record your voice once and use it for voiceovers.",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "Request saved. Continuing will check the previous request and won't create a second voice.",
  "Запустить обработку": "Start processing",
  "Здесь появятся ваши работы": "Your works will appear here",
  "Из них": "Of these",
  "Из них {0} C можно вывести": "Of these, {0} C can be withdrawn",
  "Избранное": "Favorites",
  "Избранные работы": "Favorite works",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "Change not confirmed. Check the current card before trying again.",
  "Изменить": "Edit",
  "Изменить близкого": "Edit relative",
  "Изменить вариант": "Edit variant",
  "Изменить голос": "Change voice",
  "Изменить мои фото": "Edit my photos",
  "Имя близкого": "Relative's name",
  "Имя голоса": "Voice name",
  "Имя пользователя не задано": "Username not set",
  "Использовать как себя": "Use as me",
  "Используем сохранённые образцы голоса «": "Using saved voice samples for “",
  "Используйте свои фото и фото близких в инструментах студии.": "Use your photos and your relatives' photos in studio tools.",
  "История очищена: {0} работ, {1} заказов.": "History cleared: {0} works, {1} orders.",
  "КЛОН ГОЛОСА": "VOICE CLONE",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "Each sample must contain at least one second of speech.",
  "Как в системе": "As in system",
  "Как пользоваться": "How to use",
  "Как снимать": "How to take photos",
  "Каталог голосов": "Voice catalog",
  "Квадрат": "Square",
  "Кем приходится": "Relationship",
  "Ко входу": "Back to login",
  "Количество вариантов пока недоступно": "Number of variants currently unavailable",
  "Конфиденциальность": "Privacy",
  "Копирование недоступно. ID показан в карточке аккаунта.": "Copying unavailable. The ID is shown on the account card.",
  "Кружок с героем": "Video message with a character",
  "Лимит {0} голосов выбран": "Limit of {0} voices reached",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "Voice limit reached. Delete an unwanted voice to add a new one.",
  "Лимит:": "Limit:",
  "Мама": "Mom",
  "Можно добавить до {0} образцов.": "You can add up to {0} samples.",
  "Можно закрыть приложение. Статус обновится после обработки.": "You can close the app. The status will update after processing.",
  "Мои варианты": "My variants",
  "Мои голоса": "My voices",
  "Мои данные": "My data",
  "Мои фото": "My photos",
  "Моё": "Mine",
  "Моё фото": "My photo",
  "Муж": "Husband",
  "НОВЫЙ ГОЛОС": "NEW VOICE",
  "Награды": "Rewards",
  "Награды и задания": "Rewards and tasks",
  "Назад": "Back",
  "Название варианта": "Variant name",
  "Назначить голос": "Assign voice",
  "Настройки": "Settings",
  "Настройки уже изменились. Показана актуальная версия.": "Settings have already changed. The current version is shown.",
  "Начните с 2 секунд речи в тихом месте.": "Start with 2 seconds of speech in a quiet place.",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "Up to 5 JPEG or PNG photos, up to 10 MB each.",
  "Не задано": "Not set",
  "Не короче 8 знаков": "At least 8 characters",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "Could not enable the microphone. Allow access or upload a file.",
  "Не удалось войти. Откройте приложение из Telegram заново.": "Could not log in. Reopen the app from Telegram.",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "Could not play example. Reopen the card and try again.",
  "Не удалось загрузить варианты.": "Could not load variants.",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "Could not load voices. Change your search or tab to retry.",
  "Не удалось загрузить настройки. Попробуйте обновить.": "Could not load settings. Try refreshing.",
  "Не удалось загрузить работы.": "Could not load works.",
  "Не удалось загрузить следующую страницу.": "Could not load the next page.",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "Could not load the next page. Try again.",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "Could not update data from Telegram. Try again later.",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "Could not confirm favorite change. Refresh your profile.",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "Could not confirm transaction. Check your account status before retrying.",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "Could not confirm save. Refresh settings before retrying.",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "Could not confirm relative deletion. Refresh your profile.",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "Could not get a response. Try again — the request will continue with the same key.",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "Could not verify export. Refresh the page to continue the previous operation.",
  "Не удалось прочитать запись.": "Could not read the recording.",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "Could not create voice. Open the card to check its status or retry processing.",
  "Не удалось создать голос. Проверьте данные и образцы.": "Could not create voice. Check the data and samples.",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "Could not save view. You can close this and return later.",
  "Неверная почта или пароль": "Incorrect email or password",
  "Нет работ": "No works",
  "Новая выгрузка": "New export",
  "Новости": "News",
  "Новый вариант": "New variant",
  "Новый голос": "New voice",
  "Новых публикаций пока нет.": "No new posts yet.",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "A total of 2 seconds to 1.5 minutes of speech is required.",
  "О приложении": "About the app",
  "Обновить": "Refresh",
  "Обновить варианты": "Refresh variants",
  "Обновить из Telegram": "Update from Telegram",
  "Обновить настройки": "Refresh settings",
  "Обновить профиль": "Refresh profile",
  "Обновить работы": "Refresh works",
  "Обновления": "Updates",
  "Обновляем вход…": "Refreshing login…",
  "Обрабатывается": "Processing",
  "Образ готов": "Likeness ready",
  "Образ ещё не собран": "Likeness not created yet",
  "Образец {0}": "Sample {0}",
  "Образец голоса": "Voice sample",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "Sample not checked yet. Wait and continue uploading.",
  "Образец не прошёл проверку. Выберите другую запись.": "Sample failed validation. Choose another recording.",
  "Образцы готовы к повторной обработке.": "Samples ready for reprocessing.",
  "Образцы для «": "Samples for “",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "Samples updated. Tap “Retry processing” to retrain the voice.",
  "Обучаем голос": "Training voice",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "Total sample duration must not exceed 1.5 minutes.",
  "Объединение STEOS ID": "Merge STEOS ID",
  "Объединяем аккаунты": "Merging accounts",
  "Объём образцов": "Sample duration",
  "Один аккаунт для бота и сайта STEOS": "One account for the STEOS bot and website",
  "Озвучить текст голосом «": "Voice text with “",
  "Операции": "Transactions",
  "Операции в токенах STEOS ID": "Transactions in STEOS ID tokens",
  "Операции временно недоступны.": "Transactions temporarily unavailable.",
  "Операций пока нет.": "No transactions yet.",
  "Операция не подтверждена. Повтор использует прежний ключ.": "Transaction not confirmed. Retrying will use the same key.",
  "Описание": "Description",
  "Описание и согласие": "Description and consent",
  "Остановить запись ·": "Stop recording ·",
  "Остаток Circle недоступен": "Circle balance unavailable",
  "Отклик": "Haptic feedback",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "Open the link in the email and set a new password at id.steos.io. Then log in here.",
  "Откройте ссылку подтверждения для": "Open the confirmation link for",
  "Открыть id.steos.io": "Open id.steos.io",
  "Открыть историю": "Open history",
  "Отмена": "Cancel",
  "Отметьте согласие с условиями": "Check the consent box",
  "Отправить ссылку": "Send link",
  "Отправляем…": "Sending…",
  "Оформить подписку": "Subscribe",
  "Оформление": "Appearance",
  "Очистить историю": "Clear history",
  "Очистить историю?": "Clear history?",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "Clear not confirmed. Retrying will check the previous operation.",
  "Очищаем…": "Clearing…",
  "Ошибка": "Error",
  "Папа": "Dad",
  "Пароль": "Password",
  "Переименовать вариант": "Rename variant",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "Transfer not yet confirmed. Receipt saved; verification will continue.",
  "Перенос завершён, обновляем вход…": "Transfer complete, refreshing login…",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "Transferring data to the existing STEOS ID. The app will refresh the session after the transfer. Do not start the merge again.",
  "Письмо отправлено": "Email sent",
  "Питомец": "Pet",
  "Повторить загрузку": "Retry loading",
  "Повторить обработку": "Retry processing",
  "Подготовить ZIP для скачивания": "Prepare ZIP for download",
  "Поддержка": "Support",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "Connecting STEOS ID is currently unavailable. Try again later or open the STEOS ID website.",
  "Подключён": "Connected",
  "Подключён:": "Connected:",
  "Подруга": "Female friend",
  "Подтвердите почту": "Confirm your email",
  "Подтвердите согласие перед отправкой образцов.": "Confirm consent before submitting samples.",
  "Подтвердить очистку истории": "Confirm history clearing",
  "Подтвердить удаление": "Confirm deletion",
  "Подтвердить удаление аккаунта": "Confirm account deletion",
  "Подтвердить удаление близкого": "Confirm relative deletion",
  "Подтвердить удаление варианта": "Confirm variant deletion",
  "Поиск голоса": "Search voices",
  "Поиск по имени": "Search by name",
  "Пока нет своих голосов": "No custom voices yet",
  "Показать ещё": "Show more",
  "Показать ещё голоса": "Show more voices",
  "Показать пароль": "Show password",
  "Пополнить": "Top up",
  "Попробовать": "Try it",
  "Портрет": "Portrait",
  "Пост": "Post",
  "Потрачено Circle:": "Circle spent:",
  "Почта": "Email",
  "Почта уже занята": "Email already in use",
  "Почта уже занята, войдите с ней": "Email already in use. Log in with it.",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "Hi! This is a recording for my voice. I'm speaking calmly and at a normal pace, as if talking to a friend. I'll tell you how my day went, what made me happy, and what my plans are for tomorrow. Keep speaking in your own words for at least thirty seconds.",
  "Приглашайте друзей": "Invite friends",
  "Пример голоса {0}": "Voice example {0}",
  "Принимаю": "Accepting",
  "Присылать готовые работы в чат": "Send finished works to chat",
  "Проверен": "Verified",
  "Проверить выгрузку": "Verify export",
  "Проверить подтверждение": "Verify confirmation",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "Voice check failed. Record a sample without music or other people.",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "Sample check failed. Try a clean recording of a single voice.",
  "Проверьте адрес": "Check the address",
  "Проверяем запись": "Checking recording",
  "Проверяем образец {0} из {1}…": "Checking sample {0} of {1}…",
  "Проверяем состояние переноса…": "Checking transfer status…",
  "Проверяем…": "Checking…",
  "Проверяйте остаток в профиле и получайте доступные награды.": "Check your balance in your profile and claim available rewards.",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "We'll continue checking the previous request without starting it again.",
  "Продолжим сохранённый запрос с теми же данными.": "We'll continue the saved request with the same data.",
  "Продолжить отправку": "Continue upload",
  "Продолжить проверку": "Continue verification",
  "Продолжить создание голоса": "Continue voice creation",
  "Продолжить сохранение": "Continue saving",
  "Прослушать {0}": "Listen to {0}",
  "Профиль": "Profile",
  "Профиль «Вы» пока недоступен.": "The “You” profile is currently unavailable.",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "The profile has already changed. Close the form and open the current version.",
  "Работ в этом списке пока нет.": "No works in this list yet.",
  "Работа №": "Work No.",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "Works and order settings will disappear from history. Voices, “You” variants, and relatives will remain. Financial receipts are retained. History cannot be restored.",
  "Работы по неделям": "Works by week",
  "Раздел профиля": "Profile section",
  "Разделы профиля": "Profile sections",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "Each sample must be between 1 byte and 20 MB.",
  "Ребёнок": "Child",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "Processing result is being determined. Retrying is not available yet.",
  "Русский": "Русский",
  "С": "From",
  "Сбросить голос по умолчанию": "Reset default voice",
  "Светлая": "Light",
  "Свой аватар": "Custom avatar",
  "Сгорят {0}, если не потратить": "Expire on {0} unless spent",
  "Сделать кружок": "Make a video message",
  "Серия:": "Series:",
  "Сестра": "Sister",
  "Скачать ZIP": "Download ZIP",
  "Скопировать Telegram ID": "Copy Telegram ID",
  "Скорость речи": "Speech speed",
  "Скрыть пароль": "Hide password",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "Too many requests. Wait a moment and try again.",
  "Слишком много попыток. Попробуйте позже.": "Too many attempts. Try again later.",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "Take photos without filters or dark glasses, in even lighting. Include different angles. Only one person should be in the frame.",
  "Снять голос": "Record voice",
  "Снять фото": "Take photo",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "Consent changed before training started. Refresh the page and confirm the current version before retrying processing.",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "Create talking video messages with a character or your own look.",
  "Создание": "Creation",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "Voice creation is temporarily unavailable. Samples are saved in this window.",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "Creating new voices is currently unavailable. Previously created voices are available below.",
  "Создано:": "Created:",
  "Создан {0}": "Created {0}",
  "Создать аккаунт": "Create account",
  "Создать голос": "Create voice",
  "Создаём голос…": "Creating voice…",
  "Сохранение настроек создания сейчас выключено.": "Saving creation settings is currently disabled.",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "Save not confirmed. Close the form and check the current profile.",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "Save not confirmed. Retrying creation will use the previous request.",
  "Сохранение недоступно.": "Saving unavailable.",
  "Сохранено": "Saved",
  "Сохранить": "Save",
  "Сохранить близкого": "Save relative",
  "Сохранить вариант": "Save variant",
  "Сохранить голос по умолчанию": "Save default voice",
  "Сохранить мои фото": "Save my photos",
  "Сохранить образцы": "Save samples",
  "Сохраняем образцы…": "Saving samples…",
  "Сохраняем…": "Saving…",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "Saved variants of yourself are available in your profile and creation tools.",
  "Сохранённых вариантов пока нет.": "No saved variants yet.",
  "Сроки партий Circle временно недоступны": "Circle batch expiration dates temporarily unavailable",
  "Старший": "Older",
  "Статистика": "Statistics",
  "Статистика по неделям временно недоступна.": "Weekly statistics temporarily unavailable.",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "Deletion status temporarily unavailable. Receipt saved in this tab.",
  "Сторис": "Stories",
  "Сын": "Son",
  "Тариф": "Plan",
  "Текст для чтения": "Text to read",
  "Тема": "Theme",
  "Тема сохраняется на этом устройстве.": "Theme is saved on this device.",
  "Тёмная": "Dark",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "I have the right to use these photos and the consent of the people depicted.",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "Removing noise",
  "Убрать": "Remove",
  "Убрать {0}": "Remove {0}",
  "Убрать из избранного": "Remove from favorites",
  "Убрать фоновый шум": "Remove background noise",
  "Убрать фото": "Remove photo",
  "Уведомления": "Notifications",
  "Уведомления недоступны.": "Notifications unavailable.",
  "Уведомления пока недоступны.": "Notifications are not available yet.",
  "Удаление аккаунта Mini App": "Mini App account deletion",
  "Удаление:": "Deletion:",
  "Удалить": "Delete",
  "Удалить «": "Delete “",
  "Удалить «{0}»?": "Delete “{0}”?",
  "Удалить аккаунт Mini App": "Delete Mini App account",
  "Удалить близкого": "Delete relative",
  "Удалить вариант": "Delete variant",
  "Удалить голос": "Delete voice",
  "Удаляем…": "Deleting…",
  "Удаляется": "Being deleted",
  "Українська": "Українська",
  "Условия использования": "Terms of Use",
  "Файл": "File",
  "Формат": "Format",
  "Фото Telegram": "Telegram photo",
  "Фото {0}": "Photo {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "Your photo and name are taken from your Telegram profile. If you've changed them, update your data here.",
  "Фото и фотосессия": "Photo and photoshoot",
  "Фото перед загрузкой": "Photo before upload",
  "Фото профиля": "Profile photo",
  "Фото профиля Telegram": "Telegram profile photo",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "Photos, voices, relatives, and Mini App data will be deleted from all services. STEOS ID and financial receipts will remain. Deletion cannot be undone.",
  "Фото:": "Photo:",
  "Часть профиля временно недоступна. Попробуйте обновить.": "Part of the profile is temporarily unavailable. Try refreshing.",
  "Читаем аудиофайлы…": "Reading audio files…",
  "Что нового": "What's new",
  "Что нового пока не опубликовано или временно недоступно.": "What's new has not been published yet or is temporarily unavailable.",
  "Что нового пока не опубликовано.": "What's new has not been published yet.",
  "Шаблоны": "Templates",
  "Шаблоны и рилс": "Templates and Reels",
  "Эта неделя": "This week",
  "Этот голос используется:": "This voice is used:",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "This run cannot be retried yet. Refresh the voice status.",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "This format is not supported. Choose MP3, WAV, M4A, OGG, or WebM.",
  "Язык аккаунта": "Account language",
  "готова": "ready",
  "готова частично": "partially ready",
  "дата недоступна": "date unavailable",
  "для переозвучки": "for re-voicing",
  "до {0}, потом {1}": "until {0}, then {1}",
  "другой тариф": "another plan",
  "закончится {0}": "expires {0}",
  "и": "and",
  "из": "of",
  "из 1:30 · минимум 0:02": "out of 1:30 · minimum 0:02",
  "лимит уточняется": "limit being determined",
  "не задан": "not set",
  "не назначен": "not assigned",
  "новых": "new",
  "образец": "sample",
  "образца": "sample",
  "образцов": "samples",
  "оплачено до {0}": "paid through {0}",
  "подарок до {0}": "gift until {0}",
  "пока недоступно": "not available yet",
  "политику конфиденциальности STEOS": "STEOS privacy policy",
  "продлится {0}": "renews on {0}",
  "речи.": "of speech.",
  "токенов": "tokens",
  "условия": "terms",
  "уточняется": "being determined",
  "Қазақша": "Қазақша",
  "← Профиль": "← Profile",
  "▶ Прослушать": "▶ Listen",
  "Озвучка": "Voiceover",
  "Клон": "Clone",
  "Студия": "Studio",
  "Баланс": "Balance",
  "История": "History",
  "Ещё": "More",
  "Клонирование голоса": "Voice cloning",
  "Партнёрство": "Partnership",
  "Добавить в чат": "Add to chat",
  "Разделы": "Sections",
  "Главное меню": "Main menu",
  "Выберите": "Choose",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "All photos were kept after merging. Keep up to five to change your appearance.",
  "Абзацы": "Paragraphs",
  "Альбом": "Album",
  "Аудио": "Audio",
  "Без изменения": "Unchanged",
  "Бесплатно по текущему тестовому dev-тарифу.": "Free under the current test dev plan.",
  "Бесплатно по тестовому dev-тарифу": "Free under the test dev plan",
  "В избранном пока пусто": "Favorites are empty for now",
  "В очереди": "Queued",
  "Вариант {0}": "Option {0}",
  "Введите текст до 1000 символов": "Enter text up to 1000 characters",
  "Вернули": "Refunded",
  "Вернуть запись в историю не получится. Файл в чате останется.": "The recording cannot be restored to history. The file will remain in the chat.",
  "Видео": "Video",
  "Виды работ": "Types of work",
  "Все": "All",
  "Вчера": "Yesterday",
  "Выбранный вариант": "Selected option",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "Selected option is unavailable. Return to your profile and refresh the list.",
  "Выполняется": "In progress",
  "Высота голоса": "Voice pitch",
  "Говорящее видео": "Talking video",
  "Голоса": "Voices",
  "Дата неизвестна": "Date unknown",
  "Длительность": "Duration",
  "Для этого действия пока нет доступного опубликованного инструмента.": "No published tool is currently available for this action.",
  "Дополнительное поле": "Additional field",
  "Заголовок": "Title",
  "Загружаем историю…": "Loading history…",
  "Загружаем работу…": "Loading work…",
  "Загружаем результат…": "Loading result…",
  "Загружаем…": "Loading…",
  "Загружено": "Uploaded",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "Upload not confirmed. Continue checking this file.",
  "Заказ": "Order",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "Order not confirmed. Continuing will check the previous request using the same key.",
  "Заменить файл": "Replace file",
  "Избранное: {0}": "Favorites: {0}",
  "Инструмент обновляется. Обновите форму позже.": "The tool is being updated. Refresh the form later.",
  "Искать в {0} работах": "Search in {0} works",
  "Искать в истории": "Search history",
  "Использовать фото выбранного варианта": "Use the selected option's photo",
  "Используется выбранный голос.": "The selected voice is in use.",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "The generation outcome is being verified. No new job will start automatically.",
  "К инструментам": "Go to tools",
  "Кавер": "Cover",
  "Карусель": "Carousel",
  "Ключевые слова": "Keywords",
  "Коллаж": "Collage",
  "Кратко": "Brief",
  "Кружки": "Video messages",
  "Кружок": "Video message",
  "Кто в кадре": "Who's in the frame",
  "Название": "Name",
  "Не получилось": "Failed",
  "Не удалось выполнить": "Could not complete",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "Could not perform this action on the work. Refresh it and try again.",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "Could not finish creating. Try changing the settings.",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "Could not load history. Try again.",
  "Не удалось загрузить студию.": "Failed to load the studio.",
  "Не удалось загрузить фото варианта. Обновите профиль.": "Could not load the option's photo. Refresh the profile.",
  "Не удалось обработать запись": "Could not process the recording",
  "Не удалось озвучить текст": "Could not voice the text",
  "Не удалось открыть инструмент. Попробуйте обновить.": "Could not open the tool. Try refreshing.",
  "Не удалось открыть результат. Попробуйте снова.": "Could not open the result. Try again.",
  "Не удалось отправить результат. Повторите отправку.": "Could not send the result. Try sending it again.",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "Could not connect to the service. Try again.",
  "Не удалось скопировать. Выделите текст вручную.": "Could not copy. Select the text manually.",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "Could not save the submission. Allow storage access for this tab and try again.",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "Some files from the replay are no longer available. Upload them again.",
  "Ничего не нашли": "No results found",
  "Нужно разных фото": "Different photos are required",
  "Обрабатываем запись": "Processing recording",
  "Озвучиваем текст": "Voicing text",
  "Озвучить": "Generate voice",
  "Озвучка готова": "Voiceover ready",
  "Озвучка проекта": "Project voiceover",
  "Оплата": "Payment",
  "Оплачено донатом": "Paid with a donation",
  "Определить автоматически": "Detect automatically",
  "Основа": "Base",
  "Открыть результат": "Open result",
  "Отменено": "Canceled",
  "Отправить в чат": "Send to chat",
  "Отправка не принята. Проверьте сообщение об ошибке.": "Submission not accepted. Check the error message.",
  "Отправка принята. Бот доставит результат в чат.": "Submission accepted. The bot will deliver the result to the chat.",
  "Отправлено": "Sent",
  "Переозвучить запись": "Revoice recording",
  "Переозвучка": "Revoicing",
  "Персонаж": "Character",
  "Площадка": "Platform",
  "Повтори движения": "Repeat the movements",
  "Повторить": "Retry",
  "Подпись": "Caption",
  "Подтверждаю право использовать загружаемые материалы": "I confirm that I have the right to use the uploaded materials",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "I confirm that I have the right to use these photos and that the people depicted have consented to creating an option",
  "Поиск в истории": "Search history",
  "Показатели истории": "History statistics",
  "Показатели истории временно недоступны": "History statistics are temporarily unavailable",
  "Показать все работы": "Show all work",
  "Показать текст": "Show text",
  "Порядок": "Order",
  "Почистить запись": "Clean up recording",
  "Прежний голос недоступен. Выберите другой голос.": "The previous voice is unavailable. Select another voice.",
  "Преимущества": "Benefits",
  "Проверьте заполненные поля. Заказ не создан.": "Check the completed fields. The order was not created.",
  "Проверяем итог операции": "Verifying operation outcome",
  "Проверяем отправку…": "Checking submission…",
  "Проверяем результат": "Verifying result",
  "Проверяем списание токенов": "Checking token deduction",
  "Продолжить проверку озвучки": "Continue checking the voiceover",
  "Работ пока нет": "No work yet",
  "Работ: {0}": "Works: {0}",
  "Работа": "Work",
  "Работа больше не найдена. Обновите историю.": "Work no longer found. Refresh history.",
  "Работа из истории": "Work from history",
  "Работа не прошла проверку.": "Work failed validation.",
  "Работа обновилась. Загрузите её ещё раз.": "Work has been updated. Load it again.",
  "Распознавание": "Recognition",
  "Распознанный текст": "Recognized text",
  "Распознать речь": "Recognize speech",
  "Расшифровка": "Transcription",
  "Режим озвучки": "Voiceover mode",
  "Результат": "Result",
  "Результат больше недоступен": "Result is no longer available",
  "Результат операции уточняется. Повторный запуск отключён.": "The operation outcome is being verified. Retrying is disabled.",
  "Результат отправки пока неизвестен. Повторите проверку.": "Submission status is still unknown. Check again.",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "Submission status is still unknown. Retry using the same key.",
  "Результат переозвучки": "Revoicing result",
  "Результат работы": "Work result",
  "Реплики": "Lines",
  "Речевая запись": "Speech recording",
  "Рилс": "Reels",
  "Сегодня": "Today",
  "Сейчас создаётся": "Being created now",
  "Сервис сейчас недоступен.": "The service is currently unavailable.",
  "Сессия истекла. Откройте приложение заново.": "Session expired. Reopen the app.",
  "Синтез": "Synthesis",
  "Скачать": "Download",
  "Скачать все файлы": "Download all files",
  "Скачать набор": "Download set",
  "Скопировано": "Copied",
  "Скопировать": "Copy",
  "Слайды": "Slides",
  "Слишком много запросов. Подождите немного.": "Too many requests. Please wait a moment.",
  "Слушать результат": "Listen to result",
  "Смена голоса": "Voice change",
  "Сначала новые": "Newest first",
  "Сначала старые": "Oldest first",
  "Создать": "Create",
  "Создаётся": "Creating",
  "Списано": "Deducted",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "Status not yet confirmed. Checking the previous order.",
  "Статус текущих заказов временно недоступен": "Current order statuses are temporarily unavailable",
  "Стиль": "Style",
  "Стоимость": "Cost",
  "Сцена": "Scene",
  "Съёмка": "Filming",
  "Текст": "Text",
  "Текст для озвучки": "Text for voiceover",
  "Текст песни": "Song lyrics",
  "Текст поста": "Post text",
  "Товар": "Product",
  "Удалить из истории": "Delete from history",
  "Удалить из истории?": "Delete from history?",
  "Уточняем результат": "Verifying result",
  "Уточняем состояние сохранённого заказа…": "Verifying the status of the saved order…",
  "Файл в чате останется": "The file will remain in the chat",
  "Файлов: {0}": "Files: {0}",
  "Форма недоступна.": "Form unavailable.",
  "Формат отправки": "Submission format",
  "Фото": "Photo",
  "Фотосессии": "Photo shoots",
  "Фотосессия": "Photo shoot",
  "Фотосессия товара": "Product photo shoot",
  "Части": "Parts",
  "Шаблон": "Template",
  "Эта работа недоступна вашему аккаунту.": "This work is unavailable to your account.",
  "Это вся история": "This is the entire history",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "This tool is currently unavailable. Try refreshing the form.",
  "Язык записи": "Recording language",
  "MP3 · пауза между репликами 0,6 с": "MP3 · 0.6 s pause between lines",
  "{0} / 1 000 знаков": "{0} / 1,000 characters",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20,000 characters · version {1}",
  "{0} реплик": "{0} lines",
  "{0} ролей · {1} новых реплик": "{0} roles · {1} new lines",
  "Аудио больше недоступно. Обновите статус проекта.": "Audio is no longer available. Update the project status.",
  "Буфер недоступен. Вставьте текст в поле вручную.": "Clipboard unavailable. Paste the text into the field manually.",
  "В проекте должно быть от 1 до 50 ролей.": "The project must have between 1 and 50 roles.",
  "В проекте может быть не больше 500 реплик.": "The project can have no more than 500 lines.",
  "Вставить из буфера": "Paste from clipboard",
  "Вставить сценарий": "Paste script",
  "Выберите голос для каждой непустой роли.": "Select a voice for each non-empty role.",
  "Выше": "Move up",
  "Голос {0}": "Voice {0}",
  "Голос роли": "Role voice",
  "Готовим аудио…": "Preparing audio…",
  "Добавить {0} реплик": "Add {0} lines",
  "Добавьте реплику или вставьте сценарий.": "Add a line or paste a script.",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "Wait for the shared file to finish loading, then try again.",
  "Дублировать": "Duplicate",
  "Загружаем аудио…": "Loading audio…",
  "Загружаем проекты…": "Loading projects…",
  "Загрузить версию сервера": "Load server version",
  "Закрыть раздел без сохранения изменений?": "Close the section without saving changes?",
  "Заменить текущие роли и реплики?": "Replace the current roles and lines?",
  "Заменить текущий сценарий": "Replace current script",
  "Изменить сценарий": "Edit script",
  "Имя роли": "Role name",
  "Кто говорит": "Speaker",
  "Мои проекты": "My projects",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "Press play in the player to enable audio.",
  "Название проекта": "Project name",
  "Название слишком длинное.": "Name is too long.",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "Could not recover operations. Do not start voice generation again; check the history.",
  "Не удалось выполнить действие. Изменения остаются на экране.": "Action failed. Changes remain on screen.",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "Could not load audio. Check your connection and try again.",
  "Не удалось озвучить проект": "Could not generate audio for the project",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "Could not prepare audio. Check the line and selected voice.",
  "Не удалось проверить владельца проекта. Обновите страницу.": "Could not verify project ownership. Refresh the page.",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "Could not connect to the server. Check your connection and try again.",
  "Не хватает Circle. Пополните баланс и повторите действие.": "Insufficient Circle balance. Top up your balance and try again.",
  "Ниже": "Move down",
  "Новый дубль реплики": "New take of line",
  "Общий файл · MP3": "Shared file · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "One of the voices is no longer available. Select another voice.",
  "Озвучено реплик: {0} из {1}": "Lines voiced: {0} of {1}",
  "Озвучиваем проект": "Generating project audio",
  "Озвучить · {0} Circle": "Generate audio · {0} Circle",
  "Озвучить проект": "Generate project audio",
  "Озвучка проектов": "Script voiceover",
  "Озвучка уже выполняется. Дождитесь результата.": "Voice generation is already in progress. Wait for the result.",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "The operation has already been accepted or its outcome is unknown. Check the previous request.",
  "Отбросить локальные изменения и загрузить версию сервера?": "Discard local changes and load the server version?",
  "Открыть в истории": "Open in history",
  "Отменить изменения": "Undo changes",
  "Отменить несохранённые изменения?": "Discard unsaved changes?",
  "Перед озвучкой дождитесь сохранения изменений.": "Wait for changes to be saved before generating audio.",
  "Переозвучить": "Regenerate audio",
  "Переозвучить реплику": "Regenerate line audio",
  "Повторить проверку": "Retry check",
  "Подтвердить и запустить": "Confirm and start",
  "Подтверждение озвучки": "Confirm audio generation",
  "Проверить прежний запрос": "Check previous request",
  "Проверить статус": "Check status",
  "Проверьте роли, голоса и длину реплик.": "Check roles, voices, and line lengths.",
  "Проект больше недоступен.": "Project is no longer available.",
  "Проект длиннее 20 000 знаков.": "Project exceeds 20,000 characters.",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "The project changed in another window. Compare your version and load the latest one.",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "The project has changed. Save it and check the price again.",
  "Проект или результат больше недоступен.": "Project or result is no longer available.",
  "Проект озвучен": "Project audio generated",
  "Проекты {0}": "Projects {0}",
  "Прослушать": "Listen",
  "Прослушать реплику": "Listen to line",
  "Прослушать текущую версию": "Listen to current version",
  "Прослушивание в очереди": "Listening queued",
  "Прослушивание реплики": "Listening to line",
  "Результат изменился. Загрузите его актуальную версию.": "The result has changed. Load the latest version.",
  "Результат озвучки проекта": "Project audio result",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "The result is still being determined. No new generation will start automatically.",
  "Реплика {0}": "Line {0}",
  "Реплика длиннее 1 000 знаков.": "Line exceeds 1,000 characters.",
  "Реплики · {0}": "Lines · {0}",
  "Реплику {0} выше": "Move line {0} up",
  "Реплику {0} ниже": "Move line {0} down",
  "Роли и голоса": "Roles and voices",
  "Роль {0}": "Role {0}",
  "Роль реплики": "Line role",
  "Скачать MP3": "Download MP3",
  "Слишком много запросов. Подождите и повторите проверку.": "Too many requests. Wait and try checking again.",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "Create a project, then paste a script or add roles and lines.",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "The price is confirmed by the server. Checking this request again will not charge you again.",
  "Стоимость: {0} Circle": "Cost: {0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "Lines in “Name: line” format become roles and lines. Timecodes can stay.",
  "Сценарий": "Script",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "The script has changed. This track belongs to an earlier project version.",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "A script with roles: each role has its own voice.",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "The text or voice has changed. Generate a new preview for the current version.",
  "Текст реплики": "Line text",
  "Удалить проект": "Delete project",
  "Удалить реплику {0}": "Delete line {0}",
  "Удалить реплику?": "Delete this line?",
  "Удалить роль {0}": "Delete role {0}",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "Delete role “{0}” and its lines ({1})?",
  "Удалить этот проект?": "Delete this project?",
  "Укажите имя каждой роли.": "Enter a name for each role.",
  "Уточняем результат озвучки": "Checking the voiceover result",
  "Цена изменилась. Проверьте новую цену перед запуском.": "The price has changed. Check the new price before starting.",
  "есть несохранённые изменения": "unsaved changes",
  "сохранено": "saved",
  "＋ Новый проект": "＋ New project",
  "＋ Реплика": "＋ Line",
  "＋ Роль": "＋ Role",
  "Circle из пакетов без срока действия.": "Circle from packages with no expiration date.",
  "Circle каждый месяц": "Circle every month",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Circle arrive every {0} days, with the first batch arriving immediately.",
  "Circle этой партии действуют до {0}": "This batch of Circle is valid until {0}",
  "{0} Circle каждый месяц": "{0} Circle every month",
  "{0} Circle каждый месяц · до {1} своих голосов": "{0} Circle every month · up to {1} of your own voices",
  "{0} мес.": "{0} mo.",
  "Баланс и профиль": "Balance and profile",
  "В текущем месяце осталось {0} из {1} Circle": "{0} of {1} Circle remaining this month",
  "Ваш текущий тариф": "Your current plan",
  "Включить тестовое продление": "Enable test renewal",
  "Выбор тарифа": "Choose a plan",
  "Действует до {0}": "Valid until {0}",
  "Для этой подписки продление пока недоступно.": "Renewal is not yet available for this subscription.",
  "До {0} своих голосов": "Up to {0} of your own voices",
  "До {0} сохраняется текущий тариф.": "Your current plan remains in effect until {0}.",
  "Докупить Circle": "Buy more Circle",
  "Доступные сроки": "Available durations",
  "Загружаем подписку…": "Loading subscription…",
  "Запланировать переход": "Schedule plan change",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "The request does not match the saved operation. Do not repeat the purchase; contact support.",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "The outcome of the previous request needs to be checked. New purchases are temporarily blocked.",
  "Начислить {0} тестовых Circle": "Add {0} test Circle",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "Could not recover the operation. Check your subscription before making another purchase.",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "Operation confirmed. Refresh the data; there is no need to repeat the purchase.",
  "Оставить текущий тариф": "Keep current plan",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "Canceling renewal keeps your plan and limits until the end of the paid period.",
  "Отменить продление": "Cancel renewal",
  "Оформить dev-подписку": "Activate dev subscription",
  "Пакет Circle начислен.": "Circle package credited.",
  "Пакеты Circle доступны с активной подпиской.": "Circle packages are available with an active subscription.",
  "Перейти на выбранный тариф": "Switch to selected plan",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "The switch will take effect after your current subscription ends. No payment is required now.",
  "Подписка": "Subscription",
  "Подписка временно недоступна. Попробуйте обновить данные.": "Subscription temporarily unavailable. Try refreshing the data.",
  "Подписка не продлится": "Subscription will not renew",
  "Подписка обновлена.": "Subscription updated.",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "Subscription is already active. Refresh the data and choose an available action.",
  "Подписка уже закончилась. Обновите данные.": "Subscription has already expired. Refresh the data.",
  "Подтвердить": "Confirm",
  "Подтверждение подписки": "Subscription confirmation",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "Purchases are currently unavailable. Real payments are not enabled.",
  "Получить dev-пакет бесплатно": "Get a free dev package",
  "Потом: {0}": "Later: {0}",
  "Предыдущая подписка закончилась {0}": "Previous subscription ended on {0}",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "When renewing a paid period, the new batch will arrive in the next period.",
  "Проверка операции": "Checking operation",
  "Продление включено": "Renewal enabled",
  "Продлить подписку": "Renew subscription",
  "Свои голоса": "Your own voices",
  "Свои голоса: {0} из {1}": "Your own voices: {0} of {1}",
  "Сравнить тарифы": "Compare plans",
  "Срок": "Duration",
  "Срок подписки": "Subscription duration",
  "Срок: {0} мес.": "Duration: {0} mo.",
  "Тариф останется до конца срока. Следующего продления не будет.": "Your plan will remain active until the end of the period. It will not renew again.",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "Plans are currently unavailable. Try refreshing the data later.",
  "Текущий тариф": "Current plan",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "Test dev catalog. No real payments; test Circle are credited.",
  "Управление подпиской": "Manage subscription",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "Plan terms have changed. Refresh the data before confirming.",
  "Что входит": "What's included",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "This is a free dev operation. No money or Telegram Stars will be charged.",
  "Этот переход между тарифами недоступен.": "This plan switch is unavailable.",
  "Этот тариф больше недоступен. Обновите список.": "This plan is no longer available. Refresh the list.",
  "QR-код": "QR code",
  "QR-код приглашения": "Invitation QR code",
  "{0} из {1} · {2} Circle": "{0} of {1} · {2} Circle",
  "Виды заданий": "Task types",
  "Выполнение этого задания пока недоступно.": "This task is not available yet.",
  "Готовим материал…": "Preparing content…",
  "Действие подтверждено. Обновляем задания.": "Action confirmed. Updating tasks.",
  "День {0}": "Day {0}",
  "День {0} из {1}": "Day {0} of {1}",
  "Дней подряд: {0}": "Consecutive days: {0}",
  "Друзья": "Friends",
  "Ежедневная серия": "Daily streak",
  "Ежедневные": "Daily",
  "Есть награды": "Rewards available",
  "Забрать {0} Circle": "Claim {0} Circle",
  "Загружаем награды…": "Loading rewards…",
  "Задание ещё не выполнено. Обновите прогресс.": "Task not completed yet. Refresh your progress.",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "The task counts opening the story-sharing interface. Telegram does not confirm publication.",
  "Заданий в этой группе пока нет.": "No tasks in this group yet.",
  "Задания дня": "Tasks of the day",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "Visit every day. Missing a day resets your streak.",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "The outcome of the previous request needs to be checked. New credits are temporarily blocked.",
  "Копирование недоступно. Выделите текст вручную.": "Copying is unavailable. Select the text manually.",
  "Материал для сторис": "Story content",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "Reward confirmed. Refresh your data; no need to claim it again.",
  "Награда получена": "Reward received",
  "Награда получена. Завтра +{0} Circle": "Reward received. Tomorrow: +{0} Circle",
  "Награда уже получена. Обновите данные.": "Reward already received. Refresh your data.",
  "Награды временно недоступны. Попробуйте обновить данные.": "Rewards are temporarily unavailable. Try refreshing your data.",
  "Награды за друзей": "Rewards for friends",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "Rewards are credited in Circle: they can be spent on STEOS but cannot be withdrawn.",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "Credit not confirmed. Check the previous request; the new reward is temporarily blocked.",
  "Начисления приостановлены.": "Credits are suspended.",
  "Начислено {0} Circle": "Credited {0} Circle",
  "Начислено: {0} Circle": "Credited: {0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "Could not recover the reward request. Check your balance and contact support.",
  "Не удалось загрузить QR-код.": "Could not load the QR code.",
  "Не удалось открыть отправку сторис. Награда не начислена.": "Could not open the story-sharing interface. No reward was credited.",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "Could not prepare the story. Try again.",
  "Новый день: {0}": "New day: {0}",
  "Обновить награды": "Refresh rewards",
  "Обновятся: {0}": "Will be updated: {0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "Open the Mini App in Telegram with story support.",
  "Открыть STEOS ID в профиле": "Open STEOS ID in your profile",
  "Открыть сторис": "Open story",
  "Отправить в сторис": "Share to story",
  "Партнёрские данные временно недоступны.": "Partner data is temporarily unavailable.",
  "Партнёрство · Статистика, материалы и вывод": "Partnership · Statistics, materials, and withdrawals",
  "Первые шаги": "First steps",
  "Перейти к заданию": "Go to task",
  "Получить ежедневную награду": "Claim daily reward",
  "Приглашено: {0} · Покупателей: {1}": "Invited: {0} · Buyers: {1}",
  "Прогресс задания": "Task progress",
  "Прогресс задания временно недоступен.": "Task progress is temporarily unavailable.",
  "Промокод": "Promo code",
  "Разовые": "One-time",
  "Скопировать приглашение": "Copy invitation",
  "Скопировать промокод": "Copy promo code",
  "Ссылка приглашения": "Invitation link",
  "Сторис в Telegram": "Telegram Stories",
  "Челленджи недели": "Weekly challenges",
  "Circle используются внутри STEOS": "Circles are used within STEOS",
  "Telegram подтвердил отправку сообщения.": "Telegram confirmed that the message was sent.",
  "Без покупок": "No purchases",
  "В этом списке пока нет друзей.": "There are no friends in this list yet.",
  "Возможен вывод по условиям программы": "Withdrawal may be available under the program terms",
  "Вопросы": "Questions",
  "Всё время": "All time",
  "Вы здесь": "You are here",
  "Выберите PDF, JPG или PNG.": "Select a PDF, JPG, or PNG file.",
  "Выберите плательщика": "Select payer",
  "Выбрать чат в Telegram": "Select chat in Telegram",
  "Выбрать чат для отправки": "Select a chat to send to",
  "Вывод": "Withdrawal",
  "Вывод недоступен на текущем уровне.": "Withdrawal is unavailable at your current level.",
  "Вывод сейчас недоступен.": "Withdrawals are currently unavailable.",
  "Вывод средств": "Withdraw funds",
  "Выплачен": "Paid",
  "Выставьте счёт на": "Bill to",
  "Для вывода войдите в STEOS ID.": "Sign in to STEOS ID to withdraw funds.",
  "Для расчёта нужны опубликованные уровни и тарифы.": "Published levels and rates are required for the calculation.",
  "До уровня «{0}»: ещё {1} покупателей": "To reach level “{0}”: {1} more buyers",
  "Доступно к выводу": "Available for withdrawal",
  "Доступных шаблонов пока нет.": "No templates are available yet.",
  "Доход": "Income",
  "Если купят {0} друзей": "If {0} friends make purchases",
  "Есть покупки": "Has purchases",
  "За этот период начислений пока нет.": "No earnings have been credited for this period yet.",
  "Загружаем QR-код…": "Loading QR code…",
  "Загружаем друзей…": "Loading friends…",
  "Загружаем материалы…": "Loading materials…",
  "Загружаем партнёрские данные…": "Loading partner data…",
  "Загрузите проверенный счёт на оплату.": "Upload a verified invoice for payment.",
  "Заказать материал в чат": "Order material in chat",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "Request accepted. Delivery to the chat has not yet been confirmed.",
  "Заявка принята. Статус выплаты появится в истории.": "Request accepted. The payout status will appear in the history.",
  "Заявок на вывод пока нет.": "No withdrawal requests yet.",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "Changing payment details is blocked until the result of this request is received.",
  "Имя получателя": "Recipient name",
  "История выводов": "Withdrawal history",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "The request outcome needs to be checked. New material is temporarily blocked.",
  "Как определяется уровень?": "How is the level determined?",
  "Как это работает": "How it works",
  "Калькулятор станет доступен после публикации расчётной политики.": "The calculator will be available once the calculation policy is published.",
  "Количество друзей": "Number of friends",
  "Материалы": "Materials",
  "Материалы временно недоступны. Попробуйте обновить список.": "Materials are temporarily unavailable. Try refreshing the list.",
  "Материалы пока недоступны.": "Materials are currently unavailable.",
  "Месяц": "Month",
  "Минимальная сумма": "Minimum amount",
  "На рассмотрении": "Under review",
  "Налоговый номер": "Tax ID",
  "Начисления за период": "Earnings for the period",
  "Начислено Circle": "Circle credited",
  "Начислено за период: {0} Circle": "Credited for the period: {0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "Could not securely save the request or verify ownership. Nothing was sent.",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "Could not restore the sending process. Contact support before making a new request.",
  "Не удалось загрузить друзей.": "Failed to load friends.",
  "Не удалось загрузить историю выводов.": "Failed to load withdrawal history.",
  "Не удалось загрузить тарифы.": "Failed to load rates.",
  "Не удалось открыть отправку в Telegram.": "Could not open the sending interface in Telegram.",
  "Не удалось проверить владельца. Обновите страницу.": "Could not verify ownership. Refresh the page.",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "Could not read the saved request. New withdrawals are blocked.",
  "Не удалось сохранить состояние отправки.": "Could not save the sending status.",
  "Неделя": "Week",
  "Нет данных": "No data",
  "Новая заявка": "New request",
  "Новая заявка на вывод сейчас недоступна.": "A new withdrawal request is currently unavailable.",
  "О программе": "About the program",
  "Обзор": "Overview",
  "Обновите страницу или обратитесь в поддержку.": "Refresh the page or contact support.",
  "Обновить историю выводов": "Refresh withdrawal history",
  "Обновить материалы": "Refresh materials",
  "От {0} покупателей": "From {0} buyers",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "No response received. Check the same request: its data and key have been saved.",
  "Отклонён": "Rejected",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "Open the Mini App in Telegram with support for sending materials.",
  "Открыть сторис в Telegram": "Open story in Telegram",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "Sending has not been confirmed. Retrying will check the previous request without sending it again.",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "Sending canceled. You can open chat selection again.",
  "Оценка дохода": "Estimated income",
  "Оценка за {0} месяцев: {1} Circle": "Estimated income for {0} months: {1} Circle",
  "Оценка за месяц: {0} Circle": "Estimated monthly income: {0} Circle",
  "Переходы": "Clicks",
  "Период обзора": "Review period",
  "Плательщик": "Payer",
  "Подать заявку на вывод": "Submit withdrawal request",
  "Подготовить QR-код": "Generate QR code",
  "Подготовить другой материал": "Prepare another material",
  "Подготовить материал": "Prepare material",
  "Поделитесь своей ссылкой или промокодом.": "Share your link or promo code.",
  "Поделиться": "Share",
  "Пока без покупок": "No purchases yet",
  "Пока недоступно": "Not available yet",
  "Покупатели": "Buyers",
  "Покупки друзей учитывает сервер STEOS ID.": "STEOS ID server tracks friends' purchases.",
  "Полные условия программы": "Full program terms",
  "Пользователь": "User",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "Try STEOS: {0}\nPromo code: {1}",
  "Привязка до: {0}": "Linked until: {0}",
  "Привязка приглашённого друга действует {0} месяцев.": "A referred friend remains linked for {0} months.",
  "Приглашён: {0}": "Invited: {0}",
  "Проверить загрузку счёта": "Check invoice upload",
  "Проверить ту же заявку": "Check the same request",
  "Проверьте налоговый номер получателя.": "Check the recipient's tax ID.",
  "Проверьте реквизиты и счёт.": "Check the payment details and invoice.",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "Check the withdrawal amount: it must be a whole number within the available range.",
  "Проверяем владельца…": "Verifying ownership…",
  "Проверяем заявку или счёт…": "Checking request or invoice…",
  "Процент и доступность вывода определяет опубликованная программа.": "The published program determines the percentage and withdrawal availability.",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "Percentages, time frames, and restrictions are shown according to published server data.",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "The invoice file must be between 1 byte and 10 MB.",
  "Регистрации": "Registrations",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "The invoice upload result is unknown. Check the upload without resending the file.",
  "Скачать PNG": "Download PNG",
  "Сколько действует привязка друга?": "How long does a friend's link remain active?",
  "Скопировать текст": "Copy text",
  "Сохранена неподтверждённая заявка": "Unconfirmed request saved",
  "Срок рассмотрения, дней": "Review period, days",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "The link and promo code are added by the server. Select an available material.",
  "Ссылка на полный документ условий пока не опубликована.": "The link to the full terms document has not been published yet.",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "Story opened in Telegram. Confirm the post in the editor.",
  "Сумма в Circle": "Amount in Circle",
  "Сумма меньше минимальной суммы вывода.": "The amount is below the minimum withdrawal amount.",
  "Сумма превышает доступный остаток.": "The amount exceeds the available balance.",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "Invoice for payment · PDF, JPG, or PNG, up to 10 MB",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "The invoice upload or verification failed. Select a PDF, JPG, or PNG file up to 10 MB.",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "The invoice has not been confirmed yet. Check again or select another file.",
  "Счёт проверен": "Invoice verified",
  "Текст приглашения": "Invitation text",
  "Текст сообщения": "Message text",
  "Тексты": "Texts",
  "Тестовая заявка": "Test request",
  "Тестовая программа dev. Реальные выплаты выключены.": "Test program dev. Real payouts are disabled.",
  "Тестовая программа: реальные выплаты отключены.": "Test program: real payouts are disabled.",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "Test calculation dev. This is an estimate; no earnings are credited.",
  "Укажите имя получателя: до 200 символов.": "Enter the recipient's name: up to 200 characters.",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "The server displays the level based on counted buyers. See the “Levels” tab.",
  "Уровни": "Levels",
  "Условия начислений пока не опубликованы.": "Earning terms have not been published yet.",
  "Условия программы": "Program terms",
  "Учёт переходов по ссылке пока недоступен.": "Link click tracking is currently unavailable.",
  "Фильтр друзей": "Friend filter",
  "Что делать, если данные не обновились?": "What should I do if the data hasn't updated?",
  "Шаги": "Steps",
  "Баннер": "Banner",
  "QR-постер": "QR poster",
  "{0} / 300 знаков": "{0} / 300 characters",
  "· до 20 МБ": "· up to 20 MB",
  "Агент готовит ответ…": "The agent is preparing a response…",
  "Аудиозапись": "Audio recording",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "Free in dev only. Up to 30 seconds and 10 MB. You can edit the text before sending.",
  "Ваш вопрос": "Your question",
  "Вопрос или название инструмента": "Question or tool name",
  "Вопросов: {0}": "Questions: {0}",
  "Вопросы · {0}": "Questions · {0}",
  "Восстанавливаем чат…": "Restoring chat…",
  "Все сервисы работают": "All services operational",
  "Выберите MP3, WAV или M4A до 20 МБ.": "Choose an MP3, WAV, or M4A file up to 20 MB.",
  "Выберите инструкцию к нужному инструменту или странице.": "Choose instructions for the relevant tool or page.",
  "Диктовать вопрос": "Dictate a question",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "Dictation not confirmed. Retry checking the previous request or upload.",
  "До": "To",
  "Ещё спрашивают": "Also asked",
  "Загружаем справку…": "Loading help…",
  "Загружаем статус…": "Loading status…",
  "Закрыть чат": "Close chat",
  "ИИ-агент поддержки": "AI support agent",
  "ИИ-агент сейчас недоступен.": "The AI agent is currently unavailable.",
  "Инструкции": "Instructions",
  "Инструкции · {0}": "Instructions · {0}",
  "Инструкции пока не опубликованы.": "No instructions have been published yet.",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "The request outcome is still unknown. No new question is being sent.",
  "Как пользоваться STEOS": "How to use STEOS",
  "Кружки и говорящие видео": "Video messages and talking videos",
  "Медленнее обычного": "Slower than usual",
  "Написать агенту": "Message the agent",
  "Начать": "Start",
  "Начать новую диктовку": "Start a new dictation",
  "Не помогло": "Didn't help",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "Could not restore dictation. The new request is blocked.",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "Could not restore chat. Contact support.",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "Could not load support. Try again.",
  "Не удалось загрузить статус сервисов.": "Could not load service status.",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "Could not confirm the response. You can start a new chat or contact support.",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "Could not retrieve a response. Retry checking without asking a new question.",
  "Не удалось проверить владельца чата. Повторите открытие.": "Could not verify chat ownership. Try opening it again.",
  "Не удалось сохранить новый чат.": "Could not save the new chat.",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "Could not save your rating. Try again.",
  "Недоступен": "Unavailable",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "Some services are running slower than usual. View status",
  "Нет подтверждённых данных": "No confirmed data",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "Nothing found. Try different words or ask the AI agent.",
  "Новый чат": "New chat",
  "Обзор приложения": "App overview",
  "Обновить справку": "Refresh help",
  "Обновить статус": "Refresh status",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "Published check. Automated monitoring is not claimed.",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "Response not confirmed. Check the previous request or contact support.",
  "Отвечает по опубликованной справке STEOS": "Answers using the published STEOS help documentation",
  "Открыть инструкции": "Open instructions",
  "Открыть инструкцию": "Open instructions",
  "Открыть инструмент": "Open tool",
  "Открыть ответ справки": "Open help answer",
  "Открыть раздел": "Open section",
  "Отправить вопрос": "Send question",
  "Оценка ответа": "Rate the response",
  "Очистить поиск": "Clear search",
  "Поиск по справке": "Search help",
  "Полезно": "Helpful",
  "Помощь": "Help",
  "Популярные вопросы": "Popular questions",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "The last check is outdated. Current status is unknown.",
  "Посмотреть короткий обзор": "View a quick overview",
  "Предыдущая": "Previous",
  "Проверено: {0}": "Checked: {0}",
  "Проверить диктовку": "Check dictation",
  "Пропустить": "Skip",
  "Работает": "Operational",
  "Распознать вопрос": "Recognize question",
  "Распознаём вопрос…": "Recognizing question…",
  "Результаты поиска": "Search results",
  "Следующая": "Next",
  "Советы": "Tips",
  "Справка пока не опубликована.": "Help documentation has not been published yet.",
  "Спросите что угодно": "Ask anything",
  "Спросить ИИ-агента": "Ask the AI agent",
  "Спросить ИИ-агента поддержки": "Ask the AI support agent",
  "Статус": "Status",
  "Статус сервисов": "Service status",
  "Статус сервисов пока не публикуется.": "Service status is not published yet.",
  "Статья недоступна": "Article unavailable",
  "Темы": "Topics",
  "Темы пока не опубликованы.": "No topics have been published yet.",
  "Точного ответа в справке нет.": "No exact answer is available in the help documentation.",
  "Чат не отправляет сообщения человеку автоматически.": "The chat does not automatically send messages to a human.",
  "Читаем запись…": "Reading recording…",
  "Эта статья больше не входит в опубликованную справку.": "This article is no longer part of the published help documentation.",
  "Выберите MP3, WAV или M4A до {0} МБ.": "Choose an MP3, WAV, or M4A file up to {0} MB.",
  "До {0} · до {1} МБ": "Up to {0} · up to {1} MB",
  "Нужна запись от 1 секунды до {0}.": "Recording must be between 1 second and {0}.",
  "Остановить запись · {0}": "Stop recording · {0}",
  "{0} C/сек": "{0} C/sec",
  "Все инструменты": "All tools",
  "Все шаблоны": "All templates",
  "Вся подборка": "Full collection",
  "Выбрать, кто играет": "Choose who performs",
  "Голос и музыка": "Voice and music",
  "Двое": "Two",
  "Дети": "Children",
  "Дешевле": "Cheaper",
  "Для бизнеса": "For business",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "Several templates are available for this action. Choose one from the catalog.",
  "Загружаем шаблон…": "Loading template…",
  "Закрыть поиск": "Close search",
  "Закрыть превью": "Close preview",
  "Инструменты": "Tools",
  "Искать во всех шаблонах": "Search all templates",
  "Короче": "Shorter",
  "Кто играет": "Who performs",
  "Найти инструмент или шаблон": "Find a tool or template",
  "Не удалось загрузить выбранный вариант.": "Failed to load the selected option.",
  "Не удалось загрузить шаблон. Обновите превью.": "Failed to load the template. Refresh the preview.",
  "Не удалось открыть инструмент.": "Failed to open the tool.",
  "Несколько": "Several",
  "Новые": "New",
  "Один": "One",
  "от {0} C": "From {0} C",
  "от {0} C/сек": "From {0} C/sec",
  "От {0} Circle": "From {0} Circle",
  "От А до Я": "A to Z",
  "Очистить": "Clear",
  "Питомцы": "Pets",
  "По желанию": "Optional",
  "Подборка пока недоступна.": "Collection is currently unavailable.",
  "Подборки": "Collections",
  "Поиск": "Search",
  "Пока нет доступных шаблонов": "No templates available yet",
  "Популярные": "Popular",
  "После": "After",
  "Превью шаблона": "Template preview",
  "Пример результата пока не опубликован.": "A result example has not been published yet.",
  "Пример сейчас недоступен.": "Example is currently unavailable.",
  "Рекомендуем": "Recommended",
  "Смотреть все": "View all",
  "Сначала": "Sort by",
  "Сравнить до и после": "Compare before and after",
  "Стилей: {0}. Выбор на следующем шаге.": "Styles: {0}. Choose on the next step.",
  "Удерживайте для просмотра": "Press and hold to view",
  "Цена уточняется в форме создания.": "Price will be confirmed in the creation form.",
  "Частые вопросы": "Frequently asked questions",
  "Что нужно": "What you need",
  "Что хотите сделать?": "What would you like to do?",
  "Шаблоны и подборки": "Templates and collections",
  "Это действие пока недоступно.": "This action is currently unavailable.",
  "е": "e",
  "за секунду": "per second",
  "ё": "ё",
  "{0} C в минуту": "{0} C per minute",
  "{0} C за 100 знаков": "{0} C per 100 characters",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "The session owner has changed. Return to the studio after refreshing the page.",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "Failed to restore the saved request. New generation is blocked.",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "Failed to update the saved request. New generation is blocked.",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "Failed to verify the owner. New generation is blocked.",
  "Не удалось сохранить заявку. Отправка не выполнена.": "Failed to save the request. Submission failed.",
  "от {0} C в минуту": "From {0} C per minute",
  "от {0} C за 100 знаков": "From {0} C per 100 characters",
  "Проверить статус заказа": "Check order status",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "Status is not yet confirmed. Check this same order later.",
  "в минуту": "per minute",
  "за 100 знаков": "per 100 characters",
  "Анимация звука": "Sound Animation",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "The original speech will remain in the video. Select a clip up to one minute long.",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "The original words will remain in the video. The voice can be changed. Select a clip up to one minute long.",
  "Вид персонажа": "Character Appearance",
  "Видео готово": "Video Ready",
  "Видео не создано": "Video Not Created",
  "Волна": "Wave",
  "Выберите, кто говорит": "Choose Who Is Speaking",
  "Выбранное фото": "Selected Photo",
  "Движение": "Movement",
  "Добавьте видео": "Add Video",
  "Дополнительная настройка": "Additional Settings",
  "Другой голос для записи": "Different Voice for Recording",
  "Ещё вариант": "Another Option",
  "Ещё настройки": "More Settings",
  "Изменить данные": "Edit Details",
  "Источник": "Source",
  "Источник лица": "Face Source",
  "Источник речи": "Speech Source",
  "Кадр по вертикали": "Vertical Frame",
  "Кадр по горизонтали": "Horizontal Frame",
  "Каких движений избегать": "Movements to Avoid",
  "Конец фрагмента, секунды": "Clip End, Seconds",
  "Кружком": "As a video message",
  "Кружок готов": "Video message ready",
  "Кружок не создан": "Video message not created",
  "Люди и персонажи": "People and Characters",
  "Напишите текст или добавьте запись": "Enter Text or Add a Recording",
  "Начало фрагмента, секунды": "Clip Start, Seconds",
  "Не удалось загрузить виды персонажа.": "Failed to Load Character Appearances.",
  "Не удалось загрузить людей и персонажей.": "Failed to Load People and Characters.",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "Failed to Confirm Order Completion. No New Generation Started.",
  "Не удалось проверить доставку. Откройте историю заказа.": "Failed to Verify Delivery. Open Order History.",
  "Оставить голос записи": "Keep Recording Voice",
  "Открыть в чате": "Open in Chat",
  "Отправлено в чат": "Sent to Chat",
  "По умолчанию": "Default",
  "Подтвердите право использовать материалы": "Confirm Your Right to Use These Materials",
  "Полосы": "Stripes",
  "Портретное": "Portrait",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "The Previous Order Is Not Yet Complete. Check Its Result First.",
  "Приближение": "Zoom",
  "Проверка отклонила материал. Измените исходные данные.": "The Content Was Rejected During Review. Change the Source Data.",
  "Продолжить проверку отправки": "Continue Checking Submission",
  "Результат недоступен. Проверьте историю заказа.": "Result Unavailable. Check Order History.",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "Submission Status Not Yet Confirmed. Continue Checking with the Same Key.",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "Result Not Yet Confirmed. Check This Order Before Creating a New One.",
  "Своё видео": "Own Video",
  "Своё фото": "Own Photo",
  "Создание сейчас недоступно": "Creation Currently Unavailable",
  "Создать кружок": "Create video message",
  "Создаём видео": "Creating Video",
  "Списание возвращено": "Charge Refunded",
  "Тестовый заказ без списания": "Test Order Without Charge",
  "Файлом": "As a File",
  "Фоновый звук": "Background Sound",
  "Фото с лицом": "Photo with Face",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "The Price or Tool Version Has Changed. Refresh the Form and Check the Cost.",
  "Человек или персонаж": "Person or Character",
  "Что скажет?": "What Will They Say?",
  "Напишите не меньше {0} знаков": "Enter at least {0} characters",
  "Текст отклонён проверкой. Измените текст.": "Text rejected by moderation. Please edit the text.",
  "В видео прозвучат новые слова.": "New words will be spoken in the video.",
  "Если речь длиннее видео, ролик повторится.": "If the speech is longer than the video, the clip will repeat.",
  "Исходная речь": "Original speech",
  "Новая запись": "New recording",
  "Новые слова текстом": "New words as text",
  "Речь в видео": "Speech in the video",
  "Размер файла не должен превышать {0} МБ.": "File size must not exceed {0} MB.",
  "До {0} МБ": "Up to {0} MB",
  "Альбомное": "Landscape",
  "Альбомом": "In landscape orientation",
  "Без стиля": "No style",
  "В новом стиле": "In a new style",
  "Вариант": "Variant",
  "Во весь экран": "Full screen",
  "Восстановить фото": "Restore photo",
  "Все стили": "All styles",
  "Все темы": "All themes",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "Select a tool from the catalog, then confirm photo usage.",
  "Выберите подходящее фото до {0} МБ.": "Choose a suitable photo up to {0} MB.",
  "Выберите стиль или свой референс": "Choose a style or your own reference",
  "Выбран свой референс": "Custom reference selected",
  "Выбрать стиль": "Choose a style",
  "Двигайте картинку, чтобы выбрать кадр": "Move the image to select a frame",
  "Диафрагма": "Aperture",
  "Добавить человека": "Add a person",
  "Добавьте описание, от 10 знаков": "Add a description, at least 10 characters",
  "Загрузите фото": "Upload a photo",
  "Заполните обязательные поля": "Fill in the required fields",
  "Изменить фото": "Change photo",
  "Использовать выбранное фото результата": "Use the selected result photo",
  "Кадр": "Frame",
  "Кадрирование": "Cropping",
  "Как у фото": "Like the photo",
  "Камера": "Camera",
  "Найти настройку съёмки": "Find a shooting setting",
  "Найти стиль": "Find a style",
  "Настройки съёмки недоступны.": "Shooting settings are unavailable.",
  "Начать новое улучшение": "Start a new enhancement",
  "Не выбран": "Not selected",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "Failed to restore the enhancement. A new submission is blocked.",
  "Не удалось загрузить режимы фото.": "Failed to load photo modes.",
  "Не удалось загрузить фото.": "Failed to load photo.",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "Failed to use the result photo. Open the original order and try again.",
  "Не удалось открыть режим. Попробуйте ещё раз.": "Failed to open the mode. Please try again.",
  "Не удалось передать выбранное фото. Попробуйте снова.": "Failed to transfer the selected photo. Please try again.",
  "Не удалось проверить владельца.": "Failed to verify ownership.",
  "Не удалось прочитать фото.": "Failed to read the photo.",
  "Не удалось улучшить текст. Исходный текст сохранён.": "Failed to improve the text. The original text has been saved.",
  "О стиле": "About the style",
  "Объектив": "Lens",
  "Оживить фото": "Animate photo",
  "Описание во весь экран": "Full-screen description",
  "Описание длиннее допустимого": "Description exceeds the allowed length",
  "По вертикали": "Vertical",
  "По горизонтали": "Horizontal",
  "По описанию": "By description",
  "Повторить прежнее улучшение": "Repeat the previous enhancement",
  "Подтвердите права на материалы": "Confirm rights to the materials",
  "Пример": "Example",
  "Проверить улучшение": "Check enhancement",
  "Проверяем фото…": "Checking photo…",
  "Ракурс": "Angle",
  "Раскрасить чёрно-белое": "Colorize black and white",
  "Режим фото": "Photo mode",
  "Референс должен быть не меньше 256 × 256 пикселей.": "The reference must be at least 256 × 256 pixels.",
  "Свернуть": "Collapse",
  "Свет": "Lighting",
  "Свой референс": "Custom reference",
  "Свой референс сейчас недоступен": "Custom reference is currently unavailable",
  "Сделать рилс": "Create a Reel",
  "Сколько фото": "Number of photos",
  "Создать фото": "Create photo",
  "Создаём фото": "Creating photo",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "The enhancement verification has expired. The original text has been saved.",
  "Тема стиля": "Style theme",
  "Убрать из кадра": "Remove from frame",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "The enhancement has not yet been confirmed. The original text has been saved.",
  "Улучшить": "Enhance",
  "Формат файла": "File format",
  "Фото готовы": "Photos are ready",
  "Фото на аватарку": "Profile photo",
  "Фото не создано": "Photo not created",
  "Цвет": "Color",
  "Что дальше": "What's next",
  "Что делает в кадре": "What they're doing in the frame",
  "Выберите разных людей в кадре": "Choose different people for the frame",
  "Измените описание и попробуйте улучшить его снова.": "Change the description and try improving it again.",
  "Использовать референс": "Use reference",
  "Авто": "Auto",
  "Без движения": "No motion",
  "Видео должно длиться не меньше секунды": "Video must be at least one second long",
  "Выберите главное фото": "Select the main photo",
  "Выберите один исходный файл": "Choose one source file",
  "Выберите файл подходящего формата и размера": "Choose a file of a supported format and size",
  "Выберите фрагмент от 1 до 10 секунд": "Select a clip from 1 to 10 seconds",
  "Главное фото": "Main photo",
  "Длительность исходника: {0} с": "Source duration: {0} s",
  "Добавить речь": "Add speech",
  "Загрузите видео": "Upload a video",
  "Загрузите фото или видео": "Upload a photo or video",
  "Загрузить": "Upload",
  "Загрузить видео": "Upload video",
  "Загрузить фото": "Upload photo",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "Original audio is not retained: the model creates new audio.",
  "Звук от модели": "Model-generated audio",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "The model creates background sound, noises and music. Speech can be added afterwards.",
  "Использовать видео результата": "Use the resulting video",
  "Исходное видео": "Source video",
  "Исходный файл": "Source file",
  "Как двигаться": "How to move",
  "Конец фрагмента, мс": "Clip end, ms",
  "Конец, секунды": "End, seconds",
  "Люди в кадре недоступны для этого режима": "People in frame are unavailable in this mode",
  "Начало фрагмента, мс": "Clip start, ms",
  "Начало, секунды": "Start, seconds",
  "Не удалось загрузить режимы видео.": "Could not load video modes.",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "Could not use the resulting video. Open the source order and try again.",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "Could not transfer the video. Open the source order and try again.",
  "Новое": "New",
  "Объёмное фото создаётся без звука": "Parallax video is created without audio",
  "Первый кадр": "First frame",
  "Продолжить загрузку": "Continue upload",
  "Разрешение": "Resolution",
  "Режим видео": "Video mode",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "We will use the main photo. Select the main photo to crop.",
  "Снять": "Capture",
  "Снять видео": "Record video",
  "Создать видео": "Create video",
  "Темп": "Pace",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "Fixed format: portrait 3:4, 5-second video",
  "Фото товара": "Product photos",
  "Фрагмент от 1 до 10 секунд": "Clip from 1 to 10 seconds",
  "Хит": "Popular",
  "Что изменить": "What to change",
  "Этот режим видео пока недоступен": "This video mode is currently unavailable",
  "Как у исходника": "Same as source",
  "Со звуком": "With audio",
  "Без звука": "Silent",
  "5 секунд": "5 seconds",
  "10 секунд": "10 seconds",
  "Не удалось прочитать файл.": "Could not read the file.",
  "1. Видео с вами": "1. Video of you",
  "1. Видео с движениями": "1. Motion video",
  "2. Кем стать": "2. Who to become",
  "2. Кто повторит": "2. Who will repeat it",
  "Видео должно длиться не меньше {0} секунд": "Video must be at least {0} seconds long",
  "Водяной знак — недоступен": "Watermark — unavailable",
  "Вы, близкий или персонаж": "You, someone close or a character",
  "Выберите допустимый фрагмент видео": "Select a clip within the allowed duration",
  "Выберите одного героя": "Choose one character",
  "Выберите фон": "Select a background",
  "Выберите, кто повторит движения": "Choose who will repeat the movements",
  "Голос героя — недоступен": "Character voice — unavailable",
  "Другой голос — недоступен": "Another voice — unavailable",
  "Загрузите видео с движениями": "Upload a motion video",
  "Из видео": "From the video",
  "Изменить людей и свои фото": "Manage people and your photos",
  "Источник героя": "Character source",
  "Исходный звук сохраняется, если он есть в ролике.": "Original audio is retained if the video has an audio track.",
  "Кадр, ракурс и фон берутся с фото героя.": "Framing, angle and background come from the character photo.",
  "Кто повторит движения": "Who will repeat the movements",
  "На фото должны быть видны голова, плечи и корпус.": "The photo must show the head, shoulders and torso.",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "The frame must contain one person. The photo and video must show the head, shoulders and torso.",
  "Подтвердите права и согласие человека": "Confirm your rights and the person’s consent",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "I confirm my rights to the materials and the person’s consent to use their likeness",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "Can't turn this into a video message: the result has no confirmed audio track.",
  "Режим движения": "Motion mode",
  "С героя": "From the character",
  "Смена голоса пока недоступна": "Voice changing is currently unavailable",
  "Снять выбор": "Clear selection",
  "Сохранение исходного звука не подтверждено.": "Original audio preservation is not confirmed.",
  "Стать персонажем": "Become a character",
  "Сцена и движения берутся из видео; внешность может отличаться.": "The scene and movements come from the video; appearance may differ.",
  "Только свои фото или с согласием человека на фото": "Use only your own photos or photos with the person’s consent",
  "Фон": "Background",
  "Фото героя": "Character photo",
  "Фрагмент от {0} до {1} секунд": "Clip from {0} to {1} seconds",
  "{0} символов": "{0} characters",
  "Авито": "Avito",
  "Английский": "English",
  "Выберите аудио или видео": "Choose audio or video",
  "Выбрать": "Select",
  "Гарантия": "Warranty",
  "Да": "Yes",
  "Для чего нужен промпт": "Prompt purpose",
  "Для этого инструмента сократите текст до 500 символов.": "Shorten the text to 500 characters for this tool.",
  "Добавьте текст": "Add text",
  "Добавьте файл": "Add a file",
  "Дополнительные варианты": "More variants",
  "Дополнительные варианты пока не подтверждены.": "More variants are not confirmed yet.",
  "Дружелюбный": "Friendly",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "Upload a recording or record your voice. Transcription starts after confirmation.",
  "Исходное фото": "Source photo",
  "Как изменить текст": "How to change the text",
  "Комплект": "Package contents",
  "Короткий": "Short",
  "Материал": "Material",
  "Музыка": "Music",
  "На весь экран": "Full screen",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "Could not open the tool. Check your account and text length.",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "Could not confirm more variants. Check the same request.",
  "Не удалось скачать текст.": "Could not download the text.",
  "Не удалось скопировать текст.": "Could not copy the text.",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "Could not save the draft. Creation is blocked to prevent data loss.",
  "Нейтральный": "Neutral",
  "Нет": "No",
  "Объём описания": "Description length",
  "Описание товара": "Product description",
  "Повторить запрос с тем же ключом": "Retry with the same key",
  "Подарочный": "Gift",
  "Подробнее": "More detail",
  "Подробный": "Detailed",
  "Подтверждаю права на материалы": "I confirm my rights to the materials",
  "Пожелания": "Preferences",
  "Показать время": "Show timestamps",
  "Показать всё": "Show all",
  "Премиальный": "Premium",
  "Проверить тот же запрос": "Check the same request",
  "Продающий": "Sales-focused",
  "Промпт из видео пока недоступен.": "Video-to-prompt is not available yet.",
  "Промпт из фото": "Prompt from a photo",
  "Разделить по собеседникам": "Separate speakers",
  "Размеры": "Dimensions",
  "Распознавание по ссылке YouTube пока недоступно.": "Transcription from YouTube links is not available yet.",
  "Распознать": "Transcribe",
  "Редактировать текст": "Edit text",
  "Сайт": "Website",
  "Сбросить сохранённый черновик": "Reset saved draft",
  "Скачать TXT": "Download TXT",
  "Скопировать весь текст": "Copy all text",
  "Собеседник {0}": "Speaker {0}",
  "Создать промпт": "Create a prompt",
  "Создать сценарий": "Create a script",
  "Создаём текст": "Creating text",
  "Сократите пожелания": "Shorten your preferences",
  "Сократите текст": "Shorten the text",
  "Список": "List",
  "Текст готов": "Text is ready",
  "Текст из аудио и видео": "Text from audio and video",
  "Текст не создан": "Text was not created",
  "Тестовый режим без списания": "Test mode without charges",
  "Тон описания": "Description tone",
  "Улучшить промпт": "Improve a prompt",
  "Уход": "Care",
  "Что добавить в описание": "What to add to the description",
  "Экспертный": "Expert",
  "Язык": "Language",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "Add a photo in the opened tool.",
  "Не удалось открыть фото.": "Could not open the photo.",
  "Текст для видео": "Text for the video",
  "Цена этого выбора пока не подтверждена": "The price for this choice is not confirmed yet",
  "C за фото": "C per photo",
  "C за секунду": "C per second",
  "Обычный": "Default",
  "Кто повторил": "Performed by",
  "Человек с фото": "Person from the photo",
  "Сменить фон": "Change background",
  "Убрать лишнее": "Remove clutter",
  "Добавить очки": "Add glasses",
  "Причёска": "Hairstyle",
  "Улыбка": "Smile",
  "Деловой образ": "Business look",
  "Летний фон": "Summer background",
  "Машет рукой": "Waving",
  "Ветер": "Wind",
  "Плавнее": "Smoother",
  "Ярче": "Brighter",
  "День в ночь": "Day to night",
  "Снег": "Snow",
  "Очки": "Glasses",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "What should be in the photo? For example: a girl with an umbrella on a wet street, evening, shop window lights",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "What should change in the photo? For example: replace the background with a city at night, add glasses",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "What should be added or changed? For example: a business suit, a slight smile",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "What happens in the video? For example: the camera slowly flies over a city at night, lights and wet asphalt",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "How should it move? For example: smiling and waving, wind in the hair",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "What should change in the video? For example: replace the background with a city at night, add snow",
  "Что добавить? Например: движения плавнее, ярче": "What should be added? For example: smoother motion, brighter",
  "Сменить голос в записи": "Change the voice in a recording",
  "Загрузите запись": "Upload a recording",
  "Ваша речь зазвучит выбранным голосом": "Your speech will sound in the chosen voice",
  "Голосовое, интервью или заметку: уберём шум": "A voice message, interview or note: we’ll remove the noise",
  "Библиотека и ваши клоны": "Library and your clones",
  "Без переозвучки, выберите другой": "No voice conversion, choose another",
  "· Мой голос": "· My voice",
  "· ещё {0}+ голосов": "· {0}+ more voices",
  "Убрать шум": "Remove noise",
  "Перед сменой голоса уберём фон и эхо": "We’ll remove background and echo before changing the voice",
  "Оставим только голос, без фона и эха": "We’ll keep only the voice, without background or echo",
  "Голосовым или файлом: выберете, когда запись будет готова": "As a voice message or a file: you’ll choose when the recording is ready",
  "Сменить голос": "Change voice",
  "Сделать голосовым": "Make a voice message",
  "{0} · от {1} C": "{0} · from {1} C",
  "Сначала остановите запись": "Stop the recording first",
  "Загрузите или запишите аудио": "Upload or record audio",
  "Читаем запись, секунду": "Reading the recording, one moment",
  "Запись длиннее {0}, загрузите короче": "The recording is longer than {0}, upload a shorter one",
  "Выберите голос, которым зазвучит запись": "Choose the voice your recording will sound in",
  "Этот голос не умеет переозвучку, выберите другой": "This voice can’t convert recordings, choose another",
  "Пауза": "Pause",
  "Длиннее {0}": "Longer than {0}",
  "Звучит запись": "Playing the recording",
  "Прослушать запись": "Listen to the recording",
  "Загрузите запись короче": "Upload a shorter recording",
  "Запись с микрофона": "Microphone recording",
  "Без шума": "Noise-free",
  "Как в записи": "As in the recording",
  "Слушать": "Listen",
  "Отправить голосовым": "Send as a voice message",
  "Отправить файлом": "Send as a file",
  "Голосовое в чате": "Voice message in the chat",
  "Файл в чате": "File in the chat",
  "Голосовое в чате, в отдельной теме": "Voice message in the chat, in a separate topic",
  "Файл в чате, в отдельной теме": "File in the chat, in a separate topic",
  "Тут откроется тема чата, куда бот прислал голосовое": "This opens the chat topic where the bot sent the voice message",
  "Тут откроется тема чата, куда бот прислал запись": "This opens the chat topic where the bot sent the recording",
  "Меняем голос": "Changing the voice",
  "Собираем запись": "Assembling the recording",
  "Шум убран": "Noise removed",
  "Запись готова": "The recording is ready",
  "Голос изменён": "Voice changed",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "You can leave this screen: the bot will message you when the recording is ready.",
  "Голос ваш, шума больше нет.": "Your voice, no more noise.",
  "Голос ваш, запись готова стать голосовым.": "Your voice, and the recording is ready to become a voice message.",
  "Слова и интонация ваши, голос новый.": "Your words and intonation, a new voice.",
  "Пришлём в чат голосовым или файлом, как удобнее.": "We’ll send it to the chat as a voice message or a file, whichever you prefer.",
  "Запись ещё собирается": "The recording is still being assembled",
  "Заставить говорить": "Make it talk",
  "Заменить запись": "Replace the recording",
  "Загружаем запись": "Uploading the recording",
  "Запись загружена": "Recording uploaded",
  "Запись собрана": "Recording assembled",
  "Запись не прошла проверку": "The recording did not pass review",
  "запись не собрана": "the recording was not assembled",
  "голос не изменён": "the voice was not changed",
  "Не получилось убрать шум": "Couldn’t remove the noise",
  "Не получилось собрать запись": "Couldn’t assemble the recording",
  "Не получилось сменить голос": "Couldn’t change the voice",
  "Обновить форму": "Refresh the form",
  "Запись {0}": "Recording {0}",
  "Проверяем доступность": "Checking availability",
  "Загрузите запись заново": "Upload the recording again",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "Couldn’t select the voice. Try again.",
  "Запись здесь недоступна, загрузите файл": "Recording isn’t available here, upload a file",
  "Не удалось прочитать запись, попробуйте ещё раз": "Couldn’t read the recording, try again",
  "Ваш голос": "Your voice",
  "в аудио": "in the audio",
  "со скидкой, {0} водяной знак": "discounted, watermark {0}",
  "Запись ещё загружается": "The recording is still loading",
  "Проверяем отправку": "Checking delivery",
  "Этот способ отправки сейчас недоступен": "This delivery method isn’t available right now",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "Delivery isn’t confirmed yet. Tap again and we’ll check the same request.",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "Couldn’t hand over the recording. Open the work in “History” and try again.",
  "Попробовать ещё раз": "Try again",
  "Проверить ещё раз": "Check again",
  "К настройкам": "Back to settings",
  "Заказ не создан": "Order not created",
  "Заказ не подтверждён": "Order not confirmed",
  "остаток": "balance",
  "Права на материалы": "Rights to the materials",
  "Только свои файлы или с согласия владельца": "Only your own files or with the owner’s consent",
  "Загружаем файл": "Uploading the file",
  "Создаём": "Creating",
  "Файл больше {0} МБ, загрузите меньше": "The file is larger than {0} MB, upload a smaller one",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "The photo is smaller than {0} × {1} pixels, upload a larger one",
  "Видео длиннее {0}, загрузите короче": "The video is longer than {0}, upload a shorter one",
  "Запись короче {0}, загрузите длиннее": "The recording is shorter than {0}, upload a longer one",
  "Видео короче {0}, загрузите длиннее": "The video is shorter than {0}, upload a longer one",
  "Не удалось открыть фото. Загрузите его заново.": "Couldn’t open the photo. Upload it again.",
  "Не удалось открыть видео. Загрузите его заново.": "Couldn’t open the video. Upload it again.",
  "Можно до {0} фото": "Up to {0} photos",
  "Этот человек не участвует": "This person isn’t taking part",
  "Добавьте фото": "Add photos",
  "Файл не читается, загрузите другой": "The file can’t be read, upload another one",
  "Запись слишком короткая": "The recording is too short",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "Couldn’t open the recording for playback. Upload it again.",
  "Файл не прошёл проверку. Выберите другой файл.": "The file didn’t pass the check. Choose another file.",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "Too many uploads in a row. Wait a minute and choose the file again.",
  "Файл не принят. Выберите его снова.": "The file wasn’t accepted. Choose it again.",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "The selected character, voice or template is no longer available. Choose another one — the order was not created.",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "Creation is unavailable right now. The order was not created, no Circle was charged.",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "The previous work is still being created. When it’s ready, send the order again.",
  "Политику и запрещённые темы не пропускаем.": "We don’t allow politics or prohibited topics.",
  "{0} C списаны, {1}.": "{0} C were charged, {1}.",
  "{0} C вернулись на баланс.": "{0} C were returned to your balance.",
  ", на шаге «{0}»": ", at the “{0}” step",
  "Сбой на нашей стороне": "Something went wrong on our side",
  "{0} или {1}": "{0} or {1}",
  "до {0}": "up to {0}",
  "Записать": "Record",
  "Заменить": "Replace",
  "Нужна запись: MP3, WAV или M4A": "A recording is needed: MP3, WAV or M4A",
  "Нужно фото: JPG или PNG": "A photo is needed: JPG or PNG",
  "Нужно видео: MP4 или MOV": "A video is needed: MP4 or MOV",
  "Нужен файл PDF, DOCX или TXT": "A PDF, DOCX or TXT file is needed",
  "Нужно фото или видео": "A photo or video is needed",
  "Файл больше {0} МБ": "The file is larger than {0} MB",
  "Остановить запись": "Stop recording",
  "Запрашиваем микрофон": "Requesting the microphone",
  "Отменить запись": "Cancel recording",
  "{0} КБ": "{0} KB",
  "{0} МБ": "{0} MB",
  "Не хватает {0} C · Пополнить": "Need {0} more C · Top up",
  "Не хватает Circle": "Not enough Circle",
  "Не хватает {0} C": "Need {0} more C",
  "На балансе {0} C, нужно {1} C": "You have {0} C, {1} C needed",
  "Создать за {0} вместо {1} C": "Create for {0} instead of {1} C",
  "Создать за {0} C вместо {1} C": "Create for {0} C instead of {1} C",
  "Со скидкой всё равно не хватает {0}": "Even with the discount you need {0} more",
  "Со скидкой всё равно не хватает {0} C": "Even with the discount you need {0} C more",
  "Для этой работы скидки нет": "There’s no discount for this work",
  "Сделать дешевле на {0}%, с водяным знаком": "Make it {0}% cheaper, with a watermark",
  "Сделать дешевле на 10%, с водяным знаком": "Make it 10% cheaper, with a watermark",
  "Назад в студию": "Back to the studio",
  "Работа ещё создаётся": "The work is still being created",
  "Ваше фото": "Your photo",
  "Ваши фото": "Your photos",
  "Ваш текст": "Your text",
  "Ваша тема": "Your topic",
  "Тема поста": "Post topic",
  "Готовые кадры": "Finished shots",
  "Готовый кружок": "Finished video message",
  "Готовый ролик": "Finished video",
  "Готовое фото": "Finished photo",
  "Готовая аватарка": "Finished avatar",
  "Готовые слайды": "Finished slides",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "A ready-made story starring you: editing and music are already in the template",
  "Пост в стиле шаблона, {0} на выбор": "A post in the template’s style, {0} to choose from",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "An avatar for social networks and messengers, {0} to choose from",
  "Фотосессия из {0} кадра в стиле шаблона": "A photo shoot of {0} shot in the template’s style",
  "Фотосессия из {0} кадров в стиле шаблона": "A photo shoot of {0} shots in the template’s style",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "Your photo comes to life in a short video, {0} to choose from",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "A character says your text in a Telegram video message, {0} to choose from",
  "Карусель слайдов для поста, {0} на выбор": "A slide carousel for a post, {0} to choose from",
  "{0} стиль": "{0} style",
  "{0} стиля": "{0} styles",
  "{0} стилей": "{0} styles",
  "{0}, выберете на следующем шаге": "{0}, you’ll choose on the next step",
  "Что скажет герой, до 250 знаков": "What the character will say, up to 250 characters",
  "1 фото": "1 photo",
  "Любое, где хорошо видно лицо": "Any photo where the face is clearly visible",
  "Лицо крупно и при хорошем свете": "Face close-up, in good light",
  "Селфи, лицо крупно": "A selfie, face close-up",
  "Снимок оживёт в ролике": "The photo will come to life in a video",
  "Или фото, из которых сделаем слайды": "Or photos we’ll turn into slides",
  "Стиль кружка": "Video message style",
  "1 человек": "1 person",
  "Вы, близкие или персонаж": "You, a relative or a character",
  "Ваши дети, до {0}": "Your children, up to {0}",
  "Ребёнок, одно фото": "A child, one photo",
  "Питомец, одно фото": "A pet, one photo",
  "Вы или близкие, одно фото": "You or a relative, one photo",
  "По желанию: вы, близкие или персонаж": "Optional: you, a relative or a character",
  "По желанию: ваши дети, до {0}": "Optional: your children, up to {0}",
  "По желанию: ребёнок, одно фото": "Optional: a child, one photo",
  "По желанию: питомец, одно фото": "Optional: a pet, one photo",
  "По желанию: вы или близкие, одно фото": "Optional: you or a relative, one photo",
  "Reels": "Reels",
  "Аватар": "Avatar",
  "{0} кадр": "{0} shot",
  "{0} кадра": "{0} shots",
  "{0} кадров": "{0} shots",
  "Выбрать, кто играет: {0}": "Choose who performs: {0}",
  "Сравнить: {0} и {1}": "Compare: {0} and {1}",
  "Поровну": "Half and half",
  "Пример результата пока не опубликован": "The result example is not published yet",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "The result is saved in “History”. We don’t send it to the chat — that’s what you chose in the settings.",
  "Результат сохранён в «Истории».": "The result is saved in “History”.",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "The result file isn’t available yet. Check the work in “History”.",
  ", голос для: {0}": ", voice for: {0}",
  ", играет: {0}": ", plays: {0}",
  ": добавьте свои фото": ": add your photos",
  ": добавьте фото": ": add photos",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> of <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG or PNG, up to 10 MB",
  "JPG, PNG · до {0} снимков": "JPG, PNG · up to {0} shots",
  "MP3, WAV или M4A, до 50 МБ": "MP3, WAV or M4A, up to 50 MB",
  "MP4 или MOV, до 200 МБ": "MP4 or MOV, up to 200 MB",
  "PDF, DOCX или TXT, до 20 МБ": "PDF, DOCX or TXT, up to 20 MB",
  "{0} и {1}": "{0} and {1}",
  "{0} фото": "{0} photos",
  "{0} фото · как в жизни": "{0} photos · true to life",
  "{0}, персонаж": "{0}, character",
  "Анфас, вполоборота, с улыбкой и без": "Front-on, three-quarter, smiling and not",
  "Без модели": "No model",
  "Без сильных теней и фильтров": "No harsh shadows or filters",
  "Было": "Before",
  "В близких": "Saved in relatives",
  "В кадре {0}": "In the frame: {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "Already {0} of {1} in the frame: unselect someone",
  "В кадре: {0}": "In the frame: {0}",
  "В роли «{0}» не больше {1}": "No more than {1} in the role “{0}”",
  "В роль «{0}» персонажи не входят": "Characters can’t play the role “{0}”",
  "В роль «{0}» подходят {1}": "The role “{0}” fits {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "Variants are made from your photos in “Custom avatar”. The selected one appears in “Who’s in the frame” on every screen.",
  "Ваш питомец из близких": "Your pet from relatives",
  "Ваш ребёнок из близких": "Your child from relatives",
  "Ваши фото: один раз для всех инструментов": "Your photos: once for all tools",
  "Вкл": "On",
  "Впишите имя": "Enter a name",
  "Все <span class=\"mono\">{0}</span>": "All <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "All options are in view",
  "Все персонажи": "All characters",
  "Вы и персонажи": "You and characters",
  "Вы или персонаж": "You or a character",
  "Вы, близкие и персонажи": "You, relatives and characters",
  "Вы, свои фото": "You, your photos",
  "Вы: добавьте свои фото": "You: add your photos",
  "Выберите вариант": "Choose a variant",
  "Выберите вариант для поля «{0}»": "Choose an option for the field “{0}”",
  "Выберите ниже": "Choose below",
  "Выберите одного": "Choose one",
  "Выберите, кто играет: {0}": "Choose who plays: {0}",
  "Выберите, кто это для вас": "Choose who this is to you",
  "Выбирать во всех инструментах без загрузки": "Pick in every tool without uploading again",
  "Выбор встанет во все инструменты": "The choice applies to all tools",
  "Выбрать «{0}»": "Choose “{0}”",
  "Выбрать вариант": "Choose a variant",
  "Выбрать: {0}": "Choose: {0}",
  "Выкл": "Off",
  "Выключится, когда выберете вариант": "Turns off when you choose an option",
  "Группы": "Groups",
  "Добавить": "Add",
  "Добавить в кадр": "Add to the frame",
  "Добавьте свои фото": "Add your photos",
  "Добавьте свои фото или вариант": "Add your photos or a variant",
  "Добавьте фото: {0}": "Add photos: {0}",
  "Другой голос": "Another voice",
  "Ещё {0}: {1}": "{0} more: {1}",
  "Заготовки": "Presets",
  "Загрузите файл": "Upload a file",
  "Загрузить ещё": "Upload more",
  "Закрыть камеру": "Close camera",
  "Запись недоступна. Загрузите видео.": "Recording is unavailable. Upload a video.",
  "Здесь подходят {0}": "{0} fit here",
  "Здесь только персонажи своей подборки": "Only characters from this collection here",
  "Играет: {0}": "Plays: {0}",
  "Из ваших фото": "From your photos",
  "Из каталога": "From the catalog",
  "Изменить ваши фото": "Edit your photos",
  "Изменить свои фото": "Edit your photos",
  "Изменить: {0}": "Edit: {0}",
  "Иллюстрация": "Illustration",
  "Имя": "Name",
  "Имя и фото · роли выбираются в ряду": "Name and photos · roles are chosen in the row",
  "Искать стиль": "Search styles",
  "Каким вы будете": "How you’ll appear",
  "Камера · лицо в кадр": "Camera · face in the frame",
  "Камера · селфи в кадр": "Camera · selfie in the frame",
  "Камера недоступна · имитация": "Camera unavailable · simulation",
  "Камера недоступна. Загрузите файл.": "Camera unavailable. Upload a file.",
  "Каталог 2 400+ голосов, подборки": "Catalog of 2,400+ voices, collections",
  "Ко всем стилям": "Back to all styles",
  "Кто будет моделью на фото": "Who will be the model in the photo",
  "Кто играет: <b>{0}</b>": "Who plays: <b>{0}</b>",
  "Кто играет: {0}": "Who plays: {0}",
  "Кто это для вас": "Who is this to you",
  "Лицо в круг, смотрите в камеру": "Face in the circle, look at the camera",
  "Люди": "People",
  "Можно близких или персонажа": "Relatives or a character",
  "Можно ваших близких": "Your relatives",
  "Можно до {0} видео": "Up to {0} videos",
  "Можно до {0} записей": "Up to {0} recordings",
  "Можно до {0} записи": "Up to {0} recordings",
  "Можно до {0} запись": "Up to {0} recording",
  "Можно до {0} файл": "Up to {0} file",
  "Можно до {0} файла": "Up to {0} files",
  "Можно до {0} файлов": "Up to {0} files",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "This works, but 3 or more shots give a closer likeness",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "This works, but 3 or more photos give a closer likeness",
  "Можно себя или близких": "Yourself or relatives",
  "Можно себя, близких или персонажа": "Yourself, relatives or a character",
  "На этом экране вы в кадре всегда": "On this screen you’re always in the frame",
  "Навсегда, вместе с фото": "Permanently, with the photos",
  "Нажмите, чтобы выбрать": "Tap to choose",
  "Найти": "Find",
  "Напишите пару слов, и мы предложим варианты": "Write a few words and we’ll suggest options",
  "Например: Барсик": "For example: Max",
  "Например: Лёша": "For example: Alex",
  "Нашли": "Found",
  "Не получилось подготовить файл": "Couldn’t prepare the file",
  "Не получилось улучшить. Попробуйте дописать пару слов": "Couldn’t enhance it. Try adding a few words",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "Doesn’t fit<span class=\"nfx\">: up to {0} characters</span>",
  "Необязательно: всё уже настроено": "Optional: everything is already set up",
  "Ничего не нашлось": "Nothing found",
  "Нужно выбрать": "Needs a choice",
  "Объём": "Depth",
  "Один раз для всех инструментов": "Once for all tools",
  "Отменить свой вариант": "Cancel your own option",
  "Отметьте, кто будет в кадре · {0}": "Select who will be in the frame · {0}",
  "Персонажи": "Characters",
  "Подберём сами": "We’ll pick it for you",
  "Подбираем варианты": "Finding options",
  "Пожилой": "Senior",
  "Поиск стилей": "Style search",
  "Пока нечего сохранять": "Nothing to save yet",
  "Попробуйте другое слово": "Try another word",
  "Порядок здесь один": "There’s only one order here",
  "Примеры": "Examples",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "Will be removed {0} along with the photos. This can’t be undone.",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "Will be removed from relatives along with the photos. This can’t be undone.",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "Will be removed from relatives and {0} along with the photos. This can’t be undone.",
  "Профиль близкого": "Loved one’s profile",
  "Разные ракурсы и выражения": "Different angles and expressions",
  "Реалистичный": "Realistic",
  "Реалистичный, иллюстрация или 3D": "Realistic, illustration or 3D",
  "Роли": "Roles",
  "Роль «{0}»": "Role “{0}”",
  "Роль «{0}» для женского персонажа": "The role “{0}” is for a female character",
  "Роль «{0}» для мужского персонажа": "The role “{0}” is for a male character",
  "Роль «{0}» для персонажей своей подборки": "The role “{0}” is for characters from its collection",
  "Свой вариант": "Your own",
  "Скачать здесь не получится": "Downloading isn’t possible here",
  "Создайте новый вариант": "Create a new variant",
  "Сортировка": "Sort",
  "Сохранится в близких": "Will be saved to relatives",
  "Сохранить в близких": "Save to relatives",
  "Стало": "After",
  "Только для этой фотосессии": "Only for this photoshoot",
  "Удаление": "Deletion",
  "Удалить «{0}» {1}?": "Remove “{0}” {1}?",
  "Удалить «{0}» из близких?": "Remove “{0}” from relatives?",
  "Удалить из близких": "Remove from relatives",
  "Удалить из фотосессии": "Remove from the photoshoot",
  "Удерживайте, чтобы посмотреть примеры": "Hold to see examples",
  "Управление": "Management",
  "Файл готов. Нажмите ещё раз": "The file is ready. Tap again",
  "Фото до 10 МБ, видео до 200 МБ": "Photos up to 10 MB, videos up to 200 MB",
  "Фрагмент": "Clip",
  "Что делает? Например: поправляет шарф": "What are they doing? For example: adjusting a scarf",
  "Что делают в кадре": "What they do in the frame",
  "Эта настройка здесь закреплена": "This setting is fixed here",
  "Этот голос не умеет переозвучку записи": "This voice can’t re-voice a recording",
  "вариант «{0}»": "variant “{0}”",
  "взрослая": "adult",
  "взрослый": "adult",
  "всё видео умещается": "the whole video fits",
  "выберите": "choose",
  "до <span class=\"mono\">{0}</span>": "up to <span class=\"mono\">{0}</span>",
  "до {0} человек": "up to {0} people",
  "до {0} человека": "up to {0} people",
  "ещё {0} из {1}": "{0} of {1} left",
  "женская роль": "female role",
  "из фотосессии": "from the photoshoot",
  "из этой фотосессии": "from this photoshoot",
  "камера": "camera",
  "максимум {0} секунд": "maximum {0} seconds",
  "максимум {0} секунда": "maximum {0} second",
  "максимум {0} секунды": "maximum {0} seconds",
  "можно до <span class=\"mono\">{0}</span>": "up to <span class=\"mono\">{0}</span>",
  "мужская роль": "male role",
  "не из подборки этой роли": "not from this role’s collection",
  "не подходит по возрасту": "not the right age",
  "не участвует в этой фотосессии": "is not in this photoshoot",
  "необязательно": "optional",
  "нет фото": "no photos",
  "нужно выбрать": "needs a choice",
  "нужно: Вы": "needed: You",
  "персонажи в эту роль не входят": "characters can’t play this role",
  "питомец": "pet",
  "по желанию": "optional",
  "пожилая": "senior",
  "пожилой": "senior",
  "ребёнок": "child",
  "роль для взрослого": "role for an adult",
  "роль для женщины": "role for a woman",
  "роль для мужчины": "role for a man",
  "роль для питомца": "role for a pet",
  "роль для ребёнка": "role for a child",
  "роль для человека": "role for a person",
  "Попробуйте другое слово или сбросьте тему": "Try another word or clear the theme",
  "Искать среди {n}+ голосов": "Search {n}+ voices",
  "Голосов: {n}": "Voices: {n}",
  "Персонажей: {n}": "Characters: {n}",
  "Голосов: {0}": "Voices: {0}",
  "Прослушать {n}": "Play {n}",
  "Загружаем ещё {n}": "Loading {n} more",
  "{a} из {b}": "{a} of {b}",
  "Подборка": "Collection",
  "Закрыть подборку": "Close collection",
  "По имени": "By name",
  "Загружаем подборки…": "Loading collections…",
  "Не удалось загрузить голоса": "Couldn't load voices",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "Couldn't play the sample. Try again.",
  "Мой голос": "Mine",
  "Мои": "Mine",
  "Своих голосов пока нет": "No voices of your own yet",
  "Клонируйте свой голос, и он появится на этой вкладке.": "Clone your voice and it will show up here.",
  "Клонировать голос": "Clone voice",
  "Открыть персонажа {0}": "Open {0}",
  "От": "From",
  "Тренды недели": "Trending this week",
  "Голоса, которые быстрее всего набирают заказы": "Voices gaining orders fastest",
  "Мужские": "Male",
  "Все мужские голоса библиотеки": "All male voices in the library",
  "Женские": "Female",
  "Все женские голоса библиотеки": "All female voices in the library",
  "Детские": "Kids",
  "Детские и мультяшные голоса": "Kids' and cartoon voices",
  "меню: Озвучка": "Voices",
  "Системная": "System",
  "Для аватарки и ленты": "For avatars and the feed",
  "Как снимок с телефона": "Like a phone shot",
  "Для ленты": "For the feed",
  "На весь экран телефона": "Full phone screen",
  "Для обложки и экрана": "For covers and screens",
  "Станет голосом по умолчанию для озвучки.": "Becomes the default voice for voiceovers.",
  "Когда генерация закончится": "When a generation is done",
  "Награды и серия": "Rewards and streak",
  "Напомним о награде за день": "Daily reward reminder",
  "Новые шаблоны и стили": "New templates and styles",
  "Не чаще раза в неделю": "At most once a week",
  "Новости STEOS": "STEOS news",
  "Только крупные обновления": "Major updates only",
  "Тут откроется документ в браузере": "The document will open in your browser",
  "Язык и валюта": "Language & currency",
  "Интерфейс и цены картой": "Interface and card prices",
  "новое|новых|новых": "new|new",
  "работа|работы|работ": "work|works",
  "заказ|заказа|заказов": "order|orders",
  "Счётчики недоступны": "Counters unavailable",
  "История пуста": "History is empty",
  "Не задан": "Not set",
  "Недоступны": "Unavailable",
  "Срок истёк": "Expired",
  "Не удалась": "Failed",
  "Готовится": "Preparing",
  "Запрошено": "Requested",
  "Запрошено {0}": "Requested {0}",
  "Недоступно": "Unavailable",
  "Пусто": "Empty",
  "Данные Mini App удалены": "Mini App data deleted",
  "Удаление данных не удалось": "Data deletion failed",
  "Данные удалены частично": "Data partly deleted",
  "Удаление требует проверки": "Deletion needs review",
  "Запрос удаления принят": "Deletion request received",
  "Удаляем данные Mini App": "Deleting Mini App data",
  "Удаление данных в очереди": "Deletion queued",
  "STEOS ID сохранён": "STEOS ID kept",
  "Финансовые квитанции сохранены": "Financial receipts kept",
  "Статус удаления не подтверждён": "Deletion status not confirmed",
  "Удаление аккаунта": "Account deletion",
  "Удалить данные Mini App?": "Delete Mini App data?",
  "Удалить аккаунт?": "Delete account?",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Your works, voices and looks in the Mini App will be deleted. Your STEOS ID and financial receipts will be kept.",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "Your works, voices, looks and Circle will be deleted. This can't be undone.",
  "Удалить данные Mini App": "Delete Mini App data",
  "Удалить аккаунт": "Delete account",
  "Данные Mini App. STEOS ID сохранится": "Mini App data only. Your STEOS ID stays",
  "Все данные удалятся навсегда": "All data will be deleted for good",
  "В прототипе аккаунт не удаляется": "The prototype doesn't delete accounts",
  "Автовоспроизведение": "Autoplay",
  "Пример при выборе голоса": "Sample when you pick a voice",
  "Присылать в чат": "Send to chat",
  "Готовые работы от бота": "Finished works from the bot",
  "Уведомления и отклик": "Notifications & haptics",
  "Данные": "Data",
  "Выгрузить данные": "Export data",
  "Настройки создания сейчас только для чтения": "Creation settings are read-only right now",
  "Формат по умолчанию": "Default format",
  "Для новых фото и видео": "For new photos and videos",
  "На экране создания их можно поменять для одной работы.": "You can change it for a single work on the creation screen.",
  "Сообщения приходят в чат с ботом": "Messages arrive in your chat with the bot",
  "Бот напишет только в ответ на действия": "The bot will only reply to your actions",
  "Уведомления пока недоступны": "Notifications aren't available yet",
  "Вибрация": "Vibration",
  "Лёгкий отклик на нажатия": "Light feedback on taps",
  "Выгрузка данных": "Data export",
  "Выгрузка запрошена": "Export requested",
  "Пришлём архив в чат в течение суток": "We'll send the archive to your chat within 24 hours",
  "Настройки и доступные текстовые данные аккаунта": "Settings and available account text data",
  "Ссылка на архив придёт в чат с ботом": "The archive link will arrive in your chat with the bot",
  "Готовые работы и заказы": "Finished works and orders",
  "Клоны и записи образцов": "Clones and sample recordings",
  "Ваши фото и варианты себя": "Your photos and looks",
  "Люди и питомцы из фотосессий": "People and pets from photo shoots",
  "Запросить выгрузку": "Request export",
  "Готовим архив": "Preparing the archive",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "This takes a few minutes. You can close this, the export will continue",
  "Срок хранения архива истёк": "The archive has expired",
  "Запросите новую выгрузку данных": "Request a new data export",
  "Архив не собрался": "The archive couldn't be built",
  "Запросите выгрузку ещё раз": "Request the export again",
  "Не вошли: {0}": "Not included: {0}",
  "Вошли частично: {0}": "Partly included: {0}",
  "Не входят в выгрузку: {0}": "Not part of the export: {0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "Some data is unavailable. See manifest.json in the archive for the exact contents",
  "Архив готов, но не полностью": "Archive ready, but incomplete",
  "Архив готов": "Archive ready",
  "Скачать можно до {0}": "Available to download until {0}",
  "Архив в формате ZIP": "ZIP archive",
  "Скачать архив": "Download archive",
  "Счётчики истории не загрузились": "History counters didn't load",
  "Загружаем историю": "Loading history",
  "Проверьте связь и повторите загрузку": "Check your connection and try again",
  "История очищена": "History cleared",
  "Голоса, варианты «Вы», близкие и Circle на месте": "Your voices, looks, loved ones and Circle are still here",
  "Здесь появятся работы, когда вы что-то создадите": "Your works will show up here once you create something",
  "Раздел «История»": "History section",
  "Работы": "Works",
  "Фото, видео, кружки и озвучки": "Photos, videos, video messages and voiceovers",
  "Заказы": "Orders",
  "Параметры и статусы генераций": "Generation settings and statuses",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "Your voices, looks, loved ones and Circle stay.",
  "Удалить работы и заказы": "Delete works and orders",
  "Без возможности восстановления": "This can't be undone",
  "Подтверждение удаления": "Confirm deletion",
  "Попробовать: {0}": "Try: {0}",
  "Обновление": "Update",
  "Загружаем «Что нового»": "Loading What's new",
  "Новых обновлений пока нет": "No new updates yet",
  "Уведомления сейчас не сохранить": "Notifications can't be saved right now",
  "Настройки сейчас только для чтения": "Settings are read-only right now",
  "Выгрузка не запросилась. Попробуйте ещё раз": "Export request failed. Try again",
  "Удалить всю историю?": "Delete all history?",
  "{0}. Вернуть не получится.": "{0}. This can't be undone.",
  "История не очистилась. Попробуйте ещё раз": "History wasn't cleared. Try again",
  "Удаление не началось. Попробуйте ещё раз": "Deletion didn't start. Try again",
  "Не удалось загрузить настройки": "Couldn't load settings",
  "«Что нового» не загрузилось": "What's new didn't load",
  "Сохранение настроек сейчас недоступно": "Saving settings isn't available right now",
  "Настройки уже изменились, показываем актуальные": "Settings have changed, showing the latest",
  "Не удалось сохранить. Попробуйте ещё раз": "Couldn't save. Try again",
  "Настройки, ресурсы и история": "Settings, assets and history",
  "Данные Mini App": "Mini App data",
  "Учётная запись и финансовые данные STEOS ID": "STEOS ID account and financial data",
  "Переписка с ботом": "Chat with the bot",
  "Фото, аудио, видео и модели": "Photos, audio, videos and models",
  "Данные других продуктов STEOS": "Data from other STEOS products",
  "Рубли": "Rubles",
  "Драмы": "Drams",
  "Евро": "Euros",
  "Доллары": "Dollars",
  "Другие языки": "More languages",
  "Интерфейс и сообщения бота": "Interface and bot messages",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "Card prices are shown in this currency. Telegram Stars are the same everywhere.",
  "сегодня, {0}": "today, {0}",
  "вчера, {0}": "yesterday, {0}",
  "Старт": "Start",
  "Плюс": "Plus",
  "Про": "Pro",
  "Картой или СБП": "Card or SBP",
  "СБП только для РФ": "SBP is Russia only",
  "1 месяц": "1 month",
  "3 месяца": "3 months",
  "6 месяцев": "6 months",
  "Год": "Year",
  "год": "a year",
  "С днём рождения": "Happy birthday",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "Happy birthday. May everything you plan work out on the first try",
  "Просто так": "Just because",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "Just because. Here's to more video messages and funny voices",
  "Спасибо": "Thank you",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "Thanks for being there. A little gift from me",
  "С праздником": "Happy holidays",
  "С праздником. Твори, снимай и удивляй": "Happy holidays. Create, shoot and amaze",
  "Для блога": "For your blog",
  "Для твоего блога: пусть ролики выходят чаще и легче": "For your blog: more videos, less effort",
  "Удачи": "Good luck",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "Good luck with your new project. May the voice and visuals turn out just as planned",
  "картой": "by card",
  "оплата картой каждый месяц": "paid by card monthly",
  "оплата картой за {0}": "paid by card for {0}",
  "{0} в месяц": "{0} a month",
  "{0} за {1}": "{0} for {1}",
  "кружок|кружка|кружков": "video message|video messages",
  "рилс|рилса|рилсов": "reel|reels",
  "свой голос|своих голоса|своих голосов": "own voice|own voices",
  "своего голоса|своих голосов|своих голосов": "own voice|own voices",
  "день|дня|дней": "day|days",
  "звезда|звезды|звёзд": "star|stars",
  "Подписаться на {0}": "Subscribe for {0}",
  "Продлевается каждый месяц, отмена в любой момент": "Renews monthly, cancel anytime",
  "Без автопродления, Circle приходят каждый месяц": "No auto-renewal, Circle arrive monthly",
  "Перейти на {0}": "Switch to {0}",
  "Сразу придут {0} C, а {1} больше не продлится": "{0} C arrive now, and {1} won't renew",
  "Сразу придут {0} C": "{0} C arrive now",
  "Перейти на {0} с {1}": "Switch to {0} on {1}",
  "До {0} остаётся {1}, потом {2}": "{1} stays until {0}, then {2}",
  "Продлить на {0}": "Extend for {0}",
  "Ещё {0} после {1}, без автопродления": "{0} more after {1}, no auto-renewal",
  "Следующее списание {0}, {1}": "Next charge {0}, {1}",
  "Способ оплаты": "Payment method",
  "Звёздами": "With Stars",
  "Тестовая оплата": "Test payment",
  "Звёзды и деньги не списываются": "No Stars or money are charged",
  "Оплата картой скоро": "Card payment coming soon",
  "Ваш тариф": "Your plan",
  "выгоднее на {0}%": "{0}% better value",
  "{0} C в месяц": "{0} C a month",
  "или": "or",
  "Что сотворим в этом месяце?": "What will you create this month?",
  "Готовы творить без пауз?": "Ready to create nonstop?",
  "Ваш тариф {0}": "Your plan: {0}",
  "{0} C каждый месяц": "{0} C every month",
  "До {0} {1}": "Up to {0} {1}",
  "Пакеты Circle, если не хватит": "Circle packs if you need more",
  "{0} включает": "{0} includes",
  "Сравнить": "Compare",
  "Помесячно": "Monthly",
  "Выгода {0}": "Save {0}",
  "Одним платежом": "One payment",
  "{0} с {1}": "{0} from {1}",
  "Оставить {0}": "Keep {0}",
  "Продлить {0}": "Renew {0}",
  "Продлить": "Renew",
  "Включить продление": "Turn on renewal",
  "Возобновить {0}": "Resume {0}",
  "Возобновить": "Resume",
  "Оплата пока не подключена": "Payment isn't connected yet",
  "Сейчас недоступно": "Unavailable right now",
  "Переход на {0} на {1}": "Switch to {0} for {1}",
  "Переход на {0}": "Switch to {0}",
  "Продление {0} на {1}": "Extend {0} for {1}",
  "Подписка {0} на {1}": "{0} for {1}",
  "Как удобнее оплатить": "Choose how to pay",
  "Подарок друга": "Friend's gift",
  "{0} на первый пакет {1} после подписки": "{0} off your first pack for {1} after you subscribe",
  "Не загрузилось": "Didn't load",
  "Прошлую операцию не проверить": "Can't check the last operation",
  "разрешите хранение данных и откройте раздел снова": "allow data storage and reopen this section",
  "Оплата требует проверки": "Payment needs review",
  "Исход подтверждения оплаты ещё неизвестен": "Payment confirmation result is still unknown",
  "Исход отмены счёта неизвестен": "Invoice cancellation result is unknown",
  "Ждём подтверждения оплаты": "Waiting for payment confirmation",
  "Исход прошлой операции неизвестен": "Last operation result is unknown",
  "проверьте его перед новой покупкой": "check it before buying again",
  "Проверить": "Check",
  "Открыть оплату": "Open payment",
  "Отменить счёт": "Cancel invoice",
  "Продление отменено": "Renewal canceled",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "A message with the old invoice may still arrive. It doesn't confirm a new subscription",
  "Продление требует проверки": "Renewal needs review",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "Invoice not confirmed. Refresh or contact support",
  "Не удалось подготовить счёт": "Couldn't prepare the invoice",
  "Сервер повторит проверку. Текущие права не меняются": "The server will check again. Your current access stays the same",
  "Счёт отправлен": "Invoice sent",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "The bot sent an invoice. Your subscription starts once payment is confirmed",
  "Счёт подготовлен": "Invoice prepared",
  "Передан боту. Доставка и оплата ещё не подтверждены": "Handed to the bot. Delivery and payment aren't confirmed yet",
  "Срок счёта истёк": "Invoice expired",
  "Продление не оплачено. Выберите тариф ещё раз": "Renewal wasn't paid. Choose a plan again",
  "Запланированное продление отменено": "Scheduled renewal canceled",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "Your current plan stays. A new subscription needs a separate payment",
  "Продление запланировано": "Renewal scheduled",
  "Счёт на свою подписку придёт в конце подарочного месяца": "The invoice for your own subscription will arrive at the end of the gift month",
  "Подарок ещё действует": "Gift still active",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "A monthly plan will be available once it ends. For now you can extend for 3 or 12 months",
  "выберите другой тариф или срок": "pick another plan or period",
  "−{0}% на первый пакет · ещё {1}": "−{0}% on your first pack · {1} left",
  "Circle из пакетов не сгорают": "Circle from packs never expire",
  "Подарить другу": "Gift to a friend",
  "С открыткой, без продления": "With a card, no renewal",
  "Промокод {0}": "Promo code {0}",
  "{0} C, сгорят {1}": "{0} C, expire {1}",
  "Промокод применён": "Promo code applied",
  "{0} C и {1} на первый пакет": "{0} C and {1} off your first pack",
  "после подписки": "after you subscribe",
  "Вы пришли по ссылке партнёра": "You came via a partner link",
  "привязка уже действует": "the link is already active",
  "Есть промокод?": "Have a promo code?",
  "Загружаем тарифы": "Loading plans",
  "Счёт придёт {0}": "The invoice arrives {0}",
  "Счёт придёт в конце текущего срока": "The invoice arrives at the end of the current period",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "The new plan starts after payment. Nothing is charged now.",
  "Оплата подтверждена": "Payment confirmed",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "The paid period has already ended. Circle for past periods aren't credited.",
  "Баланс пополнен": "Balance topped up",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "Your balance is now {0} C. Circle from packs never expire",
  "следующие {0} C придут {1}": "the next {0} C arrive {1}",
  "До этой даты действует {0}": "{0} stays active until then",
  "{0} продлён до {1}": "{0} extended until {1}",
  "Circle приходят каждый месяц, {0}": "Circle arrive monthly, {0}",
  "Тариф {0} подключён": "{0} plan activated",
  "Подписка {0} оформлена": "{0} subscription started",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "Paid until {0}. Circle arrive monthly, {1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "Test subscription active until {0}. No Stars or money are charged",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Circle are valid until {0}, next charge then: {1}",
  "Circle действуют до {0}, продление выключено": "Circle are valid until {0}, renewal is off",
  "В месяц": "Per month",
  "Кружки или фото": "Video messages or photos",
  "Видео говорит": "Video Speaks",
  "Рилсы": "Reels",
  "Сравнение тарифов": "Plan comparison",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "Every plan: {0} {1} instead of {2}, all studio tools and Circle packs",
  "Следующее списание": "Next charge",
  "Сумма": "Amount",
  "Тестовая, без списаний": "Test, no charges",
  "Картой": "By card",
  "Оплачено до": "Paid until",
  "Действует до": "Active until",
  "Потом": "Then",
  "Продление": "Renewal",
  "Счёт на {0} запланирован": "{0} invoice scheduled",
  "подписку": "subscription",
  "Придёт {0}. Новый тариф начнётся после оплаты": "Arrives {0}. The new plan starts after payment",
  "Отменить": "Cancel",
  "Отменить подписку": "Cancel subscription",
  "Тариф останется до {0}": "Your plan stays until {0}",
  "Потом тариф {0}": "Then {0}",
  "Подарок на месяц": "One-month gift",
  "Оплачено вперёд": "Prepaid",
  "Подписка {0}": "{0} subscription",
  "Условия тарифа уточняются": "Plan details are being confirmed",
  "Сменить тариф": "Change plan",
  "Отмена подписки": "Cancel subscription",
  "Этот переход сейчас недоступен": "This switch isn't available right now",
  "Переход уже назначен": "Switch already scheduled",
  "Выберите другой тариф": "Pick another plan",
  "С {0} начнётся этот тариф": "This plan starts {0}",
  "Это ваш тариф": "This is your plan",
  "К подписке": "Back to subscription",
  "Сейчас {0}, {1}": "Now {0}, {1}",
  "Латиница, цифры и «_»": "Latin letters, digits and _",
  "Ник начинается с буквы": "Must start with a letter",
  "Не короче 5 знаков": "At least 5 characters",
  "Не длиннее 32 знаков": "At most 32 characters",
  "Ник не кончается на _": "Can't end with _",
  "Это ваш ник": "That's your username",
  "Сначала проверьте прежнюю операцию": "Check the previous operation first",
  "Подарок сейчас недоступен": "Gifting isn't available right now",
  "Укажите ник друга в Telegram": "Enter your friend's Telegram username",
  "Проверьте ник": "Check the username",
  "Друг увидит: {0}": "Your friend sees: {0}",
  "Подарок придёт без имени": "The gift arrives anonymously",
  "{0} дарит вам": "{0} is giving you",
  "вам подарили": "you've been given",
  "Вам подарили": "You've been given",
  "{0} подписку STEOS {1} на месяц.": "{0} a one-month STEOS {1} subscription.",
  "Забрать подарок": "Claim gift",
  "От друга": "From a friend",
  "{0} C и {1} {2}": "{0} C and {1} {2}",
  "Подарить {0}": "Gift {0}",
  "Тестовый подарок: звёзды и деньги не списываются": "Test gift: no Stars or money are charged",
  "На месяц, без продления": "For one month, no renewal",
  "Тариф подарка": "Gift plan",
  "Кому": "To",
  "ник друга в Telegram": "friend's Telegram username",
  "Ник друга в Telegram": "Friend's Telegram username",
  "Пожелание": "Message",
  "Пара тёплых слов, по желанию": "A few warm words, optional",
  "Подписать от меня": "Sign it from me",
  "Так увидит друг": "What your friend sees",
  "Подарок оформлен для {0}": "Gift set up for {0}",
  "Подарок отправлен {0}": "Gift sent to {0}",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "The bot sent a card with a “Claim gift” link in the caption.",
  "Месяц {0} начнётся, когда друг заберёт подарок": "The {0} month starts when your friend claims it",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "Friend hasn't opened STEOS yet? Forward the card yourself",
  "Переслать": "Forward",
  "Загружаем подарок": "Loading gift",
  "Вам подарок": "A gift for you",
  "Подписка STEOS на месяц": "One-month STEOS subscription",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "This gift is for {0}. Forward them the card with the link.",
  "Подарок уже получен": "Gift already claimed",
  "Подарок добавлен": "Gift added",
  "Подписка {0} подключена": "{0} subscription activated",
  "Circle подарка сгорят {0}": "Gift Circle expire {0}",
  "Месяц без продления, Circle действуют до {0}": "One month, no renewal, Circle valid until {0}",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "You already have {0}: the gift adds {1} C that expire in a month",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "You'll get {0} C and {1} {2}. It won't renew on its own",
  "За последние 7 дней": "Last 7 days",
  "Потрачено": "Spent",
  "Начислено": "Credited",
  "Пакеты пока недоступны": "Packs aren't available yet",
  "Пакет": "Pack",
  "Оплата пакетов пока не подключена": "Pack payments aren't connected yet",
  "Введите промокод": "Enter a promo code",
  "Применить": "Apply",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "Partner codes work until your first purchase; a STEOS code can be used once",
  "От партнёра или от STEOS": "From a partner or from STEOS",
  "Например, ANNA24": "For example, ANNA24",
  "Не удалось загрузить операции": "Couldn't load transactions",
  "Начисление": "Credit",
  "Списание": "Charge",
  "Загружаем операции": "Loading transactions",
  "Журнал STEOS ID": "STEOS ID log",
  "Операций пока нет": "No transactions yet",
  "Применение не подтверждено. Проверьте прежний запрос": "Not confirmed yet. Check the previous request",
  "Отменить подписку?": "Cancel subscription?",
  "Тариф {0} останется до {1}, потом не продлится.": "{0} stays until {1} and won't renew after that.",
  "Оставить": "Keep",
  "Не удалось подготовить открытку": "Couldn't prepare the card",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "Open the Mini App in Telegram to forward the card",
  "Отправка отменена": "Sending canceled",
  "Ссылка на подарок скопирована": "Gift link copied",
  "Не получилось. Попробуйте ещё раз": "That didn't work. Try again",
  "Счёт отменён": "Invoice canceled",
  "Оплата не завершена": "Payment not completed",
  "Подтверждение оплаты": "Payment confirmation",
  "Проверяем подтверждение оплаты": "Checking payment confirmation",
  "Проверяем отмену счёта": "Checking invoice cancellation",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "Telegram has started confirming the invoice. The result isn't known yet. Don't pay again: check this invoice or contact support.",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "The gift is set up once the server confirms. The month starts when your friend claims it. Returning from the payment window doesn't mean the payment is complete.",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle arrive once the server confirms. Returning from the payment window doesn't mean the payment is complete.",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle and your subscription appear once the server confirms. Returning from the payment window doesn't mean the payment is complete.",
  "Не удалось открыть оплату. Проверьте прежний запрос": "Couldn't open the payment. Check the previous request",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "Open the Mini App in Telegram to pay with Stars",
  "Оплата ещё не подтверждена сервером": "The server hasn't confirmed the payment yet",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "The card is ready. Open the Mini App in Telegram to forward it",
  "Отменить счёт?": "Cancel invoice?",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "Only this unpaid invoice is canceled. Your current subscription stays. If the payment is already being confirmed, the server won't allow canceling.",
  "Вернуться к оплате": "Back to payment",
  "{0} на первый пакет после подписки": "{0} off your first pack after you subscribe",
  "{0} на первый пакет, ещё {1}": "{0} off your first pack, {1} left",
  "{0} на первый пакет": "{0} off your first pack",
  "Промокод {0} применён": "Promo code {0} applied",
  "Circle сгорят {0}": "Circle expire {0}",
  "Circle начислены": "Circle credited",
  "Привязка к партнёру подтверждена": "Partner link confirmed",
  "Скидка {0}. Бонусные Circle сгорят {1}": "Discount: {0}. Bonus Circle expire {1}",
  "Привязка к партнёру действует": "Partner link is active",
  "{0} C и {1}": "{0} C and {1}",
  "Открытка передана боту для доставки.": "The card was handed to the bot for delivery.",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "The bot is preparing to deliver the card. You can also forward it yourself.",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "Card delivery isn't confirmed. You can forward it yourself.",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "Circle with an expiry are spent first (bonus and subscription), then the rest; withdrawable Circle go last.",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "Recipient not found among STEOS users. Check the username or ask your friend to start the bot.",
  "Условия оплаты изменились. Обновите данные.": "Payment terms have changed. Please refresh.",
  "Эту открытку может переслать только отправитель подарка.": "Only the gift sender can forward this card.",
  "Откройте чат с ботом и попробуйте ещё раз.": "Open the chat with the bot and try again.",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "Delivery to the recipient isn't confirmed. Forward the card yourself.",
  "Предложение не найдено. Обновите данные.": "Offer not found. Please refresh.",
  "Такого промокода нет": "No such promo code",
  "Срок действия промокода закончился": "This promo code has expired",
  "Этот промокод пока не действует": "This promo code isn't active yet",
  "Вы уже активировали этот промокод": "You've already used this promo code",
  "Промокод больше не действует": "This promo code is no longer valid",
  "Это ваш промокод": "That's your own promo code",
  "Партнёрские промокоды работают только до первой покупки": "Partner codes only work before your first purchase",
  "Промокод партнёра временно недоступен": "This partner code is temporarily unavailable",
  "Вы уже привязаны к партнёру": "You're already linked to a partner",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "The recipient changed. Cancel the previous unpaid invoice and check the username before buying again.",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "The message must be up to 200 characters, without control characters.",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "Check the username: the recipient must have started STEOS, and you can't gift yourself",
  "Получатель сейчас занят. Повторите позже": "The recipient is busy right now. Try again later",
  "Подарок не найден": "Gift not found",
  "Этот подарок предназначен другому пользователю": "This gift is meant for another user",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "Couldn't confirm the renewal terms. Refresh the plans.",
  "Подписка изменилась. Обновите данные перед новым продлением.": "Your subscription changed. Refresh before renewing again.",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "Renewal is already scheduled. You can cancel it in subscription settings.",
  "Запланированное продление отменено. Обновите данные.": "Scheduled renewal canceled. Please refresh.",
  "Счёт будет доступен в конце текущего срока.": "The invoice will be available at the end of the current period.",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "A monthly plan will be available after the gift ends. For now you can extend for 3 or 12 months.",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "The previous subscription change is still being checked. Check it again.",
  "Изменение подписки ещё не подтверждено Telegram.": "Telegram hasn't confirmed the subscription change yet.",
  "Подписка изменилась. Обновите данные и повторите проверку.": "Your subscription changed. Refresh and check again.",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "The discount is already tied to the previous invoice. Check its payment.",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "The invoice is already being confirmed or can't be canceled. Check the payment result.",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "Payment needs review. The server saved the payment, but access isn't confirmed yet. Don't pay again — check later or contact support.",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "Invoice canceled. No subscription or Circle were credited for it. You can start a new payment.",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "Payment not completed. Money and Circle aren't confirmed; you can start a new payment.",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "The card is being prepared. Tap Check to get the result of the previous request.",
  "Подарить подписку": "Gift a subscription",
  "Оплата подписки": "Subscription payment",
  "Итог оплаты": "Payment result",
  "Подарок": "Gift",
  "Пакет Circle": "Circle pack",
  "лента: Хит": "Top",
  "настройки: Очистить историю": "Clear history",
  "Разделы, которых нет в меню": "Sections not in the menu",
  "Базовый": "Basic",
  "Продвинутый": "Advanced",
  "Амбассадор": "Ambassador",
  "задание ждёт|задания ждут|заданий ждут": "task waiting|tasks waiting",
  ", до +{0} C": ", up to +{0} C",
  "Серия {0}, задания на сегодня": "{0} streak, today's tasks",
  "Задания на каждый день": "Daily tasks",
  "Всё созданное в одном месте": "Everything you've made in one place",
  "Пока пусто: всё созданное будет здесь": "Empty for now: your creations will appear here",
  "{0}, последняя {1}": "{0}, latest {1}",
  "тариф {0}": "{0} plan",
  "без подписки": "no subscription",
  "{0}, {1}% с покупок": "{0}, {1}% of purchases",
  "{0} уровень, {1}% с покупок": "{0} level, {1}% of purchases",
  "До {0}% с покупок друзей": "Up to {0}% of friends' purchases",
  "ИИ-агент ответит сразу": "AI agent replies instantly",
  "Черновики ролей и реплик": "Drafts of roles and lines",
  "Тема, язык и валюта": "Theme, language & currency",
  "{0} ждут": "{0} waiting",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Telegram will open a chat picker here: the bot joins the group and works there",
  "голос {0}": "voice {0}",
  "Искать в {0} {1}": "Search {0} {1}",
  "работе|работах|работах": "work|works",
  "Не прошло модерацию": "Failed moderation",
  "Бесплатно": "Free",
  "Цена недоступна": "Price unavailable",
  "Не удалось загрузить историю": "Couldn't load history",
  "Проверьте написание или поищите по номеру заказа": "Check the spelling or search by order number",
  "Проверьте написание или поищите по названию, голосу или персонажу": "Check the spelling or search by title, voice or character",
  "Сбросить поиск": "Clear search",
  "В этой вкладке пока пусто": "Nothing here yet",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "Tap the heart on a work to find it here quickly",
  "Новые работы этого вида появятся здесь сами": "New works of this type will appear here automatically",
  "Показать все": "Show all",
  "Поиск по истории": "Search history",
  "Что показать": "What to show",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "Round videos, photos, videos, voiceovers and texts you create",
  "Открыть студию": "Open Studio",
  "{0}: шаг {1} из {2}. Открыть": "{0}: step {1} of {2}. Open",
  "Шаг {0} из {1}": "Step {0} of {1}",
  "{0}: {1}. Открыть": "{0}: {1}. Open",
  "Раскладка": "Layout",
  "Широкий": "Wide",
  "Инструмент": "Tool",
  "голос|голоса|голосов": "voice|voices",
  "Как в оригинале": "As in original",
  "фото|фото|фото": "photo|photos",
  "слайд|слайда|слайдов": "slide|slides",
  "снимок|снимка|снимков": "photo|photos",
  "кадр|кадра|кадров": "shot|shots",
  "Длительность записи": "Recording length",
  "Цена": "Price",
  "Списание не подтверждено": "Charge not confirmed",
  "Кадры": "Frames",
  "знак|знака|знаков": "character|characters",
  "пункт|пункта|пунктов": "item|items",
  "фраза|фразы|фраз": "phrase|phrases",
  "человек|человека|человек": "person|people",
  "Смотреть видео": "Watch video",
  "символ|символа|символов": "character|characters",
  "Дорожка": "Track",
  "фрагмент 1:00": "1:00 clip",
  "вся песня": "whole song",
  "образец|образца|образцов": "sample|samples",
  "Свой голос": "Your own voice",
  "{0} C списаны": "{0} C charged",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "Still being created. The result will appear here and in the chat",
  "Проверяем результат. Обычно это занимает пару минут": "Verifying the result. This usually takes a couple of minutes",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "Failed moderation. We don't allow politics or banned topics. {0}",
  "Не прошло модерацию. {0}": "Failed moderation. {0}",
  "Не получилось. {0}": "Something went wrong. {0}",
  "Не получилось. {0} C вернулись на баланс": "Something went wrong. {0} C refunded to your balance",
  "Удалится только запись о заказе": "Only the order record will be deleted",
  "Удаление из истории": "Delete from history",
  "Смотреть: {0}": "Watch: {0}",
  "В этой работе нет файлов для просмотра": "This work has no files to view",
  "Вернуть запись в историю не получится.": "You won't be able to restore the record.",
  "Файл в чате останется. Вернуть работу в историю не получится.": "The file stays in the chat. You won't be able to restore the work.",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "Sending isn't confirmed yet. Tap again",
  "Принято": "Accepted",
  "Бот пришлёт результат в чат": "The bot will send the result to the chat",
  "Возврат обрабатывается": "Refund in progress",
  "Не списано": "Not charged",
  "Circle не списаны": "No Circle charged",
  "Circle вернулись на баланс": "Circle refunded to your balance",
  "Списание пока не подтверждено": "Charge not confirmed yet",
  "Возврат не подтверждён": "Refund not confirmed",
  "Ожидаем подтверждения оплаты": "Awaiting payment",
  "история: Повторить": "Repeat",
  "история: Кружки": "Video messages",
  "Фотосессия из селфи": "Selfie photo shoot",
  "Рилс с вами": "Reels with you",
  "Фото говорит": "Photo Speaks",
  "Слайды с преимуществами": "Benefit slides",
  "Карусель для поста": "Post carousel",
  "Коллаж из фото": "Photo collage",
  "Карточка для маркетплейса": "Marketplace card",
  "шаг|шага|шагов": "step|steps",
  "вопрос|вопроса|вопросов": "question|questions",
  "Открыть": "Open",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "The answer to this question wasn’t confirmed. If it matters, contact support: {0}.",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "The answer to this question wasn’t confirmed. If it matters, contact support.",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "No answer yet. We’ll check the same question — it won’t be sent twice.",
  "Открыть профиль": "Open profile",
  "Войти через STEOS ID": "Sign in with STEOS ID",
  "Тут Telegram откроет выбор чата": "Telegram will open chat selection here",
  "Разделы поддержки": "Support sections",
  "Ответит сразу": "Replies instantly",
  "Отвечает сразу": "Replies instantly",
  "Поддержка в Telegram, {0}": "Support on Telegram, {0}",
  "Поддержка в Telegram": "Support on Telegram",
  "Видео медленнее обычного": "Video is slower than usual",
  "Видео работает медленнее обычного": "Video is slower than usual",
  "Спросить ИИ‑агента поддержки": "Ask the AI support agent",
  "Отвечает сразу и знает всё о STEOS": "Replies instantly and knows all about STEOS",
  "Поиск по вопросам и инструкциям": "Search questions and instructions",
  "Шесть коротких сторис о главном": "Six short stories on the basics",
  "Попробуйте другие слова или спросите ИИ-агента": "Try other words or ask the AI agent",
  "Проверено в {0}": "Checked at {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "Orders aren’t lost: the result will arrive in the chat, and if something fails, the Circle will return to your balance.",
  "Сервисы": "Services",
  "Загружаем статус сервисов": "Loading service status",
  "Загружаем справку": "Loading help",
  "Статус не загрузился": "Status didn’t load",
  "Статус сервисов пока не отслеживается": "Service status isn’t tracked yet",
  "Если что-то не работает, напишите в поддержку": "If something isn’t working, contact support",
  "Часть сервисов работает с перебоями": "Some services are having issues",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "Check the status of your works and confirmed refunds in History.",
  "Справка не загрузилась": "Help didn’t load",
  "Справка пока не опубликована": "Help isn’t published yet",
  "Вопрос можно задать поддержке в Telegram": "You can ask support on Telegram",
  "Инструкции появятся после публикации справки": "Instructions will appear once help is published",
  "Назад к ИИ-агенту": "Back to the AI agent",
  "Инструкция · {0}": "Guide · {0}",
  "Вопрос · {0}": "Question · {0}",
  "Справка": "Help",
  "Вопрос из Справки": "Question from Help",
  "Подробнее из Справки": "More from Help",
  "Назад по таблице": "Scroll table back",
  "Вперёд по таблице": "Scroll table forward",
  "Здравствуйте, {0}.": "Hello, {0}.",
  "Здравствуйте.": "Hello.",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "I’m the STEOS AI support agent: I can help with plans and Circle, tools and templates, promo codes, STEOS ID and the partner program. Ask in your own words or pick a question.",
  "ИИ-агент печатает": "AI agent is typing",
  "ИИ-агент ещё отвечает": "The AI agent is still replying",
  "Напишите вопрос": "Type a question",
  "Диалог с ИИ-агентом": "Conversation with the AI agent",
  "Распознаём…": "Recognizing…",
  "Слушаю": "Listening",
  "Спросите о STEOS": "Ask about STEOS",
  "Вопрос ИИ-агенту": "Question for the AI agent",
  "Остановить диктовку": "Stop dictation",
  "Сказать голосом": "Dictate",
  "Отправить": "Send",
  "Не удалось начать новый чат": "Couldn’t start a new chat",
  "Спасибо, учтём": "Thanks, noted",
  "Спасибо, передадим команде": "Thanks, we’ll pass it on to the team",
  "Оценка не сохранилась": "Rating wasn’t saved",
  "Чат ещё загружается": "Chat is still loading",
  "В чате уже {0} вопросов. Начните новый": "This chat already has {0} questions. Start a new one",
  "Вопрос не сохранился. Попробуйте ещё раз": "The question wasn’t saved. Try again",
  "Некоторые сервисы работают медленнее обычного": "Some services are slower than usual",
  "{0} не работают": "{0} are down",
  "{0} не работает": "{0} is down",
  "{0} медленнее обычного": "{0} is slower than usual",
  "{0} работают медленнее обычного": "{0} are slower than usual",
  "{0} работает медленнее обычного": "{0} is slower than usual",
  "Микрофон здесь недоступен": "Microphone isn’t available here",
  "Нет доступа к микрофону": "No microphone access",
  "Нужна запись от 1 до 30 секунд": "The recording must be 1 to 30 seconds long",
  "Не удалось разобрать запись": "Couldn’t make out the recording",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "Dictation wasn’t recognized. Tap the microphone to check again",
  "Вопрос не подошёл. Сформулируйте иначе": "This question didn’t work. Try rephrasing it",
  "Ответ не подтвердился. Напишите в поддержку": "The answer wasn’t confirmed. Contact support",
  "Ответ не пришёл. Проверьте ещё раз": "No answer came. Check again",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "Talking round video, Video Speaks, Photo Speaks, Repeat the movements, custom avatar",
  "Оживить фото, видео по описанию, рилсы и сцены": "Animate photo, video from a description, reels and scenes",
  "Фото, фотосессии, товары, карусели": "Photos, photo shoots, products, carousels",
  "Голоса, клон, озвучка проектов, кавер": "Voices, clone, script voiceover, cover",
  "Звёзды Telegram и карты": "Telegram Stars and cards",
  "Не работает": "Down",
  "Как сделать по шагам": "Step by step",
  "Полезный ответ": "Helpful answer",
  "Ответ не помог": "Not helpful",
  "Проверьте связь и попробуйте ещё раз": "Check your connection and try again",
  "Не удалось проверить владельца чата": "Couldn’t verify the chat owner",
  "Не удалось восстановить чат. Начните новый": "Couldn’t restore the chat. Start a new one",
  "Клоны для озвучки": "Clones for voiceovers",
  "Создайте первый голос": "Create your first voice",
  "Люди и питомцы для фото": "People and pets for photos",
  "Добавьте близких для фото": "Add loved ones for photos",
  "Сохранённые работы": "Saved works",
  "Отмечайте работы сердцем": "Heart works to keep them here",
  "Ежедневная серия и бонусы": "Daily streak and bonuses",
  "Частые вопросы и связь с нами": "FAQ and contact us",
  "Обучается": "Training",
  "Аккаунт недоступен": "Account unavailable",
  "Эта неделя · {0}": "This week · {0}",
  "Неделя с {0} · {1}": "Week of {0} · {1}",
  "ID скопирован": "ID copied",
  "Скопировать ID": "Copy ID",
  "Баланс временно недоступен": "Balance temporarily unavailable",
  "Разбивка остатка временно недоступна": "Balance breakdown temporarily unavailable",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "Of these, {0} C expires on {1}|Of these, {0} C expire on {1}",
  "Ближайшие {0} C сгорят {1}": "Next {0} C expire on {1}",
  "Circle каждый месяц от {0}": "Circle every month from {0}",
  "Circle каждый месяц с подпиской": "Circle every month with a subscription",
  "Тариф временно недоступен": "Plan temporarily unavailable",
  "Аккаунт, подписка и баланс": "Account, subscription and balance",
  "Статистика и моё": "Statistics and Mine",
  "{0} к прошлой неделе": "{0} vs last week",
  "Работы по неделям: на этой неделе {0}": "Works by week: {0} this week",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "Works by week: {0} this week, {1} last week",
  "Статистика пока недоступна": "Statistics not available yet",
  "Дата регистрации недоступна": "Sign-up date unavailable",
  "С {0}": "Since {0}",
  "Создано": "Created",
  "Серия": "Streak",
  "день подряд|дня подряд|дней подряд": "day in a row|days in a row",
  "Общий аккаунт STEOS": "Shared STEOS account",
  "Для вывода Circle": "To withdraw Circle",
  "До {0}% с их покупок": "Up to {0}% of their purchases",
  "Обновлено {0}": "Updated {0}",
  "Действия": "Actions",
  "Сохранить имя": "Save name",
  "Новое имя": "New name",
  "Больше голосов с подпиской": "More voices with a subscription",
  "Создание голосов пока недоступно": "Voice creation isn’t available yet",
  "Свободных мест нет": "No free slots",
  "с подпиской до {0}": "up to {0} with a subscription",
  "Пауза «{0}»": "Pause “{0}”",
  "Прослушать «{0}»": "Play “{0}”",
  "Переименовать": "Rename",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "Record 2 seconds of speech or upload files, and the voice will sound like you",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "No free slots. Delete a voice to record a new one",
  "Выбрать за «Вы»": "Use as “You”",
  "голос по умолчанию": "default voice",
  "Сделать кружок с вариантом «{0}»": "Make a round video with the look “{0}”",
  "Выбраны": "Selected",
  "{0} фото|{0} фото|{0} фото": "{0} photo|{0} photos",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} photo · for all tools|{0} photos · for all tools",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} look · round videos, photos, videos|{0} looks · round videos, photos, videos",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} look|{0} looks",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "Voice {0} was deleted, so the look {1} now uses the default voice.",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "Voices were deleted, so the looks {0} now use the default voice.",
  "Другой голос можно выбрать у каждого кружка": "You can pick another voice for each round video",
  "Вариантов пока нет": "No looks yet",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "Upload your photos, and your look will speak in your voice in round videos, photos and videos",
  "Вы: свои фото и варианты": "You: your photos and looks",
  "добавьте фото": "add photos",
  "Изменить «{0}»": "Edit “{0}”",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} loved one · for photos and videos|{0} loved ones · for photos and videos",
  "Люди и питомцы для фото и видео": "People and pets for photos and videos",
  "Близких пока нет": "No loved ones yet",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "Add people and pets with photos, and they’ll appear in the frame next to you",
  "Открыть в «Истории»": "Open in History",
  "Вернуть в избранное": "Add back to favorites",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "{0} hearted work|{0} hearted works",
  "Отмеченные сердцем работы": "Works you hearted",
  "Открыть «Историю»": "Open History",
  "Не удалось загрузить избранное": "Couldn’t load favorites",
  "Закройте лист и откройте его ещё раз": "Close this sheet and open it again",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "Heart works in History, and they’ll gather here",
  "Не удалось обновить. Попробуйте позже": "Couldn’t update. Try again later",
  "Удалить голос «{0}»?": "Delete voice “{0}”?",
  "Голос пропадёт из списка. Вернуть его не получится.": "The voice will disappear from the list. You can’t restore it.",
  "Удалить вариант «{0}»?": "Delete look “{0}”?",
  "За «Вы» снова встанут ваши фото.": "Your photos will be used as “You” again.",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "Finished round videos and photos with it stay in History. You can’t restore the look.",
  "Не удалось удалить голос": "Couldn’t delete the voice",
  "Не удалось удалить вариант. Попробуйте ещё раз": "Couldn’t delete the look. Try again",
  "«{0}»": "“{0}”",
  "подписка: до {0}": "until {0}",
  "варианты «Вы»: Новый вариант": "New look",
  "в очереди": "queued",
  "идёт": "in progress",
  "завершено": "completed",
  "не удалось": "failed",
  "слово подтверждения: УДАЛИТЬ": "DELETE",
  "Выгрузка: {0}": "Export: {0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "Deletion: {0}. STEOS ID and financial receipts are kept.",
  "Введите {0}": "Type {0}",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "Transfer not confirmed yet. We’ll keep checking — open this sheet later",
  "Этот STEOS ID уже связан с другим Telegram": "This STEOS ID is already linked to another Telegram account",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "Both accounts have a subscription. Contact support to merge them",
  "Слишком много попыток. Попробуйте позже": "Too many attempts. Try again later",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "STEOS ID connection is unavailable right now. Try again later",
  "Не удалось создать аккаунт. Попробуйте позже": "Couldn’t create the account. Try again later",
  "Не удалось отправить письмо": "Couldn’t send the email",
  "Фото не подошло. Выберите другое": "This photo didn’t work. Choose another one",
  "Загрузите фото заново": "Upload the photo again",
  "Данные изменились. Откройте заново": "The data has changed. Open it again",
  "подряд": "in a row",
  "Начните {0}": "Start {0}",
  "серию": "a streak",
  "Завтра +{0} C": "Tomorrow +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "Come back every day: the reward grows, up to {0} C on day seven. Missing a day restarts the streak.",
  "Забрать {0} C": "Claim {0} C",
  "Прогресс": "Progress",
  "Заданий здесь пока нет": "No tasks here yet",
  "Время обновления недоступно": "Refresh time unavailable",
  "Новые через {0}": "New in {0}",
  "Выполнено {0} из {1}": "{0} of {1} done",
  "друг|друга|друзей": "friend|friends",
  "{0} с вами": "{0} joined",
  "Прогресс друзей недоступен": "Friend progress unavailable",
  "Пригласить": "Invite",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "Friends count once they join via your link or promo code and create their first work",
  "Ещё {0} {1} до награды {2}": "{0} more {1} to get {2}",
  "Все ступени пройдены": "All steps completed",
  "Получено {0} из {1}": "{0} of {1} claimed",
  "Задания": "Tasks",
  "покупатель|покупателя|покупателей": "buyer|buyers",
  "Партнёрская программа": "Partner program",
  "Партнёрам": "For partners",
  "До {0}% {1}": "Up to {0}% {1}",
  "с покупок друзей": "of friends' purchases",
  "Заработано {0} с покупок {1} {2}": "Earned {0} from purchases by {1} {2}",
  "друга|друзей|друзей": "friend|friends",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "Your choice: more of STEOS or income from referrals.",
  "Ещё {0} до уровня {1}": "{0} to go to {1}",
  "Максимальный уровень: вывод через STEOS ID": "Top level: withdraw via STEOS ID",
  "Статистика, материалы и вывод": "Stats, materials and withdrawals",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "The previous reward request needs checking. New rewards are on hold for now",
  "Загружаем награды": "Loading rewards",
  "Награды не загрузились": "Rewards didn't load",
  "Создайте 3 работы": "Create 3 works",
  "Сделайте кружок": "Make a round video",
  "Персонаж или вы сами": "A character or yourself",
  "Озвучьте текст": "Voice a text",
  "Голосом героя или клона": "In a character's or clone's voice",
  "Улучшите описание": "Improve a description",
  "Бот допишет детали": "The bot adds the details",
  "Отправьте работу": "Share a work",
  "Из «Истории» в любой чат": "From History to any chat",
  "Неделя кружков": "Round video week",
  "Создайте 10 кружков за неделю": "Create 10 round videos in a week",
  "Исследователь": "Explorer",
  "Попробуйте 5 разных инструментов студии": "Try 5 different Studio tools",
  "Первый кружок": "First round video",
  "Видеокружок для Telegram": "A round video for Telegram",
  "Клон голоса": "Voice clone",
  "Всего 2 секунды речи": "Just 2 seconds of speech",
  "Первое фото": "First photo",
  "Портрет в любом стиле": "A portrait in any style",
  "Первый рилс с вами": "Your first Reel",
  "Шаблон одной кнопкой": "One-tap template",
  "Первый кавер": "First cover",
  "Песня другим голосом": "A song in another voice",
  "Кружки и видео с вами": "Round videos and videos with you",
  "С вашей ссылкой": "With your link",
  "Бот в чате": "Bot in a chat",
  "Добавьте бота в группу": "Add the bot to a group",
  "Вход в STEOS ID": "Sign in with STEOS ID",
  "Один аккаунт с сайтом": "One account with the website",
  "Первый друг": "First friend",
  "3 друга": "3 friends",
  "10 друзей": "10 friends",
  "25 друзей": "25 friends",
  "Первый покупатель": "First buyer",
  "Первая оплата друга": "A friend's first payment",
  "{0} мин": "{0} min",
  "{0} ч": "{0} h",
  "Последний день": "Last day",
  "Ещё {0} {1}": "{0} {1} left",
  "Это задание выполняется вне мини-приложения": "This task is done outside the Mini App",
  "Задание пока недоступно": "Task not available yet",
  "Прогресс временно недоступен": "Progress temporarily unavailable",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "Couldn't restore the previous reward request. Check your balance and contact support",
  "Награды временно недоступны. Попробуйте обновить данные": "Rewards are temporarily unavailable. Try refreshing",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "Reward confirmed. Refresh the data: no need to claim again",
  "Задание ещё не выполнено. Обновите прогресс": "Task not completed yet. Refresh your progress",
  "Награда уже получена. Обновите данные": "Reward already claimed. Refresh the data",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "Reward not confirmed. Check the previous request: new rewards are on hold",
  "Сначала обновите данные наград": "Refresh the rewards first",
  "Сначала проверьте прежний запрос награды": "Check the previous reward request first",
  "Рассказчик": "Narrator",
  "Встреча на тракте": "Meeting on the Road",
  "Геральт": "Geralt",
  "Цири": "Ciri",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "It had been raining for three days, and the road to the fortress had almost vanished under the mud.",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "You went ahead without me again. I asked you to wait by the bridge.",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "I waited. A whole hour. Then I figured you'd got lost.",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "Witchers don't get lost. Sometimes we take the long way.",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "Then next time pick it faster. I'm freezing.",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "Silently, he took off his cloak and put it over her shoulders. The lights of the fortress were already in sight.",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "Come on. Vesemir has surely put the soup on the fire by now.",
  "Опять ты?": "You again?",
  "Мне нужна помощь": "I need help",
  "Вставьте сценарий или начните с нуля": "Paste a script or start from scratch",
  "Напишите хотя бы одну реплику": "Write at least one line",
  "Сократите реплику: до {0} знаков": "Shorten the line: up to {0} characters",
  "Сократите проект: до {0} знаков": "Shorten the project: up to {0} characters",
  "Озвучка проектов временно недоступна": "Script voiceover is temporarily unavailable",
  "Выберите голос для каждой роли": "Choose a voice for each role",
  "Озвучить · {0} C": "Generate voice · {0} C",
  "Без названия": "Untitled",
  "Роль": "Role",
  "вчера": "yesterday",
  "Проекты": "Projects",
  "роль|роли|ролей": "role|roles",
  "реплика|реплики|реплик": "line|lines",
  "Нет реплик": "No lines",
  "{0} знаков": "{0} characters",
  "Строки «Имя: реплика» сами станут ролями и голосами": "Lines like “Name: line” become roles and voices",
  "Начать с нуля": "Start from scratch",
  "Роли и реплики добавите сами": "Add roles and lines yourself",
  "Открыть пример": "Open an example",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "Projects save automatically: come back to them any time",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "A role named after a character gets that character's voice: Geralt, Ciri, Yennefer",
  "Переименовать проект": "Rename project",
  "Загрузить свежую": "Load latest",
  "{0}: голос {1}. Сменить голос": "{0}: voice {1}. Change voice",
  "Действия с ролью": "Role actions",
  "Озвучиваем": "Generating voice",
  "Действия с репликой": "Line actions",
  "Реплика: {0}": "Line: {0}",
  "Реплик пока нет": "No lines yet",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "Tap “Line” below or paste a ready script",
  "Реплика": "Line",
  "за проект": "per project",
  "Цена — по числу знаков": "Price depends on character count",
  "Добавить реплику": "Add line",
  "проект|проекта|проектов": "project|projects",
  "{0} {1} · сохраняются сами": "{0} {1} · saved automatically",
  "Пока ни одного": "None yet",
  "Новый проект": "New project",
  "Вставить сценарий или начать с нуля": "Paste a script or start from scratch",
  "Удаление проекта": "Delete project",
  "Новая роль": "New role",
  "Это первая реплика": "This is the first line",
  "Это последняя реплика": "This is the last line",
  "Удалить роль": "Delete role",
  "Вместе с её репликами": "Along with its lines",
  "В проекте нужна хотя бы одна роль": "A project needs at least one role",
  "Удалить роль «{0}»?": "Delete role “{0}”?",
  "Вместе с ней уйдут {0} {1}.": "This also deletes {0} {1}.",
  "Удалить проект?": "Delete project?",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}. Roles and lines will be deleted; the project can't be restored.",
  "Выбор голоса откроется в приложении": "Voice selection opens in the app",
  "Не удалось удалить проект: {0}": "Couldn't delete the project: {0}",
  "Не получилось открыть аудио": "Couldn't open the audio",
  "Не получилось включить звук": "Couldn't play the sound",
  "Сначала напишите текст реплики": "Write the line text first",
  "Аудио реплики пока недоступно": "Line audio isn't available yet",
  "Готовим роли": "Preparing roles",
  "Роли готовы": "Roles ready",
  "Озвучиваем реплики": "Voicing lines",
  "Реплики озвучены": "Lines voiced",
  "Собираем дорожку": "Assembling the track",
  "Дорожка собрана": "Track assembled",
  "дубль {0}": "take {0}",
  "Время реплики пока недоступно": "Line timing isn't available yet",
  "Общий файл · {0}": "Combined file · {0}",
  "Аудио пока недоступно": "Audio isn't available yet",
  "Слушать дорожку": "Play track",
  "реплика {0} из {1}": "line {0} of {1}",
  "Проект не озвучен": "Project not voiced",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "You can leave this screen: voicing will continue, and the track will appear here and in History.",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "You can leave this screen: the bot will message you when the track is ready.",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "Send the combined file to the chat or download it. Any line can be re-voiced separately.",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "The bot has already sent the combined file to a separate topic in the chat. Any line can be re-voiced separately.",
  "Сценарий не прошёл проверку": "Script didn't pass review",
  "проект не озвучен": "project not voiced",
  "Не получилось собрать дорожку": "Couldn't assemble the track",
  "К сценарию": "Back to script",
  "Звук дорожки не загрузился: скачайте файл": "Track audio didn't load: download the file",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "Each line on a new row: name, colon, text. A row without a name goes to the previous role",
  "голос персонажа": "character voice",
  "Заменить сценарий": "Replace script",
  "Сейчас {0} {1}, они уйдут": "Currently {0} {1}; they will be removed",
  "реплику|реплики|реплик": "line|lines",
  "Заменить на {0} {1}": "Replace with {0} {1}",
  "Добавить {0} {1}": "Add {0} {1}",
  "Заменить реплики": "Replace lines",
  "Добавить реплики": "Add lines",
  "Не нашли реплик: имя, двоеточие, текст": "No lines found: name, colon, text",
  "Вставьте сценарий в поле": "Paste the script into the field",
  "Роли и голоса появятся сами": "Roles and voices appear automatically",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "Geralt: You again. What is it this time?\nCiri: I need your help.",
  "Сейчас нельзя": "Not available right now",
  "Вставьте текст в поле": "Paste the text into the field",
  "Загружаем проекты": "Loading projects",
  "Проекты не загрузились": "Projects didn't load",
  "Не хватает Circle: пополните баланс": "Not enough Circle: top up your balance",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "Price: {0} C. Tap again to generate voice",
  "Не удалось посчитать цену. Попробуйте ещё раз": "Couldn't calculate the price. Try again",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "The script didn't pass review. Edit the text and try again.",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "Couldn't assemble the track. If Circle was deducted, it will be returned to your balance.",
  "Запуск не подтверждён": "Start not confirmed",
  "Не получилось собрать дорожку.": "Couldn't assemble the track.",
  "Повторная проверка не спишет Circle дважды.": "Checking again won't charge Circle twice.",
  "Отправили в чат": "Sent to chat",
  "Отправка принята: бот пришлёт дорожку в чат": "Request accepted: the bot will send the track to the chat",
  "Прослушивание реплики пока недоступно": "Line preview isn't available yet",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "Listen to line: {0} C. Tap again",
  "Переозвучка реплики пока недоступна": "Re-voicing a line isn't available yet",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "Re-voice line: {0} C. Tap again",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "Saving projects is unavailable right now. Refresh the data.",
  "Изменение проектов сейчас недоступно. Обновите данные.": "Editing projects is unavailable right now. Refresh the data.",
  "Проект ещё сохраняется. Попробуйте через секунду.": "The project is still saving. Try again in a second.",
  "Результат больше недоступен.": "The result is no longer available.",
  "Не удалось проверить владельца проекта.": "Couldn't verify the project owner.",
  "Операция не найдена. Проверьте историю.": "Operation not found. Check your History.",
  "Проект ещё не сохранён.": "The project isn't saved yet.",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "Script voiceover is unavailable right now. Refresh the data.",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "Line preview is unavailable right now. Refresh the data.",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "Re-voicing a line is unavailable right now. Refresh the data.",
  "Дорожка ещё не готова.": "The track isn't ready yet.",
  "Аккаунт сменился. Обновите страницу.": "The account has changed. Reload the page.",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "Sending isn't confirmed yet. Tap again to check the previous request.",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "The project result isn't available yet. Check the status again.",
  "Не удалось открыть аудио проекта.": "Couldn't open the project audio.",
  "месяц|месяца|месяцев": "month|months",
  "покупателя|покупателей|покупателей": "buyer|buyers",
  "рабочий день|рабочих дня|рабочих дней": "business day|business days",
  "друг купит|друга купят|друзей купят": "friend buys|friends buy",
  "покупателем|покупателями|покупателями": "buyer|buyers",
  "Баннеры": "Banners",
  "Постер": "Poster",
  "Голос героя": "Character’s voice",
  "Персонаж говорит": "Character speaks",
  "Было и стало": "Before and after",
  "Подарок другу": "Gift for a friend",
  "Кружок, который говорит": "A round video that talks",
  "Персонаж читает ваш текст": "A character reads your text",
  "Рилс с вами одной кнопкой": "A reel with you in one tap",
  "Сюжет, монтаж и музыка в шаблоне": "Story, editing and music included",
  "Герой говорит": "Hero speaks",
  "Герой говорит вашим текстом": "A hero speaks your text",
  "Голос и губы в такт": "Voice and lips in sync",
  "Старое фото как новое": "Old photos like new",
  "Цвет и резкость за минуту": "Color and sharpness in a minute",
  "Кавер любым голосом": "A cover in any voice",
  "Рок, джаз или lo-fi": "Rock, jazz or lo-fi",
  "Фотосессия в любом образе": "A photo shoot in any look",
  "По паре своих фото": "From a couple of your photos",
  "Друзьям": "Friends",
  "Личное сообщение": "Direct message",
  "Подписчикам": "Followers",
  "Пост в канал": "Channel post",
  "Семье": "Family",
  "Сообщение родным": "Message to family",
  "Геймерам": "Gamers",
  "Чат по интересам": "Interest chat",
  "Для работы": "For work",
  "Коллегам и в рабочий чат": "Colleagues and work chats",
  "Авторам": "Creators",
  "Блогерам и создателям роликов": "Bloggers and video makers",
  "Подарок по моему промокоду": "A gift with my promo code",
  "Кружки, фото и голос с ИИ прямо в Telegram": "AI round videos, photos and voice right in Telegram",
  "Кружки с персонажами": "Round videos with characters",
  "Пишете текст, персонаж его говорит": "You write, the character speaks",
  "Озвучка любым голосом": "Voiceover in any voice",
  "Из библиотеки или своим клоном": "From the library or your own clone",
  "Фотосессия без студии": "A photo shoot without a studio",
  "Пара своих фото, любой образ": "A couple of photos, any look",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "{0} from signing up with your link or from the first purchase with your promo code. During this time you get a percentage of all their payments. The promo code works only until the friend's first purchase; if they came via your link, the promo code doesn't change who they're linked to.",
  "Что получает друг?": "What does a friend get?",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "+{0} C right away: they can't be withdrawn and expire in {1}.",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "A {0}% discount on the first Circle pack is valid for {1} after subscribing, since Circle packs are sold only with a subscription. One gift per account: via link or promo code.",
  "Что считается оплатой?": "What counts as a payment?",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "Subscriptions and Circle packs paid with Stars or card. The percentage is based on what the friend actually paid, after discounts. Bonus coins, task rewards and refunds don't count.",
  "Какие бывают промокоды?": "What kinds of promo codes are there?",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "Your partner promo code gives a friend a gift and links them to you; it works only until their first purchase. STEOS promo codes are published by the team in the STEOS channel and community: they give Circle with their own expiry and work for everyone, once per account.",
  "Когда приходят Circle?": "When do Circle arrive?",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "Right after the friend pays, straight to your balance. On the {0} level you can withdraw them.",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Right after the friend pays, straight to your balance. On the {0} levels they work inside STEOS; on {1} you can withdraw them.",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Right after the friend pays, straight to your balance. On the {0} level they work inside STEOS; on {1} you can withdraw them.",
  "Считаются ли друзья с истёкшей привязкой?": "Do friends with an expired link still count?",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "Yes. You no longer get a percentage of their payments, but they still count toward your level: it's based on all your buyers of all time.",
  "Кто может выводить?": "Who can withdraw?",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "Partners at the {0} level (from {1}) registered as sole traders, self-employed or the foreign equivalent, after signing in with STEOS ID. Withdrawals go only as money to an account: here or on {2}.",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "Ambassadors (from {0}) registered as sole traders, self-employed or the foreign equivalent, after signing in with STEOS ID. Withdrawals go only as money to an account: here or on {1}.",
  "Можно ли вывести монеты, заработанные до входа?": "Can I withdraw coins earned before signing in?",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "Yes. Circle earned at the {0} level before signing in with STEOS ID wait on your balance and become withdrawable once you sign in.",
  "Какие монеты тратятся первыми?": "Which coins are spent first?",
  "Можно пригласить самого себя?": "Can I invite myself?",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "No. Purchases from your own account and from duplicate accounts don't count.",
  "Международный": "International",
  "Self-employed, sole trader или компания вне РФ": "Self-employed, sole trader or company outside Russia",
  "Самозанятый в РФ": "Self-employed in Russia",
  "Налог на профессиональный доход": "Professional income tax (NPD)",
  "ИП в РФ": "Sole trader in Russia",
  "Индивидуальный предприниматель": "Individual entrepreneur",
  "Имя или компания": "Name or company",
  "Как в документах": "As in your documents",
  "TIN или номер в вашей стране": "TIN or your country's tax number",
  "ФИО": "Full name",
  "Как в паспорте": "As in your passport",
  "ИНН": "INN",
  "12 цифр": "12 digits",
  "Название ИП": "Sole trader name",
  "Как в выписке": "As in the registry extract",
  "ИНН или ОГРНИП": "INN or OGRNIP",
  "От 10 до 15 цифр": "10 to 15 digits",
  "НДС": "VAT",
  "Плательщик НДС": "VAT payer",
  "Адрес": "Address",
  "КПП": "KPP",
  "ОГРН": "OGRN",
  "Основной офис STEOS": "STEOS head office",
  "Платёжный агент STEOS в России": "STEOS payment agent in Russia",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "A Telegram chat picker will open here with this text, link and promo code",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "A Telegram chat picker will open here: the banner goes with a caption and an «Open STEOS» button",
  "Ещё <b>{0} {1}</b> до уровня {2}": "<b>{0} more {1}</b> to reach {2}",
  "Максимальный уровень": "Top level",
  "До следующего уровня": "To the next level",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "Earn up to&nbsp;{0}% <span>on friends’ purchases</span>",
  "Период": "Period",
  "Кого показать": "Show",
  "Перешли": "Clicks",
  "Зарегистрировались": "Sign-ups",
  "Купили": "Bought",
  "Пока нет данных": "No data yet",
  "{0} к прошлому периоду": "{0} vs last period",
  "за {0} {1}": "over {0} {1}",
  "Пока не считаем": "Not tracked yet",
  "нет начислений": "no earnings",
  "Пик <b>{0} C</b>": "Peak <b>{0} C</b>",
  "Начисления по месяцам": "Earnings by month",
  "Начисления по дням": "Earnings by day",
  "Здесь появятся начисления": "Your earnings will appear here",
  "Подписка Про": "Pro subscription",
  "Купила Circle": "Bought Circle",
  "Купил Circle": "Bought Circle",
  "Покупатель": "Buyer",
  "по промокоду": "via promo code",
  "привязка истекла": "link expired",
  "Это весь список · {0}": "That's everyone · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "A friend stays linked to you for {0}: from signing up via your link or from the first purchase with your promo code. The promo code works only until the friend's first purchase.",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "Buyers with an expired link still count toward your level.",
  "Пока никого": "No one yet",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "Share your link or promo code, and your first friends will show up here",
  "Картинка": "Image",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "Your link and promo code are already on the image. Tap a template to edit the caption and post.",
  "{0}, открыть и опубликовать": "{0}, open and post",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "For Reels, Shorts, TikTok and VK Clips. Your promo code and link are already in the frame; the bot will send the video to your chat.",
  "{0}, открыть": "{0}, open",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "Your link and promo code are already in the text. Copy it or send it to a chat.",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "The image goes to the chat with a caption and an «Open STEOS» button. Works for groups, channels and direct messages.",
  "Баннер «{0}» с вашим промокодом": "Banner «{0}» with your promo code",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "QR poster: the code opens your link, promo code {0}",
  "Кружки, фото и голос с ИИ": "AI round videos, photos and voice",
  "+{0}&nbsp;C на старт по промокоду": "+{0}&nbsp;C to start with the promo code",
  "Начните по ссылке или промокоду": "Start with the link or promo code",
  "Наведите камеру телефона": "Point your phone camera",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "A4 for printing: stands, shop windows, business cards. The code opens your link, and the promo code below can be entered without a camera.",
  "Цвет постера": "Poster color",
  "Прислать PDF в чат": "Send PDF to chat",
  "Вывести": "Withdraw",
  "Заявка на {0} C не подтверждена": "Request for {0} C not confirmed",
  "Вывод сейчас недоступен": "Withdrawals are unavailable right now",
  "Вывод недоступен": "Unavailable",
  "Деньгами на ваш счёт за {0}": "Paid to your account within {0}",
  "Вывод от {0} C": "Withdrawals from {0} C",
  "Вывод заработает после входа через STEOS ID": "Withdrawals open after you sign in with STEOS ID",
  "Войдите через STEOS ID": "Sign in with STEOS ID",
  "Вывод доступен на уровне {0}, от {1}": "Withdrawals unlock at {0}, from {1}",
  "Нужен уровень {0}": "{0} level required",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "Withdrawals unlock at {0}, from {1}. Until then, Circle work inside STEOS",
  "Не подключён": "Not connected",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "Signing in links your bot account to your shared STEOS account: the balance becomes shared, and withdrawals work here and on the STEOS ID site.",
  "Выплачено": "Paid",
  "В обработке": "Processing",
  "Отклонено": "Rejected",
  "Не удалось загрузить историю выводов": "Couldn't load withdrawal history",
  "Выводов пока не было": "No withdrawals yet",
  "за всё время": "all time",
  "Можно вывести": "Withdrawable",
  "Тестовая программа: настоящих выплат нет": "Test program: no real payouts",
  "Баланс и выводы есть и на {0}.": "Your balance and withdrawals are also on {0}.",
  "Вопрос о выводе?": "Question about withdrawals?",
  "Напишите в поддержку": "Contact support",
  "Поделитесь ссылкой или промокодом": "Share your link or promo code",
  "Друг привязывается к вам на {0}": "Your friend is linked to you for {0}",
  "Друг получает подарок": "Your friend gets a gift",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "+{0} C right away and −{1}% on the first Circle pack after subscribing",
  "Друг платит в STEOS": "Your friend pays in STEOS",
  "Подписка и пакеты Circle звёздами или картой": "Subscription and Circle packs with Stars or card",
  "Вам приходит процент": "You get a percentage",
  "{0}% с каждой оплаты, сразу на баланс": "{0}% of every payment, straight to your balance",
  "Шаг {0}": "Step {0}",
  "От {0}": "From {0}",
  "С первого дня": "From day one",
  "Если {0} {1} {2}": "If {0} {1} {2}",
  "{0} C за {1}": "{0} C over {1}",
  "Хватит на {0} в месяц": "Enough for {0} a month",
  "Кружок стоит {0} C": "A round video costs {0} C",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "Based on the {0} subscription: {1} a month, that's {2}&nbsp;C. You earn on every payment a friend makes during the {3} they're linked to you.",
  "Уровень считается вместе с вашими {0}.": "Your current buyers count toward the level: {0}.",
  "Калькулятор дохода": "Income calculator",
  "Тариф друзей": "Friends' plan",
  "Сколько друзей купят подписку": "How many friends buy a subscription",
  "Вы получите": "You get",
  "C в месяц": "C a month",
  "Проценты, сроки и ограничения": "Percentages, terms and limits",
  "Circle можно вывести": "Circle can be withdrawn",
  "Circle работают внутри STEOS": "Circle work inside STEOS",
  "Привязка на {0}": "Linked for {0}",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "You earn on all of a friend's payments: from signing up via your link or from the first purchase with your promo code",
  "Ссылка главнее промокода": "The link beats the promo code",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "If a friend came via your link, a promo code no longer changes who they're linked to",
  "Промокод только до первой покупки": "Promo code only until the first purchase",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "After a friend's first payment, your partner promo code no longer works for them",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "{0} C right away, expire in {1}. {2} off the first Circle pack for {3} after subscribing",
  "Только уровень {0}": "{0} level only",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "From {0} {1}, after signing in with STEOS ID. For sole traders, self-employed and their equivalents abroad",
  "Счёт на компанию STEOS": "Invoice to a STEOS company",
  "Плательщик появится, когда вывод откроется": "The payer will appear once withdrawals open",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "In Russia: {0}, in rubles. International status: {1}, in euros",
  "Выплата за {0}": "Payout within {0}",
  "После проверки счёта, от {0} C": "After the invoice is checked, from {0} C",
  "Коротко о главном": "The essentials in brief",
  "Здесь краткое изложение. Полный текст условий на {0}": "This is a summary. Full terms are on {0}",
  "Понятно": "Got it",
  "У вас {0}.": "You have {0}.",
  "Покупателей пока нет.": "No buyers yet.",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "The level is based on all your buyers of all time, including expired links.",
  "Введите сумму": "Enter an amount",
  "Можно вывести не больше {0} C": "You can withdraw up to {0} C",
  "Заполните реквизиты": "Fill in your details",
  "Загрузите счёт на оплату": "Upload an invoice",
  "Счёт ещё проверяется": "Invoice is still being checked",
  "Выплата в {0} · 1 C = {1} {0}": "Paid in {0} · 1 C = {1} {0}",
  "Вывести {0} C": "Withdraw {0} C",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "Issue the invoice in {0}. We'll check it, and the money arrives within {1}.",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Issue the invoice in euros. We'll check it, and the money arrives within {0}. Your details will be saved in STEOS ID.",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Issue the invoice in rubles. We'll check it, and the money arrives within {0}. Your details will be saved in STEOS ID.",
  "Скопировать {0}": "Copy {0}",
  "юридический адрес": "legal address",
  "Скопировать название компании": "Copy company name",
  "Скопировать все реквизиты": "Copy all details",
  "Реквизиты для счёта": "Invoice details",
  "Проверяем счёт…": "Checking invoice…",
  "PDF, JPG или PNG, до 10 МБ": "PDF, JPG or PNG, up to 10 MB",
  "Можно вывести {0} C": "{0} C available",
  "Сумма, C": "Amount, C",
  "Сумма вывода, C": "Withdrawal amount, C",
  "Всё": "All",
  "Придёт на счёт": "You'll receive",
  "Реквизиты": "Details",
  "Счёт на оплату": "Invoice",
  "Заявка на вывод принята": "Withdrawal request accepted",
  "{0} придут за {1} после проверки счёта": "{0} will arrive within {1} after the invoice is checked",
  "Ролик принят в обработку": "Video is being prepared",
  "Ролик в чате с ботом": "Video is in your bot chat",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "The bot will send it once it's ready. Delivery isn't confirmed yet.",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "Save it and post to Reels, Shorts, TikTok or VK Clips",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "Your promo code and link are already in the frame. The bot will send the video to your chat, where you can save and post it.",
  "Прислать в чат": "Send to chat",
  "Текст выделен: скопируйте его вручную": "The text is selected: copy it manually",
  "Баннер готов: отправить его в чат можно из Telegram": "Banner ready: you can send it to a chat from Telegram",
  "PDF принят в очередь": "PDF queued",
  "PDF в чате": "PDF sent to chat",
  "Не удалось загрузить период. Попробуйте ещё раз": "Couldn't load the period. Try again",
  "Без начислений": "No earnings",
  "Значение выделено: скопируйте его вручную": "Value selected: copy it manually",
  "Реквизиты выделены: скопируйте их вручную": "Details selected: copy them manually",
  "Нужен файл PDF, JPG или PNG": "A PDF, JPG or PNG file is needed",
  "Файл {0}, можно до 10 МБ": "File is {0}, max 10 MB",
  "Партнёрство не загрузилось": "Partnership didn't load",
  "Загружаем партнёрскую программу": "Loading partner program",
  "за неделю": "past week",
  "за месяц": "past month",
  "Для вывода войдите через STEOS ID": "Sign in with STEOS ID to withdraw",
  "Вывод недоступен на текущем уровне": "Withdrawals aren't available at your level",
  "Сумма больше доступной": "Amount exceeds what's available",
  "Сумма меньше минимальной": "Amount is below the minimum",
  "Проверьте реквизиты и счёт": "Check your details and invoice",
  "Счёт ещё не проверен. Загрузите его заново": "Invoice not verified yet. Upload it again",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "No response. Check the same request: its data and key are saved",
  "Не удалось загрузить список друзей": "Couldn't load the friends list",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "Couldn't restore the previous request. Contact support before making a new one",
  "Партнёрская программа временно недоступна": "Partner program is temporarily unavailable",
  "Не удалось загрузить следующую страницу": "Couldn't load the next page",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "Couldn't prepare the banner. Try again",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "The bot can't prepare this: open the bot chat and try again",
  "Материал сейчас недоступен": "This material is unavailable right now",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "Sending not confirmed. Tap again: a retry checks the previous request",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "Previous send wasn't restored. Contact support",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "Previous send confirmed. Tap again",
  "Отправка не подтверждена": "Sending not confirmed",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "Invoice failed the check. Choose a PDF, JPG or PNG up to 10 MB",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "Couldn't save the request safely. Nothing was sent",
  "Тут откроется инструмент «{0}»": "The “{0}” tool will open here",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "Geralt, Ciri and 2,400 more voices will say anything you write",
  "Снимите себя, и персонаж повторит ваши движения": "Film yourself and the character will copy your moves",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "Pick a look and get 3 shots from one selfie in a minute",
  "Сделать": "Create",
  "2 400 голосов, 19 языков": "2,400 voices, 19 languages",
  "Текст в речь голосом персонажа или своим клоном": "Text to speech in a character’s voice or your own clone",
  "Ваш голос за две минуты": "Your voice in two minutes",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "Record a sample and your clone will appear in every voiceover tool",
  "Движения": "Moves",
  "бесплатно": "free",
  "/сек": "/sec",
  "готов": "ready",
  "Клон · готов": "Clone · ready",
  "студия: Мой голос": "My voice",
  "Сейчас в тренде": "Trending now",
  "Популярное за неделю": "Popular this week",
  "Геральт скажет ваш текст": "Geralt will say your text",
  "Вы в знаменитых сценах": "You in famous scenes",
  "3 кадра в любом образе": "3 shots in any look",
  "Готовый сюжет с вами": "A ready-made story with you",
  "Вы повторите любой танец": "You’ll do any dance",
  "Ваш снимок в движении": "Your photo in motion",
  "Фото скажет ваш текст": "Your photo will say your text",
  "Легенды замка": "Castle Legends",
  "Город инков": "City of the Incas",
  "Неоновый дождь": "Neon Rain",
  "Утренний бег": "Morning Run",
  "Танец теней": "Shadow Dance",
  "Дорога домой": "The Way Home",
  "Ночной рейв": "Night Rave",
  "Снежный пик": "Snowy Peak",
  "Тайны Хейвена": "Secrets of Haven",
  "Магия рун": "Rune Magic",
  "Странные дела": "Strange Things",
  "Ночной рынок": "Night Market",
  "Ретро-кадр": "Retro Shot",
  "Утро в горах": "Morning in the Mountains",
  "Золотой час": "Golden Hour",
  "Студийный свет": "Studio Light",
  "Полароид": "Polaroid",
  "Киберпанк": "Cyberpunk",
  "Старый маяк": "The Old Lighthouse",
  "Шторм в заливе": "Storm in the Bay",
  "Кинотрейлер": "Movie Trailer",
  "Город в движении": "City in Motion",
  "Интервью": "Interview",
  "Пустыня на закате": "Desert at Sunset",
  "Подводный мир": "Underwater World",
  "Кружок «Привет»": "“Hi” round video",
  "Спокойной ночи": "Good Night",
  "Поздравляю": "Congratulations",
  "Скучаю": "Missing You",
  "Новости дня": "Daily News",
  "Нос корабля": "Ship’s Bow",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "Two people at the bow of a ship, arms spread to the wind",
  "Героиня": "Heroine",
  "роль: Герой": "Hero",
  "Уклонение от пуль": "Dodging Bullets",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "Time freezes, you bend back and the bullets fly past",
  "Танец в закусочной": "Diner Dance",
  "Пара танцует твист у стойки придорожной закусочной": "A couple dances the twist at a roadside diner counter",
  "Танцор": "Dancer",
  "Танцовщица": "Dancer",
  "Свидание под дождём": "Date in the Rain",
  "Ливень, старый дом и встреча, которую оба ждали годами": "Pouring rain, an old house and a meeting both waited years for",
  "Он": "He",
  "Она": "She",
  "Речь перед битвой": "Speech Before the Battle",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "The leader rides along the ranks and the army answers with a roar",
  "Вождь": "Leader",
  "Знаменосец": "Standard-bearer",
  "Погоня по крышам": "Rooftop Chase",
  "Прыжки между крышами ночного города, погоня не отстаёт": "Leaps between rooftops of a city at night, the chase close behind",
  "Беглец": "Runner",
  "Преследователь": "Pursuer",
  "Ограбление казино": "Casino Heist",
  "Команда в смокингах проходит через зал, сейф уже открыт": "A crew in tuxedos walks through the hall, the safe is already open",
  "Главарь": "Boss",
  "Напарник": "Partner",
  "Напарница": "Partner",
  "Прощание на вокзале": "Farewell at the Station",
  "Поезд трогается, двое держатся за руки до последнего": "The train pulls away, two people hold hands till the last moment",
  "Пассажир": "Passenger",
  "Провожающий": "Seeing off",
  "Дуэль на закате": "Duel at Sunset",
  "Пустая улица, два стрелка и последние секунды тишины": "An empty street, two gunslingers and the last seconds of silence",
  "Шериф": "Sheriff",
  "Злодей": "Villain",
  "Танец на лестнице": "Stairway Dance",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "A villain in a bright suit dances on a long street stairway",
  "Выход в открытый космос": "Spacewalk",
  "Астронавт парит над Землёй, трос уходит к станции": "An astronaut floats above Earth, the tether leading back to the station",
  "Астронавт": "Astronaut",
  "Рассвет над саванной": "Dawn over the Savanna",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "Your pet is lifted above the rock and the whole savanna looks on",
  "Главная роль": "Lead role",
  "Хранитель": "Keeper",
  "Полёт под луной": "Flight Under the Moon",
  "Велосипед отрывается от земли и летит на фоне луны": "The bike lifts off the ground and flies across the moon",
  "Финальная поддержка": "The Final Lift",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "A run-up, a jump and an overhead lift to the hall’s applause",
  "Партнёрша": "Partner",
  "Партнёр": "Partner",
  "Песня на холме": "Song on the Hill",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "An alpine meadow and the wind: you twirl and sing as the kids run towards you",
  "Бледная кожа": "Pale Skin",
  "Хвойный лес": "Pine Forest",
  "Первый взгляд": "First Glance",
  "Туман над рекой": "Mist over the River",
  "Полночь в школе": "Midnight at School",
  "Двое на поляне": "Two in the Clearing",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "A ray breaks through the pines and two people freeze in the middle of a forest clearing",
  "Глаза цвета янтаря": "Amber Eyes",
  "Бал выпускников": "Prom Night",
  "Клятва": "The Vow",
  "Игра в грозу": "Game in the Storm",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "Thunder over a forest clearing, and every swing of the bat sounds like a thunderclap",
  "Отбивающий": "Batter",
  "Подающая": "Pitcher",
  "Ловец": "Catcher",
  "К вершине сосны": "To the Top of the Pine",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "He carries her on his back to the top of a pine, with mist and the whole forest below",
  "Примерка брони": "Suiting Up",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "The armor snaps onto you piece by piece and the helmet closes over your face",
  "Полёт над городом": "Flight over the City",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "Speeding over the city at night, banking between towers and landing on a roof",
  "Пилот брони": "Armor pilot",
  "Ночь в мастерской": "Night in the Workshop",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "Welding sparks, blueprints in midair and the first successful launch",
  "Изобретатель": "Inventor",
  "Последний заряд": "The Last Charge",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "The armor is almost out of power, the team stands back to back and the last shot decides it all",
  "Герой в броне": "Armored hero",
  "Качели на паутине": "Web Swing",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "A jump off a ledge, the web pulls tight and the street rushes by below",
  "Герой в маске": "Masked hero",
  "Поцелуй под дождём": "Kiss in the Rain",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "A night alley and pouring rain: he hangs upside down, she lifts the edge of his mask",
  "Крыша на закате": "Rooftop at Sunset",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "Two sit on the edge of a roof, the city hums below and the sun sets behind the towers",
  "Бой в поезде": "Fight on the Train",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "A fight on the roof of a speeding train, then the hero stops the car with his hands",
  "Пассажирка": "Passenger",
  "Для маркетплейса": "For marketplaces",
  "Праздники": "Holidays",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "Greetings, round videos and posts for the holidays: April Fools’ Day, Easter, March 8",
  "1 апреля": "April Fools’ Day",
  "Пасха": "Easter",
  "8 марта": "March 8",
  "Мода": "Fashion",
  "Аватарки": "Avatars",
  "Фильмы": "Movies",
  "Игры": "Games",
  "Путешествия": "Travel",
  "Сумерки": "Twilight",
  "Железный человек": "Iron Man",
  "Человек-паук": "Spider-Man",
  "Романтика": "Romance",
  "Погони": "Chases",
  "Всей семьёй": "For the whole family",
  "Особая подборка": "Special collection",
  "Особая подборка {0}, {1}": "Special collection {0}, {1}",
  "Подборка {0}, {1}": "Collection {0}, {1}",
  "{0} в подборке": "{0} in the collection",
  "шаблон|шаблона|шаблонов": "template|templates",
  "шаблона|шаблонов|шаблонов": "template|templates",
  "сцена|сцены|сцен": "scene|scenes",
  "инструмент|инструмента|инструментов": "tool|tools",
  "инструмента|инструментов|инструментов": "tool|tools",
  "стиль|стиля|стилей": "style|styles",
  "кадра|кадров|кадров": "shot|shots",
  "ребёнок|ребёнка|детей": "child|children",
  "питомец|питомца|питомцев": "pet|pets",
  "кружки": "round videos",
  "голос": "voice",
  "текст": "text",
  "для бизнеса": "business",
  "Кружок из видео": "Video message from a video",
  "Фото в новом стиле": "Restyle a photo",
  "Фото по описанию": "Photo from a description",
  "Семейный портрет": "Family portrait",
  "Видео в новом стиле": "Restyle a video",
  "Видео по описанию": "Video from a description",
  "Видео другим голосом": "Video in another voice",
  "Объёмное фото": "3D photo",
  "Анимация из серии": "Animation from a series",
  "Видео из поездки": "Trip video",
  "Фильм из фотографий": "Film from photos",
  "Изменить видео": "Edit a video",
  "текст или запись": "text or recording",
  "видео до 1 минуты": "video up to 1 minute",
  "1 фото и текст": "1 photo and text",
  "запись или аудиофайл": "recording or audio file",
  "5 фото лица": "5 face photos",
  "1 селфи": "1 selfie",
  "описание словами": "a text description",
  "фото или описание": "photo or description",
  "старое фото": "an old photo",
  "чёрно-белое фото": "a black-and-white photo",
  "фото близких": "photos of loved ones",
  "от 2 до 9 фото": "2 to 9 photos",
  "тема поста": "post topic",
  "1 фото или видео": "1 photo or video",
  "ваше фото": "your photo",
  "фото тех, кто сыграет": "photos of the cast",
  "1 видео": "1 video",
  "видео и новый текст": "video and new text",
  "видео с речью": "video with speech",
  "текст поздравления": "greeting text",
  "от 3 фото": "3 or more photos",
  "фото из поездки": "trip photos",
  "семейные фото": "family photos",
  "сценарий": "script",
  "запись голоса": "voice recording",
  "песня": "a song",
  "файл или ссылка": "file or link",
  "название товара": "product name",
  "от 1 до 5 фото товара": "1 to 5 product photos",
  "фото товара": "product photos",
  "1 видео с вами": "1 video of you",
  "ваше видео": "your video",
  "картинка": "an image",
  "идея словами": "an idea in words",
  "ваш промпт": "your prompt",
  "нужно: 1 фото": "1 photo",
  "нужно: Текст": "Text",
  "нужно: Тема": "Topic",
  "нужно: Запись": "Recording",
  "формат: Reels": "Reels",
  "формат: фото": "photos",
  "формат: видео": "videos",
  "формат: кружков": "round videos",
  "формат: шаблонов": "templates",
  "любое, где хорошо видно лицо": "any photo where the face is clearly visible",
  "лицо крупно и при хорошем свете": "face close-up, in good light",
  "селфи, лицо крупно": "a selfie, face close-up",
  "снимок оживёт в ролике": "the photo comes to life in a video",
  "что скажет герой": "what the character will say",
  "или фото, из которых сделаем слайды": "or photos we’ll turn into slides",
  "Сколько стоит одна генерация": "How much does one generation cost",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "A photo costs {0} C, a photo shoot {1} C for 3 shots, a video {2} C for 5 seconds. Text helpers, such as a product description, cost {3} C. The price is always shown on the “Create” button before you’re charged.",
  "Что такое C и как пополнить баланс": "What is C and how to top up",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C stands for Circle coins, which you spend on creating. Packs and subscriptions are sold on the “Balance” tab, where you can also see what’s left.",
  "Какие файлы можно загружать": "Which files can I upload",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "Videos up to 1 minute and 15 MB, photos in JPG or PNG, audio in MP3, WAV or M4A. Each tool shows its own limits.",
  "Как сделать дешевле": "How to make it cheaper",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "If you don’t have enough Circle for a job, the button at the bottom of the screen opens “Not enough Circle” with a “Make it cheaper” option. You get {0}% off, and the result will have a watermark.",
  "Где найти готовые результаты": "Where to find my results",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "In “History” in the “More” menu. There you can download a file again or send it to the chat.",
  "Можно ли использовать свой голос": "Can I use my own voice",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "Yes. Clone your voice on the “Clone” tab and it will appear in the voice list of every voiceover tool.",
  "Фотосессия из {0} в стиле шаблона": "Photo shoot of {0} in the template’s style",
  "По желанию: {0}": "Optional: {0}",
  "Тут откроется шаблон «{0}»": "The “{0}” template will open here",
  "Только до": "Before only",
  "Только после": "After only",
  "До: {0} %": "Before: {0}%",
  "подборка": "collection",
  "Все форматы": "All formats",
  "Состав": "Cast",
  "Вкладки каталога": "Catalog tabs",
  "Найти подборку": "Find a collection",
  "Найти шаблон": "Find a template",
  "Поиск среди {0}": "Search {0}",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "No collections for “{0}”. Try searching all templates",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "Nothing for “{0}” in “{1}”. Try searching all templates",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "Nothing for “{0}” in “For you”. Try searching all templates",
  "В подборке «{0}» нет сцен «{1}»": "No “{1}” scenes in “{0}”",
  "Посмотрите все сцены подборки": "See all scenes in the collection",
  "В подборке «{0}» нет {1}": "No {1} in “{0}”",
  "Посмотрите во всех форматах": "Look in all formats",
  "В «Рекомендуем» нет {0}": "No {0} in “For you”",
  "Пока ничего нет": "Nothing here yet",
  "Шаблоны этого формата появятся совсем скоро": "Templates in this format are coming soon",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "No {1} found for “{0}”. Try all formats",
  "Искать во всех форматах": "Search all formats",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "No templates for “{0}”. Try another word",
  "Загружаем ещё": "Loading more",
  "Это все шаблоны": "That’s all the templates",
  "Тренды": "Trends",
  "Вкладки страницы": "Page tabs",
  "Найти сцену": "Find a scene",
  "Найти в подборке": "Search the collection",
  "Искать во всех сценах": "Search all scenes",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "No collections for “{0}”. Try searching all scenes",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "Nothing for “{0}” in “{1}”. Try searching all scenes",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "Nothing for “{0}” in “Trends”. Try searching all scenes",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "Nothing for “{0}” in “For you”. Try searching all scenes",
  "В «Трендах» нет сцен «{0}»": "No “{0}” scenes in “Trends”",
  "В «Рекомендуем» нет сцен «{0}»": "No “{0}” scenes in “For you”",
  "Посмотрите все сцены этой вкладки": "See all scenes on this tab",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "Nothing in “{0}” for “{1}”. Try searching all templates",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "This collection has no such templates yet. View the whole collection or pick another tab",
  "Поиск в подборке «{0}»: {1}": "Search in “{0}”: {1}",
  "Вкладки подборки": "Collection tabs",
  "Нужно: {0}": "Needs: {0}",
  "Нужно": "Needs",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "No tools or templates for “{0}”. Try another word or browse all tools",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "Nothing for “{0}” in “{1}”. Try searching all tools",
  "Искать во всех": "Search everything",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "No tools for “{0}”. Try another word",
  "Найти инструмент": "Find a tool",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "Couldn’t open the tool. Refresh the catalog and try again.",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "The tool didn’t open within 30 seconds. Try again or go back.",
  "Карточка товара": "Product card",
  "Рилс готов": "Reels ready",
  "Кавер не создан": "Cover not created",
  "Фотосессия не создана": "Photo shoot not created",
  "Рилс не создан": "Reels not created",
  "Карточка не создана": "Card not created",
  "Слайды не созданы": "Slides not created",
  "Запись не обработана": "Recording not processed",
  "Коллаж не создан": "Collage not created",
  "· остаток {0} C": "· {0} C left",
  "Вернули {0} C": "{0} C refunded",
  "Списано {0} C со скидкой, {1} водяной знак": "{0} C charged with a discount, {1} watermark",
  "Списано {0} C": "{0} C charged",
  "Рисованному стилю камера не нужна": "A drawn style doesn’t need a camera",
  "У этой камеры объектив встроенный": "This camera has a built-in lens",
  "У этой камеры резкость не настраивается": "This camera’s focus can’t be adjusted",
  "У этого объектива диафрагма постоянная": "This lens has a fixed aperture",
  "Встроенный": "Built-in",
  "Как у камеры": "Same as camera",
  "до {0} МБ": "up to {0} MB",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "No tools or templates for {0}. Try another word or browse all tools",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "Nothing for {0} in {1}. Try searching all tools",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "No tools for {0}. Try another word",
  "в «Трендах»": "in “Trends”",
  "в «Рекомендуем»": "in “For you”",
  "в подборке {0}": "in {0}",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "Nothing for {0} {1}. Try searching all scenes",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "Nothing in {0} for {1}. Try searching all templates",
  "сцен {0}": "{0} scenes",
  "В подборке {0} нет {1}": "No {1} in {0}",
  "В подборке {0} нет таких шаблонов": "{0} has no such templates",
  "Посмотрите её целиком или выберите другую вкладку": "View the whole collection or pick another tab",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "Nothing for {0} in this format. Try all formats",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "No templates for {0}. Try another word",
  "Здесь нет шаблонов": "No templates here",
  "Заказ принят": "Order received",
  "Бот пришлёт результат в чат, в отдельную тему.": "The bot will send the result to the chat, in a separate topic.",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "Change your request and try again. Circle for a reviewed order aren’t refunded.",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "Something went wrong on our side. Your Circle are back on your balance.",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "The tool is still connecting: your order is queued and will start on its own, and the bot will send the result to the chat.",
  "Сначала отметьте согласие ниже": "First tick the consent below",
  "Главное фото: {0}": "Main photo: {0}",
  "Загружаем превью…": "Loading preview…",
  "Фото не подошло": "Photo didn’t fit",
  "Проверить загрузку": "Check upload",
  "Опишите, что хотите увидеть": "Describe what you want to see",
  "Не помещается: до {0} знаков": "Too long: up to {0} characters",
  "{0} во весь экран": "{0} in full screen",
  "Загрузить картинку": "Upload an image",
  "Ваша": "Yours",
  "Убрать картинку": "Remove image",
  "Этот инструмент пока недоступен": "This tool isn’t available yet",
  "Выберите другой инструмент или вернитесь к шаблонам.": "Pick another tool or go back to templates.",
  "Вернуться": "Go back",
  "Образ": "Look",
  "Ваши селфи": "Your selfies",
  "Три разных кадра: лицо крупно, при хорошем свете": "Three different shots: face close-up, in good light",
  "Подтверждаю согласие людей на фото": "I confirm the people in the photos agree",
  "От одного до пяти ракурсов, первый — главный": "One to five angles, the first is the main one",
  "Категория": "Category",
  "Набор сцен": "Scene set",
  "Загрузите фото: нужно {0}": "Upload photos: {0} needed",
  "Выберите: {0}": "Choose: {0}",
  "Не удалось загрузить экран.": "Couldn’t load the screen.",
  "Сцен: {0}": "Scenes: {0}",
  "Заказ создан, следите за ним в «Истории».": "Order created, follow it in “History”.",
  "Старые": "Oldest",
  "Длинные": "Longest",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "The style already sets light and color. Pick another style to change them",
  "{0} открывается только до f/{1}": "{0} opens only to f/{1}",
  "Объектив не задаёт светосилу": "The lens doesn’t set the aperture",
  "Этот объектив открывается только до f/{0}": "This lens opens only to f/{0}",
  "Назад к настройкам": "Back to settings",
  "Группа": "Group",
  "Нашли {0}": "Found {0}",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "Nothing found. Try another word or reset the group.",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "Picking one takes you straight back to settings. The price stays the same",
  "Сравнить: было и стало": "Compare: before and after",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "We take the style: color, light and processing. The image itself and faces from it aren’t copied",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "We take the scene: background, light and staging. The image itself and faces from it aren’t copied",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "We take the look: clothes, pose, background and light. You’ll be in the shot, faces from the image aren’t copied",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "Image didn’t fit: it won’t open, try JPG or PNG",
  "Картинка не подошла: больше {0} МБ": "Image didn’t fit: larger than {0} MB",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "Image didn’t fit: too small, needs at least {0} px",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "Image didn’t fit: it contains protected or prohibited content",
  "Загрузить картинку-референс": "Upload a reference image",
  "Озвучка текста": "Text to speech",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "Record 2 seconds of speech and the bot will talk in your voice",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "Ready voices appear on the «Mine» tab in Voices",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "The voice appears in your list under this name. Only you see the description",
  "Голос появится на вкладке «Мои»": "The voice will appear on the «Mine» tab",
  "Имя в списке голосов": "Name in the voice list",
  "Уже в «Озвучке»": "Already in Voices",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "The voice is on the «Mine» tab, marked «Mine»",
  "Карточка голоса": "Voice card",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "Tap a voice in the list to rename or delete it",
  "Так голос выглядит в списке": "How the voice looks in the list",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "The voice is already on the «Mine» tab. Have a listen",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "Checking and training, usually 1–3 minutes. The voice will appear on the «Mine» tab on its own",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "The voice will disappear from the «Mine» tab. This can’t be undone.",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "Usually 1–3 minutes. You can close the app — the voice will appear in the list",
  "Можно закрыть приложение": "You can close the app",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "Record speech or upload files: 0:02 to 1:30 in total. MP3, WAV, M4A, OGG and WEBM, up to 10 files of 20 MB each",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "{n} of {n} clones created. Delete one to add a new one",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "Without a subscription you can create {n} clones. With one, up to {0}",
  "До {0} клонов": "Up to {0} clones",
  "Три клона бесплатно": "Three clones for free",
  "Запишите ещё один, другим тоном или настроением": "Record another one in a different tone or mood",
  "С подпиской можно создать до {0}": "With a subscription you can create up to {0}",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "Hi! This is a recording for my voice. I’m speaking calmly and at a normal pace, like talking to a friend. The more natural it sounds now, the more accurate the clone will be.",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "You know the weirdest thing about cooking from videos? You watch someone chop an onion in a minute and think: that’s easy. And then somehow the onion ends up everywhere except the pan.",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "Yesterday I finally unpacked the boxes from the move. I found an old music player, three chargers for phones I no longer have, and a notebook of summer plans. The player still works.",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "The weather is strange today: sunny in the morning, rain by lunch, and snow is forecast for the evening. A perfect time to make something hot and not rush anywhere.",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "One, two, three, testing. Can you hear me well? Now I’ll read a few phrases in different tones: first calmly, then a bit louder, and at the end very quietly, almost in a whisper.",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "My cat thinks the keyboard was made for napping and the monitor exists to be covered with his tail. So if you hear rustling in the recording, know that it was teamwork.",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "There’s a simple rule: if something doesn’t work on the third try, get up, pour some tea and come back in five minutes. Usually after that everything just works.",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "Quiet, hear that? Footsteps somewhere close. Let’s carefully peek around the corner, and if no one’s there, we’ll run to the door. Just don’t make any noise, please, I’m serious.",
  "Проверено": "Verified",
  "Создание новых голосов пока недоступно": "Creating new voices isn’t available yet",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 seconds of speech: record here or upload files",
  "Внутренняя ошибка, попробуйте позже": "Internal error, try again later",
  "образцов: {n}": "samples: {n}",
  "Образец короче 2 секунд": "Sample is shorter than 2 seconds",
  "Образец длиннее 1,5 минуты": "Sample is longer than 1.5 minutes",
  "Слишком шумная запись — попробуйте в тихом месте": "Recording is too noisy — try somewhere quiet",
  "В записи слышно несколько голосов": "Several voices can be heard in the recording",
  "Проверка не пройдена: голос не совпадает с образцами": "Check failed: the voice doesn’t match the samples",
  "Голос не прошёл правила площадки": "The voice doesn’t comply with platform rules",
  "Проверка не пройдена: запишите образец без музыки и других людей": "Check failed: record a sample without music or other people",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "You need 2 seconds to 1.5 minutes of speech in total",
  "Результат обработки уточняется, загляните чуть позже": "The processing result is being confirmed, check back a bit later",
  "Удалить голос «{n}»?": "Delete voice «{n}»?",
  "Навсегда, вместе с образцами": "Permanently, with its samples",
  "Например, спокойный, низкий": "E.g. calm, low",
  "Образец": "Sample",
  "Запись или файлы, от 2 секунд": "Recording or files, 2 sec or more",
  "Имя, описание и согласие": "Name, description and consent",
  "Проверка и обучение": "Check and training",
  "Модель STEOS · 1–3 минуты": "STEOS model · 1–3 min",
  "Тихое место без эха": "A quiet place with no echo",
  "Фоновый шум и музыка попадут в голос": "Background noise and music will end up in the voice",
  "Хороший микрофон": "A good microphone",
  "Гарнитура или настольный микрофон лучше встроенного": "A headset or desk mic is better than a built-in one",
  "То же оборудование": "Same equipment",
  "Не меняйте микрофон между записями": "Don’t switch microphones between recordings",
  "Под ним голос стоит в списке выбора": "The voice is listed under this name",
  "Шумоподавление": "Noise reduction",
  "Включайте, только если в записи слышен шум": "Turn on only if the recording has audible noise",
  "Согласие обязательно": "Consent is required",
  "Клонировать можно свой голос или с согласия владельца": "You may clone your own voice or one whose owner consents",
  "Проверка образца": "Sample check",
  "Один говорящий, без музыки и шума": "One speaker, no music or noise",
  "Обучение": "Training",
  "Модель STEOS, обычно 1–3 минуты": "STEOS model, usually 1–3 minutes",
  "Голос появится в списке сам": "The voice will appear in the list on its own",
  "Проверьте запись": "Check the recording",
  "Один голос, без музыки и шума на фоне": "One voice, no music or background noise",
  "Длина образца": "Sample length",
  "Нужно не меньше 2 секунд чистой речи": "You need at least 2 seconds of clean speech",
  "Образцы сохранены": "Samples are saved",
  "Можно попробовать снова с теми же файлами": "You can try again with the same files",
  "Не получилось — попробуйте снова": "Didn’t work — try again",
  "Шаг {a} из {b}": "Step {a} of {b}",
  "Персональный": "Personal",
  "Дальше": "Next",
  "Продолжить": "Continue",
  "К списку голосов": "To voice list",
  "Результат уточняется": "Being confirmed",
  "Попробовать снова": "Try again",
  "Голос готов": "Voice is ready",
  "Опишите голос": "Describe the voice",
  "Например, Мой голос": "E.g. My voice",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "This is my voice, or I have its owner’s consent. I won’t use the clone for deception, insults or prohibited content",
  "Загружаем {a} из {b}": "Uploading {a} of {b}",
  "Обрабатываем голос": "Processing the voice",
  "Не получилось создать голос": "Couldn’t create the voice",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "The processing result is still being confirmed. Retry isn’t available yet.",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "Samples are saved — you can try again with the same files",
  "Загруженные файлы": "Uploaded files",
  "Читаем аудио…": "Reading audio…",
  "Записать ещё": "Record more",
  "Ждём разрешение…": "Waiting for permission…",
  "Разрешите доступ в настройках браузера или загрузите файл": "Allow access in browser settings or upload a file",
  "Другой текст": "Another text",
  "Прочитайте вслух": "Read aloud",
  "Микрофон по умолчанию": "Default microphone",
  "Минимум": "Minimum",
  "Хорошо": "Good",
  "Отлично": "Excellent",
  "Набрано {a} из {b}": "{a} of {b} recorded",
  "из {t}": "of {t}",
  "всё готово": "all set",
  "Файлов с ошибкой: {n}": "Files with errors: {n}",
  "до «{n}» ещё {t}": "{t} more to «{n}»",
  "Ещё {t} до минимума": "{t} more to the minimum",
  "Нужно не меньше 2 секунд": "At least 2 seconds needed",
  "Загрузка образцов": "Uploading samples",
  "Образцы приняты сервером": "The server has received the samples",
  "Проверка голоса": "Voice check",
  "Пройдена": "Passed",
  "Не запрашивалась": "Not requested",
  "Результат проверки пока недоступен": "Check result isn’t available yet",
  "Обработка голоса": "Voice processing",
  "Не удалось обработать": "Processing failed",
  "Выполняется на сервере": "Running on the server",
  "Очистка шума": "Noise cleanup",
  "Пропущено": "Skipped",
  "Модель STEOS · один говорящий, без музыки": "STEOS model · one speaker, no music",
  "Обучение голоса": "Voice training",
  "Файл больше 20 МБ": "File is larger than 20 MB",
  "Запись {n}": "Recording {n}",
  "Не удалось прочитать аудио": "Couldn’t read the audio",
  "Неподдерживаемый формат": "Unsupported format",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "The result of your last creation is still being confirmed. Go back to that request so you don’t create a second clone.",
  "Проверить прошлое создание": "Check last creation",
  "Остановить": "Stop",
  "Ждём доступ": "Waiting for access",
  "Ещё раз": "Try again",
  "Начать запись": "Start recording",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "Tap a voice in the list to open its card: listen, rename or delete.",
  "Озвучек": "Voiceovers",
  "Знаков": "Characters",
  "Образцов": "Samples",
  "Доступна": "Available",
  "Недоступна": "Unavailable",
  "После обучения": "After training",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "Trained on your recordings: {n} samples, {d} in total",
  "Происхождение: ваши записи. Подробнее": "Source: your recordings. More info",
  "Происхождение": "Source",
  "Ваши записи": "Your recordings",
  "Проверка": "Check",
  "Не пройдена": "Failed",
  "Идёт": "In progress",
  "Переозвучка аудио": "Audio revoicing",
  "Создан": "Created",
  "Доступ": "Access",
  "Только вы": "Only you",
  "Голос пока недоступен для выбора. Обновите список.": "The voice can’t be chosen yet. Refresh the list.",
  "Голос ещё учится, обычно 1–3 минуты": "The voice is still training, usually 1–3 minutes",
  "Коротко о голосе": "About the voice in brief",
  "О голосе": "About the voice",
  "Голос не создан": "Voice not created",
  "Обработка дольше обычного": "Taking longer than usual",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "The server is still processing the voice. You can close the app and come back later.",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "Avatar {n} will be left without a voice; its circles will use the default voice.",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "Avatars {n} will be left without a voice; their circles will use the default voice.",
  "Записать первый голос": "Record your first voice",
  "клон|клона|клонов": "clone|clones",
  "в месяц": "per month",
  "{n} C в месяц": "{n} C per month",
  "{n} своих голосов": "{n} custom voices",
  "Оформить": "Subscribe",
  "Подписка активна": "Subscription active",
  "Подписка «{n}»": "Subscription «{n}»",
  "{n} голосов ваши": "{n} voices are yours",
  "Доступно — своих голосов": "Custom voices available",
  "{n} голосов мало?": "{n} voices not enough?",
  "Возьмите {n}": "Get {n}",
  "Нужно больше голосов?": "Need more voices?",
  "До {n} с подпиской": "Up to {n} with a subscription",
  "Посмотрите доступные подписки": "See available subscriptions",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "{a} of {b} used. Record voices for different tasks and moods",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "Without a subscription you can create {a} {w}. With any subscription, up to {b}",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "Without a subscription: {n}. The limit depends on your subscription.",
  "Занято {a} из {b}": "{a} of {b} used",
  "Без подписки · {n}": "Free · {n}",
  "С подпиской · {n}": "Subscription · {n}",
  "Смотреть все подписки": "See all subscriptions",
  "Повторить сохранение": "Retry saving",
  "Сохраняем изменения…": "Saving changes…",
  "Управление голосами временно недоступно": "Voice management is temporarily unavailable",
  "клон: Мой голос": "My voice",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "Custom voices are temporarily unavailable. Try refreshing the list later.",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "The voice service is temporarily unavailable. Try again later.",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "Couldn’t confirm your voice limit. Refresh the list later.",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "Couldn’t verify your account. Try again later.",
  "Имя голоса должно содержать от 2 до 32 символов.": "Voice name must be 2 to 32 characters.",
  "Описание должно содержать не больше 120 символов.": "Description must be 120 characters or fewer.",
  "Добавьте от 1 до 10 подходящих образцов.": "Add 1 to 10 suitable samples.",
  "Превью этого голоса пока недоступно.": "This voice’s preview isn’t available yet.",
  "Не удалось загрузить превью. Попробуйте позже.": "Couldn’t load the preview. Try again later.",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "The recording is too noisy. Try recording somewhere quiet.",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "Several voices can be heard. Add speech from one person only.",
  "Голос не прошёл правила площадки.": "The voice doesn’t comply with platform rules.",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "The service couldn’t process the voice. Check the status before retrying.",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "The consent has changed or is unavailable. Refresh the list and confirm the current version before retrying.",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "Upload rejected. Tap the button again to re-upload the sample.",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "Upload not confirmed yet. Tap the button again: we’ll check the previous upload first.",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "Choose an MP3, WAV, M4A, OGG or WebM audio file.",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "Couldn’t read the audio. Try again or upload a file.",
  "Пример звучания": "Sample audio",
  "Пример звучания пока недоступен": "Sample audio isn’t available yet",
  "Превью голоса": "Voice preview",
  "Прослушать пример": "Play sample",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "{0}% off your first Circle pack, valid for {1} {2} after you subscribe",
  "Вы уже пришли по ссылке партнёра": "You already joined via a partner link",
  "Промокод партнёра уже применён": "A partner code is already applied",
  "Тут откроется тема чата, куда бот прислал {0}": "This opens the chat topic where the bot sent your {0}",
  "можно вывести": "withdrawable",
  "только в STEOS": "STEOS only",
  "Не короче {0} знаков": "At least {0} characters",
  "Введите почту и пароль": "Enter email and password",
  "от {0} знаков": "{0}+ characters",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "After you log in, your Circle are shared between the bot and your STEOS account. Balance and withdrawals are also on {0}.",
  "Вход или новый аккаунт": "Log in or new account",
  "Придумайте пароль": "Create a password",
  "Ваш пароль": "Your password",
  "Принимаю {0} и {1} STEOS": "I accept the STEOS {0} and {1}",
  "согласие: условия": "terms",
  "согласие: политику конфиденциальности": "privacy policy",
  "Пришлём ссылку на почту": "We’ll email you a link",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "Open the link in the email and set a new password on {0}. Then log in here with the new password.",
  "Ссылка для нового пароля ушла на {0}": "We sent a password reset link to {0}",
  "Письма нет? Проверьте папку «Спам».": "No email? Check your Spam folder.",
  "Аккаунт создан и подключён": "Account created and connected",
  "Баланс бота теперь общий с аккаунтом STEOS.": "The bot balance is now shared with your STEOS account.",
  "Подтвердите почту по ссылке из письма.": "Confirm your email with the link we sent.",
  "Вывод работает здесь и на {0}.": "Withdrawals work here and on {0}.",
  "Открыть {0}": "Open {0}",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "We sent a link to {0}. Open it, then check the connection here.",
  "Проверить подключение": "Check connection",
  "Почти готово": "Almost done",
  "Почта ещё не подтверждена": "Email not confirmed yet",
  "Не удалось проверить. Попробуйте позже": "Couldn’t check. Try again later",
  "Озвучиваю тексты голосом героя": "Texts in a hero’s voice",
  "Любой голос из библиотеки или свой": "Any library voice or your own",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "I voice texts with hero voices in STEOS. Try it with my link, promo code {0}",
  "Пишу текст, персонаж говорит": "I type, the character speaks",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "I make round videos with characters in STEOS: I type the text and the character says it. Promo code {0}",
  "Свои фото в любом образе": "Your photos in any look",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "A photo shoot in any look from a couple of my photos, no studio. STEOS, promo code {0}",
  "Вы в кадре, монтаж и музыка сами": "You’re in the shot, editing and music are automatic",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "I star in reels with one tap in STEOS: story, editing and music are already in the template. Promo code {0}",
  "Персонаж оживает": "The character comes alive",
  "Говорит вашим текстом": "Says your text",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "The character says my text in their own voice. Try STEOS, promo code {0}",
  "Клон голоса за минуту": "A voice clone in a minute",
  "Запишите от 2 секунд, дальше говорит клон": "Record 2 seconds, then the clone does the talking",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "A clone of my voice in a minute with STEOS: now it voices everything for me. Promo code {0}",
  "Старому фото цвет и резкость": "Color and sharpness for old photos",
  "Восстановление за минуту": "Restored in a minute",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "I bring color and sharpness back to old photos with STEOS. Promo code {0}",
  "По ссылке или промокоду": "Via link or promo code",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "Get +{0} C and {1}% off your first pack in STEOS with my promo code {2}",
  "Кавер на любую песню": "A cover of any song",
  "Рок, джаз, lo-fi любым голосом": "Rock, jazz, lo-fi in any voice",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "A cover of any song in any voice with STEOS. Promo code {0}",
  "Мой аватар в любом образе": "My avatar in any look",
  "Свой аватар из 10 фото": "Your own avatar from 10 photos",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "My avatar in any look, made from 10 photos with STEOS. Promo code {0}",
  "Это я, только говорю вашим текстом": "It’s me, just speaking your text",
  "сторис: Мой голос": "My voice",
  "на баланс сразу": "to your balance right away",
  "на первый пакет Circle": "on your first Circle pack",
  "Сторис открыта в Telegram": "Story opened in Telegram",
  "Сторис готова": "Story ready",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "Now just publish it in the Telegram editor",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "The Telegram story editor will open here with this image and caption",
  "Подпись к сторис": "Story caption",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "Only Telegram Premium shows a link button on stories. Everyone sees the promo code on the image.",
  "Опубликовать в сторис": "Post to Stories",
  "Попробовать STEOS": "Try STEOS",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "Couldn’t prepare the story. Try again",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "Telegram posts stories: open the Mini App in Telegram",
  "Ссылка и промокод уже на картинке": "Link and promo code are already on the image",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "Try STEOS with my link. Promo code {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "Try STEOS with my link: +{0} C and {1}% off your first pack. Promo code {2}",
  "Ссылка": "Link",
  "Скопировать ссылку": "Copy link",
  "Друзьям {0} и {1} на первый пакет": "Friends get {0} and {1} on their first pack",
  "Промокод выделен: скопируйте вручную": "Promo code selected: copy it manually",
  "Ссылка выделена: скопируйте вручную": "Link selected: copy it manually",
  "Ссылка скопирована": "Link copied",
  "Ссылка выделена: скопируйте её вручную": "Link selected: copy it manually",
  "Ссылка выделена": "Link selected",
  "Вы пришли по приглашению": "You were invited",
  "{0} C на баланс": "{0} C to your balance",
  "Сгорят через {0} {1}": "Expire in {0} {1}",
  "{0} на первый пакет Circle": "{0} on your first Circle pack",
  "{0} {1} после оформления подписки": "{0} {1} after you subscribe",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "Circle packs can be bought with any subscription. The discount starts as soon as you subscribe.",
  "Выбрать тариф": "Choose a plan",
  "QR-код ссылки приглашения, промокод {0}": "Invite link QR code, promo code {0}",
  "Друг наведёт камеру и откроет бота": "A friend points the camera and opens the bot",
  "Цвет карточки": "Card color",
  "Скачать картинку": "Download image",
  "Аврора": "Aurora",
  "Закат": "Sunset",
  "Океан": "Ocean",
  "Графит": "Graphite",
  "Партнёры": "Partners",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "Found a bot where any character says your text in a video message. It also does photos, videos and voiceovers in any voice, all right in Telegram.",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "Sharing a find: STEOS, a Telegram bot where I make video messages with characters, voiceovers and photos. Write a text, pick a voice, and it’s ready in a minute.",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "I’m restoring our old family photos in STEOS: it brings back colour and sharpness in a minute. Send me the pictures you’d like refreshed, or try it yourself.",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "Ever wanted a video message in your favourite hero’s voice? In STEOS you write a text and a character from a game or show says it. It’s a Telegram bot.",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "I make product photos, feature cards and marketplace descriptions in STEOS in a couple of minutes, no studio or designer needed. Might come in handy for you too.",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "I voice my videos with my own voice clone, star in reels from ready-made templates and record covers. All in one STEOS bot in Telegram.",
  "По моей ссылке +{0} C на старт.": "Get +{0} C to start with my link.",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "With my link: +{0} C and −{1}% on your first pack.",
  "Попробуй сам.": "Give it a try.",
  "Попробуйте сами.": "Try it yourself.",
  "Актёры": "Actors",
  "Персонажи и актёры": "Characters and actors",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "No voices match “{q}”. Try another word or browse the collections",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "No voices here yet. Check the other tabs or collections",
  "Голос вернётся на экран создания": "The voice goes back to the creation screen",
  "После выбора пишите текст для озвучки в чат бота": "Then send the text to voice in the bot chat",
  "От Я до А": "Z to A",
  "Сортировка и фильтры": "Sort and filters",
  "Сбросить": "Reset",
  "Чаще всего выбирают": "Most chosen",
  "Сначала свежие": "Newest first",
  "Сначала давние": "Oldest first",
  "Сначала недорогие": "Cheapest first",
  "Сначала короткие ролики": "Shortest videos first",
  "По названию": "By name",
  "По названию, с конца алфавита": "By name, from the end of the alphabet",
  "Вертикальные ролики": "Vertical videos",
  "Картинки и посты": "Images and posts",
  "Горизонтальные ролики": "Horizontal videos",
  "Видеосообщения Telegram": "Telegram video messages",
  "Один человек в кадре": "One person in the frame",
  "Трое и больше": "Three or more",
  "С ребёнком": "With a child",
  "С питомцем": "With a pet",
  "Двое человек в кадре": "Two people in the frame",
  "О разделе": "About",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "Turns text into speech: a voice from the catalog or your clone, with intonation and speed settings.",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "A copy of your voice made from a recording: use it to voice any text.",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "AI studio: videos, photos, circles and other templates with you, your loved ones and characters.",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "Credits (C) in your account and top-ups. Credits are spent on voiceovers and studio orders.",
  "Задания и награды: выполняйте задания и получайте кредиты.": "Tasks and rewards: complete tasks and earn credits.",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "All your voiceovers and studio orders: listen, download or repeat.",
  "Ваш профиль и данные аккаунта.": "Your profile and account details.",
  "Настройки приложения: язык, валюта и уведомления.": "App settings: language, currency and notifications.",
  "Ответы на частые вопросы и связь с поддержкой.": "Answers to common questions and contact with support.",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "Partner program: invite friends and get a percentage of their top-ups.",
  "Озвучка больших текстов и сценариев по ролям.": "Voiceover of long texts and scripts by roles.",
  "Вы или один близкий": "You or one loved one",
  "Вы и близкий": "You and a loved one",
  "Товары и места": "Products and places",
  "Фото товара, блюда или места": "A photo of a product, dish or place",
  "В избранном": "In favorites",
  "Голоса и персонажи, которые вы отметили сердцем": "Voices and characters you marked with a heart",
  "Нажмите — выбрать голос": "Tap to choose a voice",
  "Удерживайте — карточка голоса": "Hold for the voice card",
  "Карточка голоса или персонажа": "Voice or character card",
  "Нажмите на голос, чтобы выбрать его": "Tap a voice to choose it",
  "Удерживайте, чтобы открыть карточку голоса": "Hold to open the voice card",
  "Удаление голоса": "Deleting the voice",
  "Подсказка": "Tip",
  "Пример звучания пока недоступен. Попробуйте позже.": "The sample is not available yet. Try again later.",
  "Языков: {0}": "Languages: {0}",
  "Ещё языков: {0}": "More languages: {0}",
  "Ход примера": "Sample progress",
  "Голос говорит на {0} языках": "The voice speaks {0} languages",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "All voices are multilingual and can voice text in any language the system supports.",
  "Голоса подборки": "Voices in the collection",
  "Удерживайте голос, чтобы открыть его": "Hold a voice to open it",
  "Назад к голосу": "Back to the voice",
  "Оригинал голоса говорил на {0} языке": "The original voice spoke {0}",
  "Происхождение: {0}. Подробнее": "Source: {0}. Details",
  "Новый": "New",
  "Официальный": "Official",
  "Актёр": "Actor",
  "Удерживайте, чтобы послушать": "Hold to listen",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "Hold a voice row or right-click it to open the voice card. A character opens with a regular tap.",
  "Подборка · Голосов: {0}": "Collection · Voices: {0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "Available voices will appear in the catalog. Here you can listen to a sample and choose a voice for the bot.",
  "Зажмите голос": "Press and hold a voice",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "Hold a voice row to open its card: listen and see its collections. A short tap chooses the voice.",
  "Нажмите на аватарку": "Tap the avatar",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "The round avatar in a row plays a voice sample. Tap again to stop. Tapping the row itself chooses the voice.",
  "Сохраняйте в избранное": "Save to favorites",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "Tap the heart on a voice or character card — they will gather in the “Favorites” collection, first in “Collections” and on “Recommended”. Tap again to remove.",
  "Запишите свой голос": "Record your voice",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 seconds of speech or a couple of files, and in two minutes your voice will appear in every tool with voiceover. Tap “Record” and read the text on the screen.",
  "Читать полностью": "Read more",
  "Голос STEOS": "STEOS voice",
  "Назад к персонажу": "Back to the character",
  "Назад к списку": "Back to the list",
  "Актёр STEOS": "STEOS actor",
  "Персонаж STEOS": "STEOS character",
  "Об актёре": "About the actor",
  "О персонаже": "About the character",
  "Голоса актёра": "Actor’s voices",
  "Голоса персонажа": "Character’s voices",
  "шапка: Мой голос": "My voice",
  "Пример голоса «{0}»": "“{0}” voice sample",
  "Ещё языки": "More languages",
  "Юзеры": "Users",
  "Лайки": "Likes",
  "Пол": "Gender",
  "В каталоге с": "In catalog since",
  "Автор": "Author",
  "Откуда": "From",
  "Характер": "Personality",
  "Голосов": "Voices",
  "Мужской": "Male",
  "Женский": "Female",
  "Детский": "Kids",
  "Не указан": "Not specified",
  "Голос персонажа": "Character voice",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "Choose a supported audio file up to {0} MB.",
  "пол: Детский": "Child",
  "Состав подборки": "Collection contents",
  "Закрыть выбор голоса": "Close voice selection",
  "Не удалось открыть запись для прослушивания.": "Couldn’t open the recording for playback.",
  "Использовать готовую запись": "Use a finished recording",
  "Подтвердите права на материалы, чтобы взять запись.": "Confirm your rights to the materials to use the recording.",
  "Работа из доната": "Work from a donation",
  "Модель синтеза": "Synthesis model",
  "Новая модель": "New model",
  "Прежняя модель": "Previous model",
  "Удерживайте — карточка голоса и модель синтеза": "Hold for the voice card and synthesis model",
  "Модель для озвучки в чате": "Model for voicing in the chat",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "New model: emotions and natural intonation, questions, many languages, voice clones",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "Previous model: only five languages, no emotions or question intonation, no clones",
  "Активная модель: STEOS Voice": "Active model: STEOS Voice",
  "Активная модель:": "Active model:",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "New model: 19 languages, natural sound with lively intonation — no metallic or robotic tone, high-quality voice cloning",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "Previous model: only 5 languages, no emotions or question intonation, no voice clones",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "On the STEOS Voice {0} model every voice is multilingual and will voice text in any of these languages.",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "On the STEOS Voice {0} model every voice is multilingual and will voice text in any of {1}.",
  "этих языков": "these languages",
  "Языки озвучки": "Voiceover languages",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "Any voice on the STEOS Voice {0} model will voice text in each of these languages",
  "Все голоса": "All voices",
  "Озвучка текста и переозвучка": "Text-to-speech and voice change",
  "Переозвучка записи": "Recording voice change",
  "Меняют голос в вашей записи": "Change the voice in your recording",
  "Выберите голос для переозвучки записи": "Choose a voice to change the voice in your recording",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "Voice selected — go back to the chat and tap \"Continue voice change\""
}
